(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[99885],{

/***/ 1678:
/***/ (function() {



/***/ }),

/***/ 24823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DB": function() { return /* binding */ Ye; },
/* harmony export */   "I7": function() { return /* binding */ Ee; },
/* harmony export */   "VR": function() { return /* binding */ de; },
/* harmony export */   "dB": function() { return /* binding */ Pe; },
/* harmony export */   "xp": function() { return /* binding */ Ne; }
/* harmony export */ });
/* unused harmony exports dayLabelFormat, getCurrentYearMonthAndDate, getDateMonthAndYear, getDays, getInitialMonths, getInputValue, getWeekdayLabels, isDateBlocked, isDateSelected, isEndDate, isFirstOrLastSelectedDate, isStartDate, monthLabelFormat, parseDate, weekdayLabelFormat */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var a = {
  lessThanXSeconds: {one: 'less than a second', other: 'less than {{count}} seconds'},
  xSeconds: {one: '1 second', other: '{{count}} seconds'},
  halfAMinute: 'half a minute',
  lessThanXMinutes: {one: 'less than a minute', other: 'less than {{count}} minutes'},
  xMinutes: {one: '1 minute', other: '{{count}} minutes'},
  aboutXHours: {one: 'about 1 hour', other: 'about {{count}} hours'},
  xHours: {one: '1 hour', other: '{{count}} hours'},
  xDays: {one: '1 day', other: '{{count}} days'},
  aboutXWeeks: {one: 'about 1 week', other: 'about {{count}} weeks'},
  xWeeks: {one: '1 week', other: '{{count}} weeks'},
  aboutXMonths: {one: 'about 1 month', other: 'about {{count}} months'},
  xMonths: {one: '1 month', other: '{{count}} months'},
  aboutXYears: {one: 'about 1 year', other: 'about {{count}} years'},
  xYears: {one: '1 year', other: '{{count}} years'},
  overXYears: {one: 'over 1 year', other: 'over {{count}} years'},
  almostXYears: {one: 'almost 1 year', other: 'almost {{count}} years'},
}
function i(t) {
  return function (e) {
    var n = e || {},
      r = n.width ? String(n.width) : t.defaultWidth
    return t.formats[r] || t.formats[t.defaultWidth]
  }
}
var o = {
    date: i({
      formats: {
        full: 'EEEE, MMMM do, y',
        long: 'MMMM do, y',
        medium: 'MMM d, y',
        short: 'MM/dd/yyyy',
      },
      defaultWidth: 'full',
    }),
    time: i({
      formats: {full: 'h:mm:ss a zzzz', long: 'h:mm:ss a z', medium: 'h:mm:ss a', short: 'h:mm a'},
      defaultWidth: 'full',
    }),
    dateTime: i({
      formats: {
        full: "{{date}} 'at' {{time}}",
        long: "{{date}} 'at' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}',
      },
      defaultWidth: 'full',
    }),
  },
  u = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P',
  }
function s(t) {
  return function (e, n) {
    var r,
      a = n || {}
    if ('formatting' === (a.context ? String(a.context) : 'standalone') && t.formattingValues) {
      var i = t.defaultFormattingWidth || t.defaultWidth,
        o = a.width ? String(a.width) : i
      r = t.formattingValues[o] || t.formattingValues[i]
    } else {
      var u = t.defaultWidth,
        s = a.width ? String(a.width) : t.defaultWidth
      r = t.values[s] || t.values[u]
    }
    return r[t.argumentCallback ? t.argumentCallback(e) : e]
  }
}
function c(t) {
  return function (e, n) {
    var r = String(e),
      a = n || {},
      i = a.width,
      o = (i && t.matchPatterns[i]) || t.matchPatterns[t.defaultMatchWidth],
      u = r.match(o)
    if (!u) return null
    var s,
      c = u[0],
      d = (i && t.parsePatterns[i]) || t.parsePatterns[t.defaultParseWidth]
    return (
      (s =
        '[object Array]' === Object.prototype.toString.call(d)
          ? (function (t, e) {
              for (var n = 0; n < t.length; n++) if (e(t[n])) return n
            })(d, function (t) {
              return t.test(c)
            })
          : (function (t, e) {
              for (var n in t) if (t.hasOwnProperty(n) && e(t[n])) return n
            })(d, function (t) {
              return t.test(c)
            })),
      (s = t.valueCallback ? t.valueCallback(s) : s),
      {value: (s = a.valueCallback ? a.valueCallback(s) : s), rest: r.slice(c.length)}
    )
  }
}
var d,
  l = {
    code: 'en-US',
    formatDistance: function (t, e, n) {
      var r
      return (
        (n = n || {}),
        (r =
          'string' == typeof a[t] ? a[t] : 1 === e ? a[t].one : a[t].other.replace('{{count}}', e)),
        n.addSuffix ? (n.comparison > 0 ? 'in ' + r : r + ' ago') : r
      )
    },
    formatLong: o,
    formatRelative: function (t, e, n, r) {
      return u[t]
    },
    localize: {
      ordinalNumber: function (t, e) {
        var n = Number(t),
          r = n % 100
        if (r > 20 || r < 10)
          switch (r % 10) {
            case 1:
              return n + 'st'
            case 2:
              return n + 'nd'
            case 3:
              return n + 'rd'
          }
        return n + 'th'
      },
      era: s({
        values: {
          narrow: ['B', 'A'],
          abbreviated: ['BC', 'AD'],
          wide: ['Before Christ', 'Anno Domini'],
        },
        defaultWidth: 'wide',
      }),
      quarter: s({
        values: {
          narrow: ['1', '2', '3', '4'],
          abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
          wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'],
        },
        defaultWidth: 'wide',
        argumentCallback: function (t) {
          return Number(t) - 1
        },
      }),
      month: s({
        values: {
          narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
          abbreviated: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ],
          wide: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
          ],
        },
        defaultWidth: 'wide',
      }),
      day: s({
        values: {
          narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
          short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
          abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        },
        defaultWidth: 'wide',
      }),
      dayPeriod: s({
        values: {
          narrow: {
            am: 'a',
            pm: 'p',
            midnight: 'mi',
            noon: 'n',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night',
          },
          abbreviated: {
            am: 'AM',
            pm: 'PM',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night',
          },
          wide: {
            am: 'a.m.',
            pm: 'p.m.',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night',
          },
        },
        defaultWidth: 'wide',
        formattingValues: {
          narrow: {
            am: 'a',
            pm: 'p',
            midnight: 'mi',
            noon: 'n',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night',
          },
          abbreviated: {
            am: 'AM',
            pm: 'PM',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night',
          },
          wide: {
            am: 'a.m.',
            pm: 'p.m.',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night',
          },
        },
        defaultFormattingWidth: 'wide',
      }),
    },
    match: {
      ordinalNumber:
        ((d = {
          matchPattern: /^(\d+)(th|st|nd|rd)?/i,
          parsePattern: /\d+/i,
          valueCallback: function (t) {
            return parseInt(t, 10)
          },
        }),
        function (t, e) {
          var n = String(t),
            r = e || {},
            a = n.match(d.matchPattern)
          if (!a) return null
          var i = a[0],
            o = n.match(d.parsePattern)
          if (!o) return null
          var u = d.valueCallback ? d.valueCallback(o[0]) : o[0]
          return {value: (u = r.valueCallback ? r.valueCallback(u) : u), rest: n.slice(i.length)}
        }),
      era: c({
        matchPatterns: {
          narrow: /^(b|a)/i,
          abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
          wide: /^(before christ|before common era|anno domini|common era)/i,
        },
        defaultMatchWidth: 'wide',
        parsePatterns: {any: [/^b/i, /^(a|c)/i]},
        defaultParseWidth: 'any',
      }),
      quarter: c({
        matchPatterns: {
          narrow: /^[1234]/i,
          abbreviated: /^q[1234]/i,
          wide: /^[1234](th|st|nd|rd)? quarter/i,
        },
        defaultMatchWidth: 'wide',
        parsePatterns: {any: [/1/i, /2/i, /3/i, /4/i]},
        defaultParseWidth: 'any',
        valueCallback: function (t) {
          return t + 1
        },
      }),
      month: c({
        matchPatterns: {
          narrow: /^[jfmasond]/i,
          abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
          wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i,
        },
        defaultMatchWidth: 'wide',
        parsePatterns: {
          narrow: [
            /^j/i,
            /^f/i,
            /^m/i,
            /^a/i,
            /^m/i,
            /^j/i,
            /^j/i,
            /^a/i,
            /^s/i,
            /^o/i,
            /^n/i,
            /^d/i,
          ],
          any: [
            /^ja/i,
            /^f/i,
            /^mar/i,
            /^ap/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^au/i,
            /^s/i,
            /^o/i,
            /^n/i,
            /^d/i,
          ],
        },
        defaultParseWidth: 'any',
      }),
      day: c({
        matchPatterns: {
          narrow: /^[smtwf]/i,
          short: /^(su|mo|tu|we|th|fr|sa)/i,
          abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
          wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i,
        },
        defaultMatchWidth: 'wide',
        parsePatterns: {
          narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
          any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i],
        },
        defaultParseWidth: 'any',
      }),
      dayPeriod: c({
        matchPatterns: {
          narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
          any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i,
        },
        defaultMatchWidth: 'any',
        parsePatterns: {
          any: {
            am: /^a/i,
            pm: /^p/i,
            midnight: /^mi/i,
            noon: /^no/i,
            morning: /morning/i,
            afternoon: /afternoon/i,
            evening: /evening/i,
            night: /night/i,
          },
        },
        defaultParseWidth: 'any',
      }),
    },
    options: {weekStartsOn: 0, firstWeekContainsDate: 1},
  }
function f(t) {
  if (null === t || !0 === t || !1 === t) return NaN
  var e = Number(t)
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e)
}
function h(t, e) {
  if (e.length < t)
    throw new TypeError(
      t + ' argument' + (t > 1 ? 's' : '') + ' required, but only ' + e.length + ' present',
    )
}
function m(t) {
  h(1, arguments)
  var e = Object.prototype.toString.call(t)
  return t instanceof Date || ('object' == typeof t && '[object Date]' === e)
    ? new Date(t.getTime())
    : 'number' == typeof t || '[object Number]' === e
    ? new Date(t)
    : (('string' != typeof t && '[object String]' !== e) ||
        'undefined' == typeof console ||
        (console.warn(
          "Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule",
        ),
        console.warn(new Error().stack)),
      new Date(NaN))
}
function w(t, e) {
  h(2, arguments)
  var n = m(t).getTime(),
    r = f(e)
  return new Date(n + r)
}
function g(t, e) {
  h(2, arguments)
  var n = f(e)
  return w(t, -n)
}
function v(t, e) {
  if (null == t)
    throw new TypeError('assign requires that input parameter not be null or undefined')
  for (var n in (e = e || {})) e.hasOwnProperty(n) && (t[n] = e[n])
  return t
}
function y(t, e) {
  switch (t) {
    case 'P':
      return e.date({width: 'short'})
    case 'PP':
      return e.date({width: 'medium'})
    case 'PPP':
      return e.date({width: 'long'})
    case 'PPPP':
    default:
      return e.date({width: 'full'})
  }
}
function b(t, e) {
  switch (t) {
    case 'p':
      return e.time({width: 'short'})
    case 'pp':
      return e.time({width: 'medium'})
    case 'ppp':
      return e.time({width: 'long'})
    case 'pppp':
    default:
      return e.time({width: 'full'})
  }
}
var D = {
  p: b,
  P: function (t, e) {
    var n,
      r = t.match(/(P+)(p+)?/),
      a = r[1],
      i = r[2]
    if (!i) return y(t, e)
    switch (a) {
      case 'P':
        n = e.dateTime({width: 'short'})
        break
      case 'PP':
        n = e.dateTime({width: 'medium'})
        break
      case 'PPP':
        n = e.dateTime({width: 'long'})
        break
      case 'PPPP':
      default:
        n = e.dateTime({width: 'full'})
    }
    return n.replace('{{date}}', y(a, e)).replace('{{time}}', b(i, e))
  },
}
function T(t) {
  return t.getTime() % 6e4
}
function p(t) {
  var e = new Date(t.getTime()),
    n = Math.ceil(e.getTimezoneOffset())
  return e.setSeconds(0, 0), 6e4 * n + (n > 0 ? (6e4 + T(e)) % 6e4 : T(e))
}
var k = ['D', 'DD'],
  x = ['YY', 'YYYY']
function C(t) {
  return -1 !== k.indexOf(t)
}
function M(t) {
  return -1 !== x.indexOf(t)
}
function U(t) {
  if ('YYYY' === t)
    throw new RangeError(
      'Use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr',
    )
  if ('YY' === t)
    throw new RangeError('Use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr')
  if ('D' === t)
    throw new RangeError(
      'Use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr',
    )
  if ('DD' === t)
    throw new RangeError(
      'Use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr',
    )
}
function S(t, e) {
  h(1, arguments)
  var n = e || {},
    r = n.locale,
    a = r && r.options && r.options.weekStartsOn,
    i = null == a ? 0 : f(a),
    o = null == n.weekStartsOn ? i : f(n.weekStartsOn)
  if (!(o >= 0 && o <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  var u = m(t),
    s = u.getUTCDay(),
    c = (s < o ? 7 : 0) + s - o
  return u.setUTCDate(u.getUTCDate() - c), u.setUTCHours(0, 0, 0, 0), u
}
function P(t, e) {
  h(1, arguments)
  var n = m(t, e),
    r = n.getUTCFullYear(),
    a = e || {},
    i = a.locale,
    o = i && i.options && i.options.firstWeekContainsDate,
    u = null == o ? 1 : f(o),
    s = null == a.firstWeekContainsDate ? u : f(a.firstWeekContainsDate)
  if (!(s >= 1 && s <= 7))
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively')
  var c = new Date(0)
  c.setUTCFullYear(r + 1, 0, s), c.setUTCHours(0, 0, 0, 0)
  var d = S(c, e),
    l = new Date(0)
  l.setUTCFullYear(r, 0, s), l.setUTCHours(0, 0, 0, 0)
  var w = S(l, e)
  return n.getTime() >= d.getTime() ? r + 1 : n.getTime() >= w.getTime() ? r : r - 1
}
function E(t, e, n) {
  h(2, arguments)
  var r = n || {},
    a = r.locale,
    i = a && a.options && a.options.weekStartsOn,
    o = null == i ? 0 : f(i),
    u = null == r.weekStartsOn ? o : f(r.weekStartsOn)
  if (!(u >= 0 && u <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  var s = m(t),
    c = f(e),
    d = s.getUTCDay(),
    l = c % 7,
    w = (l + 7) % 7,
    g = (w < u ? 7 : 0) + c - d
  return s.setUTCDate(s.getUTCDate() + g), s
}
function Y(t) {
  h(1, arguments)
  var e = 1,
    n = m(t),
    r = n.getUTCDay(),
    a = (r < e ? 7 : 0) + r - e
  return n.setUTCDate(n.getUTCDate() - a), n.setUTCHours(0, 0, 0, 0), n
}
function N(t) {
  h(1, arguments)
  var e = m(t),
    n = e.getUTCFullYear(),
    r = new Date(0)
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0)
  var a = Y(r),
    i = new Date(0)
  i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0)
  var o = Y(i)
  return e.getTime() >= a.getTime() ? n + 1 : e.getTime() >= o.getTime() ? n : n - 1
}
function q(t) {
  h(1, arguments)
  var e = N(t),
    n = new Date(0)
  n.setUTCFullYear(e, 0, 4), n.setUTCHours(0, 0, 0, 0)
  var r = Y(n)
  return r
}
function B(t) {
  h(1, arguments)
  var e = m(t),
    n = Y(e).getTime() - q(e).getTime()
  return Math.round(n / 6048e5) + 1
}
function O(t, e) {
  h(1, arguments)
  var n = e || {},
    r = n.locale,
    a = r && r.options && r.options.firstWeekContainsDate,
    i = null == a ? 1 : f(a),
    o = null == n.firstWeekContainsDate ? i : f(n.firstWeekContainsDate),
    u = P(t, e),
    s = new Date(0)
  s.setUTCFullYear(u, 0, o), s.setUTCHours(0, 0, 0, 0)
  var c = S(s, e)
  return c
}
function H(t, e) {
  h(1, arguments)
  var n = m(t),
    r = S(n, e).getTime() - O(n, e).getTime()
  return Math.round(r / 6048e5) + 1
}
var L = /^(1[0-2]|0?\d)/,
  W = /^(3[0-1]|[0-2]?\d)/,
  F = /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  Q = /^(5[0-3]|[0-4]?\d)/,
  R = /^(2[0-3]|[0-1]?\d)/,
  I = /^(2[0-4]|[0-1]?\d)/,
  X = /^(1[0-1]|0?\d)/,
  G = /^(1[0-2]|0?\d)/,
  A = /^[0-5]?\d/,
  z = /^[0-5]?\d/,
  j = /^\d/,
  K = /^\d{1,2}/,
  J = /^\d{1,3}/,
  Z = /^\d{1,4}/,
  _ = /^-?\d+/,
  $ = /^-?\d/,
  V = /^-?\d{1,2}/,
  tt = /^-?\d{1,3}/,
  et = /^-?\d{1,4}/,
  nt = /^([+-])(\d{2})(\d{2})?|Z/,
  rt = /^([+-])(\d{2})(\d{2})|Z/,
  at = /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  it = /^([+-])(\d{2}):(\d{2})|Z/,
  ot = /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
function ut(t, e, n) {
  var r = e.match(t)
  if (!r) return null
  var a = parseInt(r[0], 10)
  return {value: n ? n(a) : a, rest: e.slice(r[0].length)}
}
function st(t, e) {
  var n = e.match(t)
  return n
    ? 'Z' === n[0]
      ? {value: 0, rest: e.slice(1)}
      : {
          value:
            ('+' === n[1] ? 1 : -1) *
            (36e5 * (n[2] ? parseInt(n[2], 10) : 0) +
              6e4 * (n[3] ? parseInt(n[3], 10) : 0) +
              1e3 * (n[5] ? parseInt(n[5], 10) : 0)),
          rest: e.slice(n[0].length),
        }
    : null
}
function ct(t, e) {
  return ut(_, t, e)
}
function dt(t, e, n) {
  switch (t) {
    case 1:
      return ut(j, e, n)
    case 2:
      return ut(K, e, n)
    case 3:
      return ut(J, e, n)
    case 4:
      return ut(Z, e, n)
    default:
      return ut(new RegExp('^\\d{1,' + t + '}'), e, n)
  }
}
function lt(t, e, n) {
  switch (t) {
    case 1:
      return ut($, e, n)
    case 2:
      return ut(V, e, n)
    case 3:
      return ut(tt, e, n)
    case 4:
      return ut(et, e, n)
    default:
      return ut(new RegExp('^-?\\d{1,' + t + '}'), e, n)
  }
}
function ft(t) {
  switch (t) {
    case 'morning':
      return 4
    case 'evening':
      return 17
    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12
    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0
  }
}
function ht(t, e) {
  var n,
    r = e > 0,
    a = r ? e : 1 - e
  if (a <= 50) n = t || 100
  else {
    var i = a + 50
    n = t + 100 * Math.floor(i / 100) - (t >= i % 100 ? 100 : 0)
  }
  return r ? n : 1 - n
}
var mt = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  wt = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
function gt(t) {
  return t % 400 == 0 || (t % 4 == 0 && t % 100 != 0)
}
var vt = {
    G: {
      priority: 140,
      parse: function (t, e, n, r) {
        switch (e) {
          case 'G':
          case 'GG':
          case 'GGG':
            return n.era(t, {width: 'abbreviated'}) || n.era(t, {width: 'narrow'})
          case 'GGGGG':
            return n.era(t, {width: 'narrow'})
          case 'GGGG':
          default:
            return (
              n.era(t, {width: 'wide'}) ||
              n.era(t, {width: 'abbreviated'}) ||
              n.era(t, {width: 'narrow'})
            )
        }
      },
      set: function (t, e, n, r) {
        return (e.era = n), t.setUTCFullYear(n, 0, 1), t.setUTCHours(0, 0, 0, 0), t
      },
      incompatibleTokens: ['R', 'u', 't', 'T'],
    },
    y: {
      priority: 130,
      parse: function (t, e, n, r) {
        var a = function (t) {
          return {year: t, isTwoDigitYear: 'yy' === e}
        }
        switch (e) {
          case 'y':
            return dt(4, t, a)
          case 'yo':
            return n.ordinalNumber(t, {unit: 'year', valueCallback: a})
          default:
            return dt(e.length, t, a)
        }
      },
      validate: function (t, e, n) {
        return e.isTwoDigitYear || e.year > 0
      },
      set: function (t, e, n, r) {
        var a = t.getUTCFullYear()
        if (n.isTwoDigitYear) {
          var i = ht(n.year, a)
          return t.setUTCFullYear(i, 0, 1), t.setUTCHours(0, 0, 0, 0), t
        }
        var o = 'era' in e && 1 !== e.era ? 1 - n.year : n.year
        return t.setUTCFullYear(o, 0, 1), t.setUTCHours(0, 0, 0, 0), t
      },
      incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T'],
    },
    Y: {
      priority: 130,
      parse: function (t, e, n, r) {
        var a = function (t) {
          return {year: t, isTwoDigitYear: 'YY' === e}
        }
        switch (e) {
          case 'Y':
            return dt(4, t, a)
          case 'Yo':
            return n.ordinalNumber(t, {unit: 'year', valueCallback: a})
          default:
            return dt(e.length, t, a)
        }
      },
      validate: function (t, e, n) {
        return e.isTwoDigitYear || e.year > 0
      },
      set: function (t, e, n, r) {
        var a = P(t, r)
        if (n.isTwoDigitYear) {
          var i = ht(n.year, a)
          return t.setUTCFullYear(i, 0, r.firstWeekContainsDate), t.setUTCHours(0, 0, 0, 0), S(t, r)
        }
        var o = 'era' in e && 1 !== e.era ? 1 - n.year : n.year
        return t.setUTCFullYear(o, 0, r.firstWeekContainsDate), t.setUTCHours(0, 0, 0, 0), S(t, r)
      },
      incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T'],
    },
    R: {
      priority: 130,
      parse: function (t, e, n, r) {
        return lt('R' === e ? 4 : e.length, t)
      },
      set: function (t, e, n, r) {
        var a = new Date(0)
        return a.setUTCFullYear(n, 0, 4), a.setUTCHours(0, 0, 0, 0), Y(a)
      },
      incompatibleTokens: [
        'G',
        'y',
        'Y',
        'u',
        'Q',
        'q',
        'M',
        'L',
        'w',
        'd',
        'D',
        'e',
        'c',
        't',
        'T',
      ],
    },
    u: {
      priority: 130,
      parse: function (t, e, n, r) {
        return lt('u' === e ? 4 : e.length, t)
      },
      set: function (t, e, n, r) {
        return t.setUTCFullYear(n, 0, 1), t.setUTCHours(0, 0, 0, 0), t
      },
      incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T'],
    },
    Q: {
      priority: 120,
      parse: function (t, e, n, r) {
        switch (e) {
          case 'Q':
          case 'QQ':
            return dt(e.length, t)
          case 'Qo':
            return n.ordinalNumber(t, {unit: 'quarter'})
          case 'QQQ':
            return (
              n.quarter(t, {width: 'abbreviated', context: 'formatting'}) ||
              n.quarter(t, {width: 'narrow', context: 'formatting'})
            )
          case 'QQQQQ':
            return n.quarter(t, {width: 'narrow', context: 'formatting'})
          case 'QQQQ':
          default:
            return (
              n.quarter(t, {width: 'wide', context: 'formatting'}) ||
              n.quarter(t, {width: 'abbreviated', context: 'formatting'}) ||
              n.quarter(t, {width: 'narrow', context: 'formatting'})
            )
        }
      },
      validate: function (t, e, n) {
        return e >= 1 && e <= 4
      },
      set: function (t, e, n, r) {
        return t.setUTCMonth(3 * (n - 1), 1), t.setUTCHours(0, 0, 0, 0), t
      },
      incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T'],
    },
    q: {
      priority: 120,
      parse: function (t, e, n, r) {
        switch (e) {
          case 'q':
          case 'qq':
            return dt(e.length, t)
          case 'qo':
            return n.ordinalNumber(t, {unit: 'quarter'})
          case 'qqq':
            return (
              n.quarter(t, {width: 'abbreviated', context: 'standalone'}) ||
              n.quarter(t, {width: 'narrow', context: 'standalone'})
            )
          case 'qqqqq':
            return n.quarter(t, {width: 'narrow', context: 'standalone'})
          case 'qqqq':
          default:
            return (
              n.quarter(t, {width: 'wide', context: 'standalone'}) ||
              n.quarter(t, {width: 'abbreviated', context: 'standalone'}) ||
              n.quarter(t, {width: 'narrow', context: 'standalone'})
            )
        }
      },
      validate: function (t, e, n) {
        return e >= 1 && e <= 4
      },
      set: function (t, e, n, r) {
        return t.setUTCMonth(3 * (n - 1), 1), t.setUTCHours(0, 0, 0, 0), t
      },
      incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T'],
    },
    M: {
      priority: 110,
      parse: function (t, e, n, r) {
        var a = function (t) {
          return t - 1
        }
        switch (e) {
          case 'M':
            return ut(L, t, a)
          case 'MM':
            return dt(2, t, a)
          case 'Mo':
            return n.ordinalNumber(t, {unit: 'month', valueCallback: a})
          case 'MMM':
            return (
              n.month(t, {width: 'abbreviated', context: 'formatting'}) ||
              n.month(t, {width: 'narrow', context: 'formatting'})
            )
          case 'MMMMM':
            return n.month(t, {width: 'narrow', context: 'formatting'})
          case 'MMMM':
          default:
            return (
              n.month(t, {width: 'wide', context: 'formatting'}) ||
              n.month(t, {width: 'abbreviated', context: 'formatting'}) ||
              n.month(t, {width: 'narrow', context: 'formatting'})
            )
        }
      },
      validate: function (t, e, n) {
        return e >= 0 && e <= 11
      },
      set: function (t, e, n, r) {
        return t.setUTCMonth(n, 1), t.setUTCHours(0, 0, 0, 0), t
      },
      incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T'],
    },
    L: {
      priority: 110,
      parse: function (t, e, n, r) {
        var a = function (t) {
          return t - 1
        }
        switch (e) {
          case 'L':
            return ut(L, t, a)
          case 'LL':
            return dt(2, t, a)
          case 'Lo':
            return n.ordinalNumber(t, {unit: 'month', valueCallback: a})
          case 'LLL':
            return (
              n.month(t, {width: 'abbreviated', context: 'standalone'}) ||
              n.month(t, {width: 'narrow', context: 'standalone'})
            )
          case 'LLLLL':
            return n.month(t, {width: 'narrow', context: 'standalone'})
          case 'LLLL':
          default:
            return (
              n.month(t, {width: 'wide', context: 'standalone'}) ||
              n.month(t, {width: 'abbreviated', context: 'standalone'}) ||
              n.month(t, {width: 'narrow', context: 'standalone'})
            )
        }
      },
      validate: function (t, e, n) {
        return e >= 0 && e <= 11
      },
      set: function (t, e, n, r) {
        return t.setUTCMonth(n, 1), t.setUTCHours(0, 0, 0, 0), t
      },
      incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T'],
    },
    w: {
      priority: 100,
      parse: function (t, e, n, r) {
        switch (e) {
          case 'w':
            return ut(Q, t)
          case 'wo':
            return n.ordinalNumber(t, {unit: 'week'})
          default:
            return dt(e.length, t)
        }
      },
      validate: function (t, e, n) {
        return e >= 1 && e <= 53
      },
      set: function (t, e, n, r) {
        return S(
          (function (t, e, n) {
            h(2, arguments)
            var r = m(t),
              a = f(e),
              i = H(r, n) - a
            return r.setUTCDate(r.getUTCDate() - 7 * i), r
          })(t, n, r),
          r,
        )
      },
      incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T'],
    },
    I: {
      priority: 100,
      parse: function (t, e, n, r) {
        switch (e) {
          case 'I':
            return ut(Q, t)
          case 'Io':
            return n.ordinalNumber(t, {unit: 'week'})
          default:
            return dt(e.length, t)
        }
      },
      validate: function (t, e, n) {
        return e >= 1 && e <= 53
      },
      set: function (t, e, n, r) {
        return Y(
          (function (t, e) {
            h(2, arguments)
            var n = m(t),
              r = f(e),
              a = B(n) - r
            return n.setUTCDate(n.getUTCDate() - 7 * a), n
          })(t, n, r),
          r,
        )
      },
      incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T'],
    },
    d: {
      priority: 90,
      parse: function (t, e, n, r) {
        switch (e) {
          case 'd':
            return ut(W, t)
          case 'do':
            return n.ordinalNumber(t, {unit: 'date'})
          default:
            return dt(e.length, t)
        }
      },
      validate: function (t, e, n) {
        var r = gt(t.getUTCFullYear()),
          a = t.getUTCMonth()
        return r ? e >= 1 && e <= wt[a] : e >= 1 && e <= mt[a]
      },
      set: function (t, e, n, r) {
        return t.setUTCDate(n), t.setUTCHours(0, 0, 0, 0), t
      },
      incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T'],
    },
    D: {
      priority: 90,
      parse: function (t, e, n, r) {
        switch (e) {
          case 'D':
          case 'DD':
            return ut(F, t)
          case 'Do':
            return n.ordinalNumber(t, {unit: 'date'})
          default:
            return dt(e.length, t)
        }
      },
      validate: function (t, e, n) {
        return gt(t.getUTCFullYear()) ? e >= 1 && e <= 366 : e >= 1 && e <= 365
      },
      set: function (t, e, n, r) {
        return t.setUTCMonth(0, n), t.setUTCHours(0, 0, 0, 0), t
      },
      incompatibleTokens: [
        'Y',
        'R',
        'q',
        'Q',
        'M',
        'L',
        'w',
        'I',
        'd',
        'E',
        'i',
        'e',
        'c',
        't',
        'T',
      ],
    },
    E: {
      priority: 90,
      parse: function (t, e, n, r) {
        switch (e) {
          case 'E':
          case 'EE':
          case 'EEE':
            return (
              n.day(t, {width: 'abbreviated', context: 'formatting'}) ||
              n.day(t, {width: 'short', context: 'formatting'}) ||
              n.day(t, {width: 'narrow', context: 'formatting'})
            )
          case 'EEEEE':
            return n.day(t, {width: 'narrow', context: 'formatting'})
          case 'EEEEEE':
            return (
              n.day(t, {width: 'short', context: 'formatting'}) ||
              n.day(t, {width: 'narrow', context: 'formatting'})
            )
          case 'EEEE':
          default:
            return (
              n.day(t, {width: 'wide', context: 'formatting'}) ||
              n.day(t, {width: 'abbreviated', context: 'formatting'}) ||
              n.day(t, {width: 'short', context: 'formatting'}) ||
              n.day(t, {width: 'narrow', context: 'formatting'})
            )
        }
      },
      validate: function (t, e, n) {
        return e >= 0 && e <= 6
      },
      set: function (t, e, n, r) {
        return (t = E(t, n, r)).setUTCHours(0, 0, 0, 0), t
      },
      incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T'],
    },
    e: {
      priority: 90,
      parse: function (t, e, n, r) {
        var a = function (t) {
          var e = 7 * Math.floor((t - 1) / 7)
          return ((t + r.weekStartsOn + 6) % 7) + e
        }
        switch (e) {
          case 'e':
          case 'ee':
            return dt(e.length, t, a)
          case 'eo':
            return n.ordinalNumber(t, {unit: 'day', valueCallback: a})
          case 'eee':
            return (
              n.day(t, {width: 'abbreviated', context: 'formatting'}) ||
              n.day(t, {width: 'short', context: 'formatting'}) ||
              n.day(t, {width: 'narrow', context: 'formatting'})
            )
          case 'eeeee':
            return n.day(t, {width: 'narrow', context: 'formatting'})
          case 'eeeeee':
            return (
              n.day(t, {width: 'short', context: 'formatting'}) ||
              n.day(t, {width: 'narrow', context: 'formatting'})
            )
          case 'eeee':
          default:
            return (
              n.day(t, {width: 'wide', context: 'formatting'}) ||
              n.day(t, {width: 'abbreviated', context: 'formatting'}) ||
              n.day(t, {width: 'short', context: 'formatting'}) ||
              n.day(t, {width: 'narrow', context: 'formatting'})
            )
        }
      },
      validate: function (t, e, n) {
        return e >= 0 && e <= 6
      },
      set: function (t, e, n, r) {
        return (t = E(t, n, r)).setUTCHours(0, 0, 0, 0), t
      },
      incompatibleTokens: [
        'y',
        'R',
        'u',
        'q',
        'Q',
        'M',
        'L',
        'I',
        'd',
        'D',
        'E',
        'i',
        'c',
        't',
        'T',
      ],
    },
    c: {
      priority: 90,
      parse: function (t, e, n, r) {
        var a = function (t) {
          var e = 7 * Math.floor((t - 1) / 7)
          return ((t + r.weekStartsOn + 6) % 7) + e
        }
        switch (e) {
          case 'c':
          case 'cc':
            return dt(e.length, t, a)
          case 'co':
            return n.ordinalNumber(t, {unit: 'day', valueCallback: a})
          case 'ccc':
            return (
              n.day(t, {width: 'abbreviated', context: 'standalone'}) ||
              n.day(t, {width: 'short', context: 'standalone'}) ||
              n.day(t, {width: 'narrow', context: 'standalone'})
            )
          case 'ccccc':
            return n.day(t, {width: 'narrow', context: 'standalone'})
          case 'cccccc':
            return (
              n.day(t, {width: 'short', context: 'standalone'}) ||
              n.day(t, {width: 'narrow', context: 'standalone'})
            )
          case 'cccc':
          default:
            return (
              n.day(t, {width: 'wide', context: 'standalone'}) ||
              n.day(t, {width: 'abbreviated', context: 'standalone'}) ||
              n.day(t, {width: 'short', context: 'standalone'}) ||
              n.day(t, {width: 'narrow', context: 'standalone'})
            )
        }
      },
      validate: function (t, e, n) {
        return e >= 0 && e <= 6
      },
      set: function (t, e, n, r) {
        return (t = E(t, n, r)).setUTCHours(0, 0, 0, 0), t
      },
      incompatibleTokens: [
        'y',
        'R',
        'u',
        'q',
        'Q',
        'M',
        'L',
        'I',
        'd',
        'D',
        'E',
        'i',
        'e',
        't',
        'T',
      ],
    },
    i: {
      priority: 90,
      parse: function (t, e, n, r) {
        var a = function (t) {
          return 0 === t ? 7 : t
        }
        switch (e) {
          case 'i':
          case 'ii':
            return dt(e.length, t)
          case 'io':
            return n.ordinalNumber(t, {unit: 'day'})
          case 'iii':
            return (
              n.day(t, {width: 'abbreviated', context: 'formatting', valueCallback: a}) ||
              n.day(t, {width: 'short', context: 'formatting', valueCallback: a}) ||
              n.day(t, {width: 'narrow', context: 'formatting', valueCallback: a})
            )
          case 'iiiii':
            return n.day(t, {width: 'narrow', context: 'formatting', valueCallback: a})
          case 'iiiiii':
            return (
              n.day(t, {width: 'short', context: 'formatting', valueCallback: a}) ||
              n.day(t, {width: 'narrow', context: 'formatting', valueCallback: a})
            )
          case 'iiii':
          default:
            return (
              n.day(t, {width: 'wide', context: 'formatting', valueCallback: a}) ||
              n.day(t, {width: 'abbreviated', context: 'formatting', valueCallback: a}) ||
              n.day(t, {width: 'short', context: 'formatting', valueCallback: a}) ||
              n.day(t, {width: 'narrow', context: 'formatting', valueCallback: a})
            )
        }
      },
      validate: function (t, e, n) {
        return e >= 1 && e <= 7
      },
      set: function (t, e, n, r) {
        return (
          (t = (function (t, e) {
            h(2, arguments)
            var n = f(e)
            n % 7 == 0 && (n -= 7)
            var r = 1,
              a = m(t),
              i = a.getUTCDay(),
              o = n % 7,
              u = (o + 7) % 7,
              s = (u < r ? 7 : 0) + n - i
            return a.setUTCDate(a.getUTCDate() + s), a
          })(t, n, r)).setUTCHours(0, 0, 0, 0),
          t
        )
      },
      incompatibleTokens: [
        'y',
        'Y',
        'u',
        'q',
        'Q',
        'M',
        'L',
        'w',
        'd',
        'D',
        'E',
        'e',
        'c',
        't',
        'T',
      ],
    },
    a: {
      priority: 80,
      parse: function (t, e, n, r) {
        switch (e) {
          case 'a':
          case 'aa':
          case 'aaa':
            return (
              n.dayPeriod(t, {width: 'abbreviated', context: 'formatting'}) ||
              n.dayPeriod(t, {width: 'narrow', context: 'formatting'})
            )
          case 'aaaaa':
            return n.dayPeriod(t, {width: 'narrow', context: 'formatting'})
          case 'aaaa':
          default:
            return (
              n.dayPeriod(t, {width: 'wide', context: 'formatting'}) ||
              n.dayPeriod(t, {width: 'abbreviated', context: 'formatting'}) ||
              n.dayPeriod(t, {width: 'narrow', context: 'formatting'})
            )
        }
      },
      set: function (t, e, n, r) {
        return t.setUTCHours(ft(n), 0, 0, 0), t
      },
      incompatibleTokens: ['b', 'B', 'H', 'K', 'k', 't', 'T'],
    },
    b: {
      priority: 80,
      parse: function (t, e, n, r) {
        switch (e) {
          case 'b':
          case 'bb':
          case 'bbb':
            return (
              n.dayPeriod(t, {width: 'abbreviated', context: 'formatting'}) ||
              n.dayPeriod(t, {width: 'narrow', context: 'formatting'})
            )
          case 'bbbbb':
            return n.dayPeriod(t, {width: 'narrow', context: 'formatting'})
          case 'bbbb':
          default:
            return (
              n.dayPeriod(t, {width: 'wide', context: 'formatting'}) ||
              n.dayPeriod(t, {width: 'abbreviated', context: 'formatting'}) ||
              n.dayPeriod(t, {width: 'narrow', context: 'formatting'})
            )
        }
      },
      set: function (t, e, n, r) {
        return t.setUTCHours(ft(n), 0, 0, 0), t
      },
      incompatibleTokens: ['a', 'B', 'H', 'K', 'k', 't', 'T'],
    },
    B: {
      priority: 80,
      parse: function (t, e, n, r) {
        switch (e) {
          case 'B':
          case 'BB':
          case 'BBB':
            return (
              n.dayPeriod(t, {width: 'abbreviated', context: 'formatting'}) ||
              n.dayPeriod(t, {width: 'narrow', context: 'formatting'})
            )
          case 'BBBBB':
            return n.dayPeriod(t, {width: 'narrow', context: 'formatting'})
          case 'BBBB':
          default:
            return (
              n.dayPeriod(t, {width: 'wide', context: 'formatting'}) ||
              n.dayPeriod(t, {width: 'abbreviated', context: 'formatting'}) ||
              n.dayPeriod(t, {width: 'narrow', context: 'formatting'})
            )
        }
      },
      set: function (t, e, n, r) {
        return t.setUTCHours(ft(n), 0, 0, 0), t
      },
      incompatibleTokens: ['a', 'b', 't', 'T'],
    },
    h: {
      priority: 70,
      parse: function (t, e, n, r) {
        switch (e) {
          case 'h':
            return ut(G, t)
          case 'ho':
            return n.ordinalNumber(t, {unit: 'hour'})
          default:
            return dt(e.length, t)
        }
      },
      validate: function (t, e, n) {
        return e >= 1 && e <= 12
      },
      set: function (t, e, n, r) {
        var a = t.getUTCHours() >= 12
        return (
          a && n < 12
            ? t.setUTCHours(n + 12, 0, 0, 0)
            : a || 12 !== n
            ? t.setUTCHours(n, 0, 0, 0)
            : t.setUTCHours(0, 0, 0, 0),
          t
        )
      },
      incompatibleTokens: ['H', 'K', 'k', 't', 'T'],
    },
    H: {
      priority: 70,
      parse: function (t, e, n, r) {
        switch (e) {
          case 'H':
            return ut(R, t)
          case 'Ho':
            return n.ordinalNumber(t, {unit: 'hour'})
          default:
            return dt(e.length, t)
        }
      },
      validate: function (t, e, n) {
        return e >= 0 && e <= 23
      },
      set: function (t, e, n, r) {
        return t.setUTCHours(n, 0, 0, 0), t
      },
      incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T'],
    },
    K: {
      priority: 70,
      parse: function (t, e, n, r) {
        switch (e) {
          case 'K':
            return ut(X, t)
          case 'Ko':
            return n.ordinalNumber(t, {unit: 'hour'})
          default:
            return dt(e.length, t)
        }
      },
      validate: function (t, e, n) {
        return e >= 0 && e <= 11
      },
      set: function (t, e, n, r) {
        return (
          t.getUTCHours() >= 12 && n < 12
            ? t.setUTCHours(n + 12, 0, 0, 0)
            : t.setUTCHours(n, 0, 0, 0),
          t
        )
      },
      incompatibleTokens: ['a', 'b', 'h', 'H', 'k', 't', 'T'],
    },
    k: {
      priority: 70,
      parse: function (t, e, n, r) {
        switch (e) {
          case 'k':
            return ut(I, t)
          case 'ko':
            return n.ordinalNumber(t, {unit: 'hour'})
          default:
            return dt(e.length, t)
        }
      },
      validate: function (t, e, n) {
        return e >= 1 && e <= 24
      },
      set: function (t, e, n, r) {
        var a = n <= 24 ? n % 24 : n
        return t.setUTCHours(a, 0, 0, 0), t
      },
      incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T'],
    },
    m: {
      priority: 60,
      parse: function (t, e, n, r) {
        switch (e) {
          case 'm':
            return ut(A, t)
          case 'mo':
            return n.ordinalNumber(t, {unit: 'minute'})
          default:
            return dt(e.length, t)
        }
      },
      validate: function (t, e, n) {
        return e >= 0 && e <= 59
      },
      set: function (t, e, n, r) {
        return t.setUTCMinutes(n, 0, 0), t
      },
      incompatibleTokens: ['t', 'T'],
    },
    s: {
      priority: 50,
      parse: function (t, e, n, r) {
        switch (e) {
          case 's':
            return ut(z, t)
          case 'so':
            return n.ordinalNumber(t, {unit: 'second'})
          default:
            return dt(e.length, t)
        }
      },
      validate: function (t, e, n) {
        return e >= 0 && e <= 59
      },
      set: function (t, e, n, r) {
        return t.setUTCSeconds(n, 0), t
      },
      incompatibleTokens: ['t', 'T'],
    },
    S: {
      priority: 30,
      parse: function (t, e, n, r) {
        return dt(e.length, t, function (t) {
          return Math.floor(t * Math.pow(10, 3 - e.length))
        })
      },
      set: function (t, e, n, r) {
        return t.setUTCMilliseconds(n), t
      },
      incompatibleTokens: ['t', 'T'],
    },
    X: {
      priority: 10,
      parse: function (t, e, n, r) {
        switch (e) {
          case 'X':
            return st(nt, t)
          case 'XX':
            return st(rt, t)
          case 'XXXX':
            return st(at, t)
          case 'XXXXX':
            return st(ot, t)
          case 'XXX':
          default:
            return st(it, t)
        }
      },
      set: function (t, e, n, r) {
        return e.timestampIsSet ? t : new Date(t.getTime() - n)
      },
      incompatibleTokens: ['t', 'T', 'x'],
    },
    x: {
      priority: 10,
      parse: function (t, e, n, r) {
        switch (e) {
          case 'x':
            return st(nt, t)
          case 'xx':
            return st(rt, t)
          case 'xxxx':
            return st(at, t)
          case 'xxxxx':
            return st(ot, t)
          case 'xxx':
          default:
            return st(it, t)
        }
      },
      set: function (t, e, n, r) {
        return e.timestampIsSet ? t : new Date(t.getTime() - n)
      },
      incompatibleTokens: ['t', 'T', 'X'],
    },
    t: {
      priority: 40,
      parse: function (t, e, n, r) {
        return ct(t)
      },
      set: function (t, e, n, r) {
        return [new Date(1e3 * n), {timestampIsSet: !0}]
      },
      incompatibleTokens: '*',
    },
    T: {
      priority: 20,
      parse: function (t, e, n, r) {
        return ct(t)
      },
      set: function (t, e, n, r) {
        return [new Date(n), {timestampIsSet: !0}]
      },
      incompatibleTokens: '*',
    },
  },
  yt = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
  bt = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
  Dt = /^'([^]*?)'?$/,
  Tt = /''/g,
  pt = /\S/,
  kt = /[a-zA-Z]/
function xt(t, e, n, r) {
  h(3, arguments)
  var a = String(t),
    i = String(e),
    o = r || {},
    u = o.locale || l
  if (!u.match) throw new RangeError('locale must contain match property')
  var s = u.options && u.options.firstWeekContainsDate,
    c = null == s ? 1 : f(s),
    d = null == o.firstWeekContainsDate ? c : f(o.firstWeekContainsDate)
  if (!(d >= 1 && d <= 7))
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively')
  var w = u.options && u.options.weekStartsOn,
    y = null == w ? 0 : f(w),
    b = null == o.weekStartsOn ? y : f(o.weekStartsOn)
  if (!(b >= 0 && b <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  if ('' === i) return '' === a ? m(n) : new Date(NaN)
  var T,
    k = {firstWeekContainsDate: d, weekStartsOn: b, locale: u},
    x = [{priority: 10, set: Ct, index: 0}],
    S = i
      .match(bt)
      .map(function (t) {
        var e = t[0]
        return 'p' === e || 'P' === e ? (0, D[e])(t, u.formatLong, k) : t
      })
      .join('')
      .match(yt),
    P = []
  for (T = 0; T < S.length; T++) {
    var E = S[T]
    !o.useAdditionalWeekYearTokens && M(E) && U(E), !o.useAdditionalDayOfYearTokens && C(E) && U(E)
    var Y = E[0],
      N = vt[Y]
    if (N) {
      var q = N.incompatibleTokens
      if (Array.isArray(q)) {
        for (var B = void 0, O = 0; O < P.length; O++) {
          var H = P[O].token
          if (-1 !== q.indexOf(H) || H === Y) {
            B = P[O]
            break
          }
        }
        if (B)
          throw new RangeError(
            "The format string mustn't contain `"
              .concat(B.fullToken, '` and `')
              .concat(E, '` at the same time'),
          )
      } else if ('*' === N.incompatibleTokens && P.length)
        throw new RangeError(
          "The format string mustn't contain `".concat(E, '` and any other token at the same time'),
        )
      P.push({token: Y, fullToken: E})
      var L = N.parse(a, E, u.match, k)
      if (!L) return new Date(NaN)
      x.push({
        priority: N.priority,
        set: N.set,
        validate: N.validate,
        value: L.value,
        index: x.length,
      }),
        (a = L.rest)
    } else {
      if (Y.match(kt))
        throw new RangeError(
          'Format string contains an unescaped latin alphabet character `' + Y + '`',
        )
      if (("''" === E ? (E = "'") : "'" === Y && (E = Mt(E)), 0 !== a.indexOf(E)))
        return new Date(NaN)
      a = a.slice(E.length)
    }
  }
  if (a.length > 0 && pt.test(a)) return new Date(NaN)
  var W = x
      .map(function (t) {
        return t.priority
      })
      .sort(function (t, e) {
        return e - t
      })
      .filter(function (t, e, n) {
        return n.indexOf(t) === e
      })
      .map(function (t) {
        return x
          .filter(function (e) {
            return e.priority === t
          })
          .reverse()
      })
      .map(function (t) {
        return t[0]
      }),
    F = m(n)
  if (isNaN(F)) return new Date(NaN)
  var Q = g(F, p(F)),
    R = {}
  for (T = 0; T < W.length; T++) {
    var I = W[T]
    if (I.validate && !I.validate(Q, I.value, k)) return new Date(NaN)
    var X = I.set(Q, R, I.value, k)
    X[0] ? ((Q = X[0]), v(R, X[1])) : (Q = X)
  }
  return Q
}
function Ct(t, e) {
  if (e.timestampIsSet) return t
  var n = new Date(0)
  return (
    n.setFullYear(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()),
    n.setHours(t.getUTCHours(), t.getUTCMinutes(), t.getUTCSeconds(), t.getUTCMilliseconds()),
    n
  )
}
function Mt(t) {
  return t.match(Dt)[1].replace(Tt, "'")
}
function Ut(t) {
  h(1, arguments)
  var e = m(t)
  return !isNaN(e)
}
function St(t, e) {
  for (var n = t < 0 ? '-' : '', r = Math.abs(t).toString(); r.length < e; ) r = '0' + r
  return n + r
}
var Pt = function (t, e) {
    var n = t.getUTCFullYear(),
      r = n > 0 ? n : 1 - n
    return St('yy' === e ? r % 100 : r, e.length)
  },
  Et = function (t, e) {
    var n = t.getUTCMonth()
    return 'M' === e ? String(n + 1) : St(n + 1, 2)
  },
  Yt = function (t, e) {
    return St(t.getUTCDate(), e.length)
  },
  Nt = function (t, e) {
    return St(t.getUTCHours() % 12 || 12, e.length)
  },
  qt = function (t, e) {
    return St(t.getUTCHours(), e.length)
  },
  Bt = function (t, e) {
    return St(t.getUTCMinutes(), e.length)
  },
  Ot = function (t, e) {
    return St(t.getUTCSeconds(), e.length)
  },
  Ht = function (t, e) {
    var n = e.length,
      r = t.getUTCMilliseconds()
    return St(Math.floor(r * Math.pow(10, n - 3)), e.length)
  }
var Lt = 'midnight',
  Wt = 'noon',
  Ft = 'morning',
  Qt = 'afternoon',
  Rt = 'evening',
  It = 'night',
  Xt = {
    G: function (t, e, n) {
      var r = t.getUTCFullYear() > 0 ? 1 : 0
      switch (e) {
        case 'G':
        case 'GG':
        case 'GGG':
          return n.era(r, {width: 'abbreviated'})
        case 'GGGGG':
          return n.era(r, {width: 'narrow'})
        case 'GGGG':
        default:
          return n.era(r, {width: 'wide'})
      }
    },
    y: function (t, e, n) {
      if ('yo' === e) {
        var r = t.getUTCFullYear(),
          a = r > 0 ? r : 1 - r
        return n.ordinalNumber(a, {unit: 'year'})
      }
      return Pt(t, e)
    },
    Y: function (t, e, n, r) {
      var a = P(t, r),
        i = a > 0 ? a : 1 - a
      return 'YY' === e
        ? St(i % 100, 2)
        : 'Yo' === e
        ? n.ordinalNumber(i, {unit: 'year'})
        : St(i, e.length)
    },
    R: function (t, e) {
      return St(N(t), e.length)
    },
    u: function (t, e) {
      return St(t.getUTCFullYear(), e.length)
    },
    Q: function (t, e, n) {
      var r = Math.ceil((t.getUTCMonth() + 1) / 3)
      switch (e) {
        case 'Q':
          return String(r)
        case 'QQ':
          return St(r, 2)
        case 'Qo':
          return n.ordinalNumber(r, {unit: 'quarter'})
        case 'QQQ':
          return n.quarter(r, {width: 'abbreviated', context: 'formatting'})
        case 'QQQQQ':
          return n.quarter(r, {width: 'narrow', context: 'formatting'})
        case 'QQQQ':
        default:
          return n.quarter(r, {width: 'wide', context: 'formatting'})
      }
    },
    q: function (t, e, n) {
      var r = Math.ceil((t.getUTCMonth() + 1) / 3)
      switch (e) {
        case 'q':
          return String(r)
        case 'qq':
          return St(r, 2)
        case 'qo':
          return n.ordinalNumber(r, {unit: 'quarter'})
        case 'qqq':
          return n.quarter(r, {width: 'abbreviated', context: 'standalone'})
        case 'qqqqq':
          return n.quarter(r, {width: 'narrow', context: 'standalone'})
        case 'qqqq':
        default:
          return n.quarter(r, {width: 'wide', context: 'standalone'})
      }
    },
    M: function (t, e, n) {
      var r = t.getUTCMonth()
      switch (e) {
        case 'M':
        case 'MM':
          return Et(t, e)
        case 'Mo':
          return n.ordinalNumber(r + 1, {unit: 'month'})
        case 'MMM':
          return n.month(r, {width: 'abbreviated', context: 'formatting'})
        case 'MMMMM':
          return n.month(r, {width: 'narrow', context: 'formatting'})
        case 'MMMM':
        default:
          return n.month(r, {width: 'wide', context: 'formatting'})
      }
    },
    L: function (t, e, n) {
      var r = t.getUTCMonth()
      switch (e) {
        case 'L':
          return String(r + 1)
        case 'LL':
          return St(r + 1, 2)
        case 'Lo':
          return n.ordinalNumber(r + 1, {unit: 'month'})
        case 'LLL':
          return n.month(r, {width: 'abbreviated', context: 'standalone'})
        case 'LLLLL':
          return n.month(r, {width: 'narrow', context: 'standalone'})
        case 'LLLL':
        default:
          return n.month(r, {width: 'wide', context: 'standalone'})
      }
    },
    w: function (t, e, n, r) {
      var a = H(t, r)
      return 'wo' === e ? n.ordinalNumber(a, {unit: 'week'}) : St(a, e.length)
    },
    I: function (t, e, n) {
      var r = B(t)
      return 'Io' === e ? n.ordinalNumber(r, {unit: 'week'}) : St(r, e.length)
    },
    d: function (t, e, n) {
      return 'do' === e ? n.ordinalNumber(t.getUTCDate(), {unit: 'date'}) : Yt(t, e)
    },
    D: function (t, e, n) {
      var r = (function (t) {
        h(1, arguments)
        var e = m(t),
          n = e.getTime()
        e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0)
        var r = e.getTime(),
          a = n - r
        return Math.floor(a / 864e5) + 1
      })(t)
      return 'Do' === e ? n.ordinalNumber(r, {unit: 'dayOfYear'}) : St(r, e.length)
    },
    E: function (t, e, n) {
      var r = t.getUTCDay()
      switch (e) {
        case 'E':
        case 'EE':
        case 'EEE':
          return n.day(r, {width: 'abbreviated', context: 'formatting'})
        case 'EEEEE':
          return n.day(r, {width: 'narrow', context: 'formatting'})
        case 'EEEEEE':
          return n.day(r, {width: 'short', context: 'formatting'})
        case 'EEEE':
        default:
          return n.day(r, {width: 'wide', context: 'formatting'})
      }
    },
    e: function (t, e, n, r) {
      var a = t.getUTCDay(),
        i = (a - r.weekStartsOn + 8) % 7 || 7
      switch (e) {
        case 'e':
          return String(i)
        case 'ee':
          return St(i, 2)
        case 'eo':
          return n.ordinalNumber(i, {unit: 'day'})
        case 'eee':
          return n.day(a, {width: 'abbreviated', context: 'formatting'})
        case 'eeeee':
          return n.day(a, {width: 'narrow', context: 'formatting'})
        case 'eeeeee':
          return n.day(a, {width: 'short', context: 'formatting'})
        case 'eeee':
        default:
          return n.day(a, {width: 'wide', context: 'formatting'})
      }
    },
    c: function (t, e, n, r) {
      var a = t.getUTCDay(),
        i = (a - r.weekStartsOn + 8) % 7 || 7
      switch (e) {
        case 'c':
          return String(i)
        case 'cc':
          return St(i, e.length)
        case 'co':
          return n.ordinalNumber(i, {unit: 'day'})
        case 'ccc':
          return n.day(a, {width: 'abbreviated', context: 'standalone'})
        case 'ccccc':
          return n.day(a, {width: 'narrow', context: 'standalone'})
        case 'cccccc':
          return n.day(a, {width: 'short', context: 'standalone'})
        case 'cccc':
        default:
          return n.day(a, {width: 'wide', context: 'standalone'})
      }
    },
    i: function (t, e, n) {
      var r = t.getUTCDay(),
        a = 0 === r ? 7 : r
      switch (e) {
        case 'i':
          return String(a)
        case 'ii':
          return St(a, e.length)
        case 'io':
          return n.ordinalNumber(a, {unit: 'day'})
        case 'iii':
          return n.day(r, {width: 'abbreviated', context: 'formatting'})
        case 'iiiii':
          return n.day(r, {width: 'narrow', context: 'formatting'})
        case 'iiiiii':
          return n.day(r, {width: 'short', context: 'formatting'})
        case 'iiii':
        default:
          return n.day(r, {width: 'wide', context: 'formatting'})
      }
    },
    a: function (t, e, n) {
      var r = t.getUTCHours() / 12 >= 1 ? 'pm' : 'am'
      switch (e) {
        case 'a':
        case 'aa':
        case 'aaa':
          return n.dayPeriod(r, {width: 'abbreviated', context: 'formatting'})
        case 'aaaaa':
          return n.dayPeriod(r, {width: 'narrow', context: 'formatting'})
        case 'aaaa':
        default:
          return n.dayPeriod(r, {width: 'wide', context: 'formatting'})
      }
    },
    b: function (t, e, n) {
      var r,
        a = t.getUTCHours()
      switch (((r = 12 === a ? Wt : 0 === a ? Lt : a / 12 >= 1 ? 'pm' : 'am'), e)) {
        case 'b':
        case 'bb':
        case 'bbb':
          return n.dayPeriod(r, {width: 'abbreviated', context: 'formatting'})
        case 'bbbbb':
          return n.dayPeriod(r, {width: 'narrow', context: 'formatting'})
        case 'bbbb':
        default:
          return n.dayPeriod(r, {width: 'wide', context: 'formatting'})
      }
    },
    B: function (t, e, n) {
      var r,
        a = t.getUTCHours()
      switch (((r = a >= 17 ? Rt : a >= 12 ? Qt : a >= 4 ? Ft : It), e)) {
        case 'B':
        case 'BB':
        case 'BBB':
          return n.dayPeriod(r, {width: 'abbreviated', context: 'formatting'})
        case 'BBBBB':
          return n.dayPeriod(r, {width: 'narrow', context: 'formatting'})
        case 'BBBB':
        default:
          return n.dayPeriod(r, {width: 'wide', context: 'formatting'})
      }
    },
    h: function (t, e, n) {
      if ('ho' === e) {
        var r = t.getUTCHours() % 12
        return 0 === r && (r = 12), n.ordinalNumber(r, {unit: 'hour'})
      }
      return Nt(t, e)
    },
    H: function (t, e, n) {
      return 'Ho' === e ? n.ordinalNumber(t.getUTCHours(), {unit: 'hour'}) : qt(t, e)
    },
    K: function (t, e, n) {
      var r = t.getUTCHours() % 12
      return 'Ko' === e ? n.ordinalNumber(r, {unit: 'hour'}) : St(r, e.length)
    },
    k: function (t, e, n) {
      var r = t.getUTCHours()
      return 0 === r && (r = 24), 'ko' === e ? n.ordinalNumber(r, {unit: 'hour'}) : St(r, e.length)
    },
    m: function (t, e, n) {
      return 'mo' === e ? n.ordinalNumber(t.getUTCMinutes(), {unit: 'minute'}) : Bt(t, e)
    },
    s: function (t, e, n) {
      return 'so' === e ? n.ordinalNumber(t.getUTCSeconds(), {unit: 'second'}) : Ot(t, e)
    },
    S: function (t, e) {
      return Ht(t, e)
    },
    X: function (t, e, n, r) {
      var a = (r._originalDate || t).getTimezoneOffset()
      if (0 === a) return 'Z'
      switch (e) {
        case 'X':
          return At(a)
        case 'XXXX':
        case 'XX':
          return zt(a)
        case 'XXXXX':
        case 'XXX':
        default:
          return zt(a, ':')
      }
    },
    x: function (t, e, n, r) {
      var a = (r._originalDate || t).getTimezoneOffset()
      switch (e) {
        case 'x':
          return At(a)
        case 'xxxx':
        case 'xx':
          return zt(a)
        case 'xxxxx':
        case 'xxx':
        default:
          return zt(a, ':')
      }
    },
    O: function (t, e, n, r) {
      var a = (r._originalDate || t).getTimezoneOffset()
      switch (e) {
        case 'O':
        case 'OO':
        case 'OOO':
          return 'GMT' + Gt(a, ':')
        case 'OOOO':
        default:
          return 'GMT' + zt(a, ':')
      }
    },
    z: function (t, e, n, r) {
      var a = (r._originalDate || t).getTimezoneOffset()
      switch (e) {
        case 'z':
        case 'zz':
        case 'zzz':
          return 'GMT' + Gt(a, ':')
        case 'zzzz':
        default:
          return 'GMT' + zt(a, ':')
      }
    },
    t: function (t, e, n, r) {
      var a = r._originalDate || t
      return St(Math.floor(a.getTime() / 1e3), e.length)
    },
    T: function (t, e, n, r) {
      return St((r._originalDate || t).getTime(), e.length)
    },
  }
function Gt(t, e) {
  var n = t > 0 ? '-' : '+',
    r = Math.abs(t),
    a = Math.floor(r / 60),
    i = r % 60
  if (0 === i) return n + String(a)
  var o = e || ''
  return n + String(a) + o + St(i, 2)
}
function At(t, e) {
  return t % 60 == 0 ? (t > 0 ? '-' : '+') + St(Math.abs(t) / 60, 2) : zt(t, e)
}
function zt(t, e) {
  var n = e || '',
    r = t > 0 ? '-' : '+',
    a = Math.abs(t)
  return r + St(Math.floor(a / 60), 2) + n + St(a % 60, 2)
}
var jt = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
  Kt = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
  Jt = /^'([^]*?)'?$/,
  Zt = /''/g,
  _t = /[a-zA-Z]/
function $t(t, e, n) {
  h(2, arguments)
  var r = String(e),
    a = n || {},
    i = a.locale || l,
    o = i.options && i.options.firstWeekContainsDate,
    u = null == o ? 1 : f(o),
    s = null == a.firstWeekContainsDate ? u : f(a.firstWeekContainsDate)
  if (!(s >= 1 && s <= 7))
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively')
  var c = i.options && i.options.weekStartsOn,
    d = null == c ? 0 : f(c),
    w = null == a.weekStartsOn ? d : f(a.weekStartsOn)
  if (!(w >= 0 && w <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  if (!i.localize) throw new RangeError('locale must contain localize property')
  if (!i.formatLong) throw new RangeError('locale must contain formatLong property')
  var v = m(t)
  if (!Ut(v)) throw new RangeError('Invalid time value')
  var y = p(v),
    b = g(v, y),
    T = {firstWeekContainsDate: s, weekStartsOn: w, locale: i, _originalDate: v},
    k = r
      .match(Kt)
      .map(function (t) {
        var e = t[0]
        return 'p' === e || 'P' === e ? (0, D[e])(t, i.formatLong, T) : t
      })
      .join('')
      .match(jt)
      .map(function (t) {
        if ("''" === t) return "'"
        var e = t[0]
        if ("'" === e) return Vt(t)
        var n = Xt[e]
        if (n)
          return (
            !a.useAdditionalWeekYearTokens && M(t) && U(t),
            !a.useAdditionalDayOfYearTokens && C(t) && U(t),
            n(b, t, i.localize, T)
          )
        if (e.match(_t))
          throw new RangeError(
            'Format string contains an unescaped latin alphabet character `' + e + '`',
          )
        return t
      })
      .join('')
  return k
}
function Vt(t) {
  return t.match(Jt)[1].replace(Zt, "'")
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function te(
  t,
  e,
) {
  h(2, arguments)
  var n = m(t),
    r = f(e)
  return isNaN(r) ? new Date(NaN) : r ? (n.setDate(n.getDate() + r), n) : n
}
function ee(t, e) {
  h(1, arguments)
  var n = t || {},
    r = m(n.start),
    a = m(n.end),
    i = a.getTime()
  if (!(r.getTime() <= i)) throw new RangeError('Invalid interval')
  var o = [],
    u = r
  u.setHours(0, 0, 0, 0)
  var s = e && 'step' in e ? Number(e.step) : 1
  if (s < 1 || isNaN(s)) throw new RangeError('`options.step` must be a number greater than 1')
  for (; u.getTime() <= i; ) o.push(m(u)), u.setDate(u.getDate() + s), u.setHours(0, 0, 0, 0)
  return o
}
function ne(t, e) {
  h(1, arguments)
  var n = e || {},
    r = n.locale,
    a = r && r.options && r.options.weekStartsOn,
    i = null == a ? 0 : f(a),
    o = null == n.weekStartsOn ? i : f(n.weekStartsOn)
  if (!(o >= 0 && o <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  var u = m(t),
    s = u.getDay(),
    c = 6 + (s < o ? -7 : 0) - (s - o)
  return u.setDate(u.getDate() + c), u.setHours(23, 59, 59, 999), u
}
function re(t) {
  h(1, arguments)
  var e = m(t)
  return e.setDate(1), e.setHours(0, 0, 0, 0), e
}
function ae(t, e) {
  h(1, arguments)
  var n = e || {},
    r = n.locale,
    a = r && r.options && r.options.weekStartsOn,
    i = null == a ? 0 : f(a),
    o = null == n.weekStartsOn ? i : f(n.weekStartsOn)
  if (!(o >= 0 && o <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively')
  var u = m(t),
    s = u.getDay(),
    c = (s < o ? 7 : 0) + s - o
  return u.setDate(u.getDate() - c), u.setHours(0, 0, 0, 0), u
}
function ie(t) {
  var e = void 0 === t ? {} : t,
    n = e.firstDayOfWeek,
    r = void 0 === n ? 1 : n,
    a = e.weekdayLabelFormat,
    i =
      void 0 === a
        ? function (t) {
            return $t(t, 'iiiiii')
          }
        : a,
    o = new Date()
  return ee({start: te(ae(o), r), end: te(ne(o), r)}).reduce(function (t, e) {
    return t.push(i(e)), t
  }, [])
}
function oe(t) {
  var e = t.year,
    n = t.month,
    r = t.firstDayOfWeek,
    a = void 0 === r ? 1 : r,
    i = t.dayLabelFormat,
    o =
      void 0 === i
        ? function (t) {
            return $t(t, 'dd')
          }
        : i,
    u = new Date(e, n),
    s = re(u),
    c = (function (t) {
      h(1, arguments)
      var e = m(t),
        n = e.getDay()
      return n
    })(s),
    d = (function (t) {
      h(1, arguments)
      var e = m(t),
        n = e.getMonth()
      return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(23, 59, 59, 999), e
    })(u)
  return (function () {
    for (var t = 0, e = 0, n = arguments.length; e < n; e++) t += arguments[e].length
    var r = Array(t),
      a = 0
    for (e = 0; e < n; e++)
      for (var i = arguments[e], o = 0, u = i.length; o < u; o++, a++) r[a] = i[o]
    return r
  })(
    Array.from(Array(c >= a ? c - a : 6 - a + c + 1).keys()).fill(0),
    ee({start: s, end: d}).map(function (t) {
      return {date: t, dayLabel: o(t)}
    }),
  )
}
var ue = function (t) {
    return $t(t, 'dd')
  },
  se = function (t) {
    return $t(t, 'eeeeee')
  },
  ce = function (t) {
    return $t(t, 'MMMM yyyy')
  }
function de(e) {
  var n = e.year,
    r = e.month,
    a = e.firstDayOfWeek,
    i = void 0 === a ? 1 : a,
    o = e.dayLabelFormat,
    u = void 0 === o ? ue : o,
    s = e.weekdayLabelFormat,
    c = void 0 === s ? se : s,
    d = e.monthLabelFormat,
    l = void 0 === d ? ce : d
  return {
    days: (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
      function () {
        return oe({year: n, month: r, firstDayOfWeek: i, dayLabelFormat: u})
      },
      [n, r, i, u],
    ),
    weekdayLabels: (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
      function () {
        return ie({firstDayOfWeek: i, weekdayLabelFormat: c})
      },
      [i, c],
    ),
    monthLabel: l(new Date(n, r)),
  }
}
function le(t, e) {
  h(2, arguments)
  var n = m(t),
    r = m(e)
  return n.getTime() < r.getTime()
}
function fe(t, e) {
  h(2, arguments)
  var n = m(t),
    r = m(e)
  return n.getTime() > r.getTime()
}
function he(t, e) {
  h(2, arguments)
  var n = e || {},
    r = m(t).getTime(),
    a = m(n.start).getTime(),
    i = m(n.end).getTime()
  if (!(a <= i)) throw new RangeError('Invalid interval')
  return r >= a && r <= i
}
function me(t) {
  h(1, arguments)
  var e = m(t)
  return e.setHours(0, 0, 0, 0), e
}
function we(t, e) {
  h(2, arguments)
  var n = me(t),
    r = me(e)
  return n.getTime() === r.getTime()
}
function ge(t, e) {
  h(2, arguments)
  var n = m(t),
    r = f(e)
  if (isNaN(r)) return new Date(NaN)
  if (!r) return n
  var a = n.getDate(),
    i = new Date(n.getTime())
  i.setMonth(n.getMonth() + r + 1, 0)
  var o = i.getDate()
  return a >= o ? i : (n.setFullYear(i.getFullYear(), i.getMonth(), a), n)
}
var ve = function (t, e) {
  return (
    void 0 === t && (t = []),
    t.some(function (t) {
      return we(e, t)
    })
  )
}
function ye(t, e, n) {
  return !(!e || !n) && he(t, {start: e, end: n})
}
function be(t, e, n) {
  return !!((e && we(t, e)) || (n && we(t, n)))
}
function De(t, e) {
  return !(!e || !we(t, e))
}
function Te(t, e) {
  return !(!e || !we(t, e))
}
function pe(t) {
  var e = t.date,
    n = t.minBookingDate,
    r = t.maxBookingDate,
    a = t.isDateBlockedFn,
    i = t.startDate,
    o = t.endDate,
    u = t.minBookingDays,
    s = void 0 === u ? 1 : u,
    c = t.unavailableDates,
    d = void 0 === c ? [] : c,
    l = n ? new Date(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0, 0) : n,
    f = r ? new Date(r.getFullYear(), r.getMonth(), r.getDate(), 0, 0, 0) : r
  return !!(
    ve(d, e) ||
    (l && le(e, l)) ||
    (f && fe(e, f)) ||
    (i && !o && s > 1 && he(e, {start: i, end: te(i, s - 2)})) ||
    (a && a(e))
  )
}
function ke(t) {
  var e = re(t)
  return {
    year: (function (t) {
      h(1, arguments)
      var e = m(t),
        n = e.getFullYear()
      return n
    })(e),
    month: (function (t) {
      h(1, arguments)
      var e = m(t),
        n = e.getMonth()
      return n
    })(e),
    date: e,
  }
}
function xe() {
  return ke(me(Date.now()))
}
function Ce(t, e) {
  var n = e ? ke(e) : xe(),
    r = n.date,
    a = [n]
  return (
    t > 1 &&
      (a = Array.from(Array(t - 1).keys()).reduce(function (t) {
        return (r = ge(t[t.length - 1].date, 1)), t.concat([ke(r)])
      }, a)),
    a
  )
}
function Me(t, e, n, r) {
  var a = t[r ? (n > 0 ? 0 : t.length - r) : n > 0 ? t.length - 1 : 0].date
  return Array.from(Array(e).keys()).reduce(function (t) {
    return (
      (a = 0 === t.length ? ge(a, n) : ge(a, n >= 0 ? 1 : -1)),
      n > 0 ? t.concat([ke(a)]) : [ke(a)].concat(t)
    )
  }, [])
}
function Ue(t, e, n) {
  return t && 'string' == typeof e ? $t(t, e) : t && 'function' == typeof e ? e(t) : n
}
function Se(t) {
  var e = t.startDate,
    n = t.endDate,
    r = t.isDateBlocked,
    a = t.minBookingDays,
    i = t.exactMinBookingDays,
    o = t.minBookingDate,
    u = t.maxBookingDate,
    s = !o || !le(e, te(o, -1)),
    c = !u || !fe(te(e, a - 1), u)
  return (
    !(!e || 1 !== a || n || r(e)) ||
    ((e && a > 1 && !n && !i) || (e && a > 0 && i && s && c) || (e && a > 0 && i && !o && !u)
      ? !ee({start: e, end: te(e, a - 1)}).some(function (t) {
          return r(t)
        })
      : !(!e || !n || i) &&
        !le(n, te(e, a - 1)) &&
        !ee({start: e, end: n}).some(function (t) {
          return r(t)
        }))
  )
}
var Pe = 'startDate',
  Ee = 'endDate'
function Ye(t) {
  var a = t.startDate,
    i = t.endDate,
    o = t.focusedInput,
    u = t.minBookingDate,
    s = t.maxBookingDate,
    c = t.onDatesChange,
    d = t.initialVisibleMonth,
    l = t.exactMinBookingDays,
    f = void 0 !== l && l,
    h = t.minBookingDays,
    m = void 0 === h ? 1 : h,
    w = t.numberOfMonths,
    g = void 0 === w ? 2 : w,
    v = t.firstDayOfWeek,
    y = void 0 === v ? 1 : v,
    b = t.isDateBlocked,
    D =
      void 0 === b
        ? function () {
            return !1
          }
        : b,
    T = t.unavailableDates,
    p = void 0 === T ? [] : T,
    k = t.changeActiveMonthOnSelect,
    x = void 0 === k || k,
    C = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
      return Ce(g, a || d || null)
    }),
    M = C[0],
    U = C[1],
    S = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),
    P = S[0],
    E = S[1],
    Y = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(a),
    N = Y[0],
    q = Y[1]
  ;(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    return (
      'undefined' != typeof window &&
        window.addEventListener &&
        window.addEventListener('keydown', L),
      function () {
        window.removeEventListener && window.removeEventListener('keydown', L)
      }
    )
  })
  var B = function (t) {
      return ve(p, t) || D(t)
    },
    O = function (t) {
      q(t), (!N || (N && !we(t, N))) && U(Ce(g, t))
    },
    H = function (t) {
      return pe({
        date: t,
        minBookingDate: u,
        maxBookingDate: s,
        startDate: a,
        endDate: i,
        minBookingDays: m,
        isDateBlockedFn: B,
      })
    }
  function L(t) {
    if (
      ('ArrowRight' === t.key ||
        'ArrowLeft' === t.key ||
        'ArrowDown' === t.key ||
        'ArrowUp' === t.key) &&
      !N
    ) {
      var e = M[0]
      O(e.date), U(Ce(g, e.date))
    }
  }
  var W = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
      function () {
        U(Me(M, g, -1)), q(null)
      },
      [M, g],
    ),
    F = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
      function () {
        U(Me(M, g, -1, 1)), q(null)
      },
      [M, g],
    ),
    Q = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
      function () {
        U(Me(M, g, 1)), q(null)
      },
      [M, g],
    ),
    R = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
      function () {
        U(Me(M, g, 1, 1)), q(null)
      },
      [M, g],
    ),
    I = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
      function (t) {
        U(Ce(g, t)), q(null)
      },
      [g],
    ),
    X = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
      function (t) {
        void 0 === t && (t = 1), U(Me(M, g, -(12 * t - g + 1))), q(null)
      },
      [M, g],
    ),
    G = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
      function (t) {
        void 0 === t && (t = 1), U(Me(M, g, 12 * t - g + 1)), q(null)
      },
      [M, g],
    )
  return {
    firstDayOfWeek: y,
    activeMonths: M,
    isDateSelected: function (t) {
      return ye(t, a, i)
    },
    isDateHovered: function (t) {
      return (function (t) {
        var e = t.date,
          n = t.startDate,
          r = t.endDate,
          a = t.isDateBlocked,
          i = t.hoveredDate,
          o = t.minBookingDays,
          u = t.exactMinBookingDays
        return i && o > 1 && u && he(e, {start: i, end: te(i, o - 1)})
          ? !ee({start: i, end: te(i, o - 1)}).some(function (t) {
              return a(t)
            })
          : n && !r && i && he(e, {start: n, end: te(n, o - 1)}) && we(n, i) && o > 1
          ? !ee({start: n, end: te(n, o - 1)}).some(function (t) {
              return a(t)
            })
          : !(!n || r || !i || le(i, n) || !he(e, {start: n, end: i})) &&
            !ee({start: n, end: i}).some(function (t) {
              return a(t)
            })
      })({
        date: t,
        hoveredDate: P,
        startDate: a,
        endDate: i,
        minBookingDays: m,
        exactMinBookingDays: f,
        isDateBlocked: B,
      })
    },
    isFirstOrLastSelectedDate: function (t) {
      return be(t, a, i)
    },
    isStartDate: function (t) {
      return De(t, a)
    },
    isEndDate: function (t) {
      return Te(t, i)
    },
    isDateBlocked: H,
    numberOfMonths: g,
    isDateFocused: function (t) {
      return !!N && we(t, N)
    },
    focusedDate: N,
    hoveredDate: P,
    onResetDates: function () {
      c({startDate: null, endDate: null, focusedInput: 'startDate'})
    },
    onDateHover: function (t) {
      if (t) {
        if (t) {
          var e = !H(t) || (a && we(t, a)),
            n = !u || !le(t, te(u, -1)),
            r = !s || !fe(t, s),
            o = te(t, m - 1),
            c = !u || !le(o, u),
            d = !s || !fe(o, s),
            l = f && m > 1 && n && r && c && d,
            h = a && !i && !f && n && r,
            w = !(m > 1 && a) || he(t, {start: a, end: te(a, m - 2)}),
            g = a && we(t, a) && w
          e && (l || h || g) ? E(t) : null !== P && E(null)
        }
      } else E(null)
    },
    onDateSelect: function (t) {
      ;('endDate' === o || 'startDate' === o) &&
      m > 0 &&
      f &&
      Se({
        minBookingDays: m,
        exactMinBookingDays: f,
        minBookingDate: u,
        maxBookingDate: s,
        isDateBlocked: B,
        startDate: t,
        endDate: null,
      })
        ? c({startDate: t, endDate: te(t, m - 1), focusedInput: null})
        : (('endDate' === o && a && le(t, a)) || ('startDate' === o && i && fe(t, i))) &&
          !f &&
          Se({minBookingDays: m, isDateBlocked: B, startDate: t, endDate: null})
        ? c({endDate: null, startDate: t, focusedInput: 'endDate'})
        : 'startDate' === o &&
          !f &&
          Se({minBookingDays: m, isDateBlocked: B, endDate: i, startDate: t})
        ? c({endDate: i, startDate: t, focusedInput: 'endDate'})
        : 'startDate' === o &&
          !f &&
          Se({minBookingDays: m, isDateBlocked: B, endDate: null, startDate: t})
        ? c({endDate: null, startDate: t, focusedInput: 'endDate'})
        : 'endDate' === o &&
          a &&
          !le(t, a) &&
          !f &&
          Se({minBookingDays: m, isDateBlocked: B, startDate: a, endDate: t}) &&
          c({startDate: a, endDate: t, focusedInput: null}),
        'endDate' !== o && (!N || (N && !we(t, N))) && x && U(Ce(g, t))
    },
    onDateFocus: O,
    goToPreviousMonths: W,
    goToPreviousMonthsByOneMonth: F,
    goToNextMonths: Q,
    goToNextMonthsByOneMonth: R,
    goToDate: I,
    goToPreviousYear: X,
    goToNextYear: G,
  }
}
function Ne(t) {
  var e = t.date,
    n = t.focusedDate,
    a = t.isDateSelected,
    i = t.isDateFocused,
    o = t.isFirstOrLastSelectedDate,
    u = t.isDateHovered,
    s = t.isDateBlocked,
    c = t.onDateSelect,
    d = t.onDateFocus,
    l = t.onDateHover,
    f = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
      function () {
        return c(e)
      },
      [e, c],
    ),
    h = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
      function () {
        return l(e)
      },
      [e, l],
    ),
    m = s(e) && !u(e)
  return {
    tabIndex: null === n || i(e) ? 0 : -1,
    isSelected: a(e),
    isSelectedStartOrEnd: o(e),
    isWithinHoverRange: u(e),
    disabledDate: m,
    onKeyDown: function (t) {
      'ArrowRight' === t.key
        ? d(te(e, 1))
        : 'ArrowLeft' === t.key
        ? d(te(e, -1))
        : 'ArrowUp' === t.key
        ? d(te(e, -7))
        : 'ArrowDown' === t.key && d(te(e, 7))
    },
    onClick: m ? function () {} : f,
    onMouseEnter: h,
  }
}



/***/ }),

/***/ 20157:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

'use client';
Object.defineProperty(exports, "__esModule", ({ value: true }));
const jsx_runtime_1 = __webpack_require__(52322);
const react_1 = __webpack_require__(2784);
function ThirdPartyScriptEmbed({ html, height = null, width = null, children, dataNtpc = '', }) {
    (0, react_1.useEffect)(() => {
        if (dataNtpc) {
            // performance.mark is being used as a feature use signal. While it is traditionally used for performance
            // benchmarking it is low overhead and thus considered safe to use in production and it is a widely available
            // existing API.
            performance.mark('mark_feature_usage', {
                detail: {
                    feature: `next-third-parties-${dataNtpc}`,
                },
            });
        }
    }, [dataNtpc]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [children, html ? ((0, jsx_runtime_1.jsx)("div", { style: {
                    height: height != null ? `${height}px` : 'auto',
                    width: width != null ? `${width}px` : 'auto',
                }, "data-ntpc": dataNtpc, dangerouslySetInnerHTML: { __html: html } })) : null] }));
}
exports["default"] = ThirdPartyScriptEmbed;


/***/ }),

/***/ 68925:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sendGAEvent = exports.GoogleAnalytics = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
// TODO: Evaluate import 'client only'
const react_1 = __webpack_require__(2784);
const script_1 = __importDefault(__webpack_require__(45847));
let currDataLayerName = undefined;
function GoogleAnalytics(props) {
    const { gaId, dataLayerName = 'dataLayer' } = props;
    if (currDataLayerName === undefined) {
        currDataLayerName = dataLayerName;
    }
    (0, react_1.useEffect)(() => {
        // performance.mark is being used as a feature use signal. While it is traditionally used for performance
        // benchmarking it is low overhead and thus considered safe to use in production and it is a widely available
        // existing API.
        // The performance measurement will be handled by Chrome Aurora
        performance.mark('mark_feature_usage', {
            detail: {
                feature: 'next-third-parties-ga',
            },
        });
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(script_1.default, { id: "_next-ga-init", dangerouslySetInnerHTML: {
                    __html: `
          window['${dataLayerName}'] = window['${dataLayerName}'] || [];
          function gtag(){window['${dataLayerName}'].push(arguments);}
          gtag('js', new Date());

          gtag('config', '${gaId}');`,
                } }), (0, jsx_runtime_1.jsx)(script_1.default, { id: "_next-ga", src: `https://www.googletagmanager.com/gtag/js?id=${gaId}` })] }));
}
exports.GoogleAnalytics = GoogleAnalytics;
function sendGAEvent(..._args) {
    if (currDataLayerName === undefined) {
        console.warn(`@next/third-parties: GA has not been initialized`);
        return;
    }
    if (window[currDataLayerName]) {
        window[currDataLayerName].push(arguments);
    }
    else {
        console.warn(`@next/third-parties: GA dataLayer ${currDataLayerName} does not exist`);
    }
}
exports.sendGAEvent = sendGAEvent;


/***/ }),

/***/ 89362:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const jsx_runtime_1 = __webpack_require__(52322);
const third_party_capital_1 = __webpack_require__(89565);
const ThirdPartyScriptEmbed_1 = __importDefault(__webpack_require__(20157));
function GoogleMapsEmbed(props) {
    const { apiKey, ...restProps } = props;
    const formattedProps = { ...restProps, key: apiKey };
    const { html } = (0, third_party_capital_1.GoogleMapsEmbed)(formattedProps);
    return ((0, jsx_runtime_1.jsx)(ThirdPartyScriptEmbed_1.default, { height: formattedProps.height || null, width: formattedProps.width || null, html: html, dataNtpc: "GoogleMapsEmbed" }));
}
exports["default"] = GoogleMapsEmbed;


/***/ }),

/***/ 78072:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sendGTMEvent = exports.GoogleTagManager = void 0;
const jsx_runtime_1 = __webpack_require__(52322);
// TODO: Evaluate import 'client only'
const react_1 = __webpack_require__(2784);
const script_1 = __importDefault(__webpack_require__(45847));
let currDataLayerName = undefined;
function GoogleTagManager(props) {
    const { gtmId, dataLayerName = 'dataLayer', auth, preview, dataLayer } = props;
    if (currDataLayerName === undefined) {
        currDataLayerName = dataLayerName;
    }
    const gtmLayer = dataLayerName !== 'dataLayer' ? `&l=${dataLayerName}` : '';
    const gtmAuth = auth ? `&gtm_auth=${auth}` : '';
    const gtmPreview = preview ? `&gtm_preview=${preview}&gtm_cookies_win=x` : '';
    (0, react_1.useEffect)(() => {
        // performance.mark is being used as a feature use signal. While it is traditionally used for performance
        // benchmarking it is low overhead and thus considered safe to use in production and it is a widely available
        // existing API.
        // The performance measurement will be handled by Chrome Aurora
        performance.mark('mark_feature_usage', {
            detail: {
                feature: 'next-third-parties-gtm',
            },
        });
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(script_1.default, { id: "_next-gtm-init", dangerouslySetInnerHTML: {
                    __html: `
      (function(w,l){
        w[l]=w[l]||[];
        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
        ${dataLayer ? `w[l].push(${JSON.stringify(dataLayer)})` : ''}
      })(window,'${dataLayerName}');`,
                } }), (0, jsx_runtime_1.jsx)(script_1.default, { id: "_next-gtm", "data-ntpc": "GTM", src: `https://www.googletagmanager.com/gtm.js?id=${gtmId}${gtmLayer}${gtmAuth}${gtmPreview}` })] }));
}
exports.GoogleTagManager = GoogleTagManager;
const sendGTMEvent = (data) => {
    if (currDataLayerName === undefined) {
        console.warn(`@next/third-parties: GTM has not been initialized`);
        return;
    }
    if (window[currDataLayerName]) {
        window[currDataLayerName].push(data);
    }
    else {
        console.warn(`@next/third-parties: GTM dataLayer ${currDataLayerName} does not exist`);
    }
};
exports.sendGTMEvent = sendGTMEvent;


/***/ }),

/***/ 48790:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.sendGAEvent = exports.GoogleAnalytics = exports.sendGTMEvent = exports.GoogleTagManager = exports.YouTubeEmbed = exports.GoogleMapsEmbed = void 0;
var google_maps_embed_1 = __webpack_require__(89362);
Object.defineProperty(exports, "GoogleMapsEmbed", ({ enumerable: true, get: function () { return __importDefault(google_maps_embed_1).default; } }));
var youtube_embed_1 = __webpack_require__(62316);
Object.defineProperty(exports, "YouTubeEmbed", ({ enumerable: true, get: function () { return __importDefault(youtube_embed_1).default; } }));
var gtm_1 = __webpack_require__(78072);
Object.defineProperty(exports, "GoogleTagManager", ({ enumerable: true, get: function () { return gtm_1.GoogleTagManager; } }));
Object.defineProperty(exports, "sendGTMEvent", ({ enumerable: true, get: function () { return gtm_1.sendGTMEvent; } }));
var ga_1 = __webpack_require__(68925);
Object.defineProperty(exports, "GoogleAnalytics", ({ enumerable: true, get: function () { return ga_1.GoogleAnalytics; } }));
Object.defineProperty(exports, "sendGAEvent", ({ enumerable: true, get: function () { return ga_1.sendGAEvent; } }));


/***/ }),

/***/ 62316:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const jsx_runtime_1 = __webpack_require__(52322);
const script_1 = __importDefault(__webpack_require__(45847));
const third_party_capital_1 = __webpack_require__(89565);
const ThirdPartyScriptEmbed_1 = __importDefault(__webpack_require__(20157));
const scriptStrategy = {
    server: 'beforeInteractive',
    client: 'afterInteractive',
    idle: 'lazyOnload',
    worker: 'worker',
};
function YouTubeEmbed(props) {
    const { html, scripts, stylesheets } = (0, third_party_capital_1.YouTubeEmbed)(props);
    return ((0, jsx_runtime_1.jsx)(ThirdPartyScriptEmbed_1.default, { height: props.height || null, width: props.width || null, html: html, dataNtpc: "YouTubeEmbed", children: scripts === null || scripts === void 0 ? void 0 : scripts.map((script) => ((0, jsx_runtime_1.jsx)(script_1.default, { src: script.url, strategy: scriptStrategy[script.strategy], stylesheets: stylesheets }, script.url))) }));
}
exports["default"] = YouTubeEmbed;


/***/ }),

/***/ 68156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "if": function() { return /* binding */ AnimatedArray; },
  "rS": function() { return /* binding */ AnimatedObject; },
  "eC": function() { return /* binding */ AnimatedString; },
  "iG": function() { return /* binding */ AnimatedValue; },
  "Ld": function() { return /* binding */ createHost; },
  "ys": function() { return /* binding */ getAnimated; },
  "He": function() { return /* binding */ getPayload; },
  "f3": function() { return /* binding */ setAnimated; }
});

// UNUSED EXPORTS: Animated, AnimatedProps, isAnimated

// EXTERNAL MODULE: ../../node_modules/@react-spring/shared/esm/index.js + 2 modules
var esm = __webpack_require__(26673);
;// CONCATENATED MODULE: ../../node_modules/@react-spring/animated/node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

// EXTERNAL MODULE: ../../node_modules/@react-spring/shared/esm/globals.js
var globals = __webpack_require__(37994);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-layout-effect/dist/esm/useLayoutEffect.js
var useLayoutEffect = __webpack_require__(76831);
;// CONCATENATED MODULE: ../../node_modules/@react-spring/animated/index.js






const $node = Symbol.for('Animated:node');
const isAnimated = value => !!value && value[$node] === value;
/** Get the owner's `Animated` node. */

const getAnimated = owner => owner && owner[$node];
/** Set the owner's `Animated` node. */

const setAnimated = (owner, node) => (0,esm.defineHidden)(owner, $node, node);
/** Get every `AnimatedValue` in the owner's `Animated` node. */

const getPayload = owner => owner && owner[$node] && owner[$node].getPayload();
class Animated {
  /** The cache of animated values */
  constructor() {
    this.payload = void 0;
    // This makes "isAnimated" return true.
    setAnimated(this, this);
  }
  /** Get the current value. Pass `true` for only animated values. */


  /** Get every `AnimatedValue` used by this node. */
  getPayload() {
    return this.payload || [];
  }

}

/** An animated number or a native attribute value */

class AnimatedValue extends Animated {
  constructor(_value) {
    super();
    this._value = _value;
    this.done = true;
    this.elapsedTime = void 0;
    this.lastPosition = void 0;
    this.lastVelocity = void 0;
    this.v0 = void 0;

    if (esm.is.num(this._value)) {
      this.lastPosition = this._value;
    }
  }

  static create(from, _to) {
    return new AnimatedValue(from);
  }

  getPayload() {
    return [this];
  }

  getValue() {
    return this._value;
  }
  /**
   * Set the current value and optionally round it.
   *
   * The `step` argument does nothing whenever it equals `undefined` or `0`.
   * It works with fractions and whole numbers. The best use case is (probably)
   * rounding to the pixel grid with a step of:
   *
   *      1 / window.devicePixelRatio
   */


  setValue(value, step) {
    if (esm.is.num(value)) {
      this.lastPosition = value;

      if (step) {
        value = Math.round(value / step) * step;

        if (this.done) {
          this.lastPosition = value;
        }
      }
    }

    if (this._value === value) {
      return false;
    }

    this._value = value;
    return true;
  }

  reset() {
    const {
      done
    } = this;
    this.done = false;

    if (esm.is.num(this._value)) {
      this.elapsedTime = 0;
      this.lastPosition = this._value;
      if (done) this.lastVelocity = null;
      this.v0 = null;
    }
  }

}

class AnimatedString extends AnimatedValue {
  constructor(from, to) {
    super(0);
    this._value = void 0;
    this._string = null;
    this._toString = void 0;
    this._toString = (0,esm.createInterpolator)({
      output: [from, to]
    });
  }

  static create(from, to = from) {
    if (esm.is.str(from) && esm.is.str(to)) {
      return new AnimatedString(from, to);
    }

    throw TypeError('Expected "from" and "to" to be strings');
  }

  getValue() {
    let value = this._string;
    return value == null ? this._string = this._toString(this._value) : value;
  }

  setValue(value) {
    if (!esm.is.num(value)) {
      this._string = value;
      this._value = 1;
    } else if (super.setValue(value)) {
      this._string = null;
    } else {
      return false;
    }

    return true;
  }

  reset(goal) {
    if (goal) {
      this._toString = (0,esm.createInterpolator)({
        output: [this.getValue(), goal]
      });
    }

    this._value = 0;
    super.reset();
  }

}

const TreeContext = {
  current: null
};

/** An object containing `Animated` nodes */
class AnimatedObject extends Animated {
  constructor(source = null) {
    super();
    this.source = void 0;
    this.setValue(source);
  }

  getValue(animated) {
    if (!this.source) return null;
    const values = {};
    (0,esm.each)(this.source, (source, key) => {
      if (isAnimated(source)) {
        values[key] = source.getValue(animated);
      } else {
        const config = (0,esm.getFluidConfig)(source);

        if (config) {
          values[key] = config.get();
        } else if (!animated) {
          values[key] = source;
        }
      }
    });
    return values;
  }
  /** Replace the raw object data */


  setValue(source) {
    this.source = source;
    this.payload = this._makePayload(source);
  }

  reset() {
    if (this.payload) {
      (0,esm.each)(this.payload, node => node.reset());
    }
  }
  /** Create a payload set. */


  _makePayload(source) {
    if (source) {
      const payload = new Set();
      (0,esm.each)(source, this._addToPayload, payload);
      return Array.from(payload);
    }
  }
  /** Add to a payload set. */


  _addToPayload(source) {
    const config = (0,esm.getFluidConfig)(source);

    if (config && TreeContext.current) {
      TreeContext.current.dependencies.add(source);
    }

    const payload = getPayload(source);

    if (payload) {
      (0,esm.each)(payload, node => this.add(node));
    }
  }

}

/** An array of animated nodes */
class AnimatedArray extends AnimatedObject {
  constructor(from, to) {
    super(null);
    this.source = void 0;
    super.setValue(this._makeAnimated(from, to));
  }

  static create(from, to) {
    return new AnimatedArray(from, to);
  }

  getValue() {
    return this.source.map(node => node.getValue());
  }

  setValue(newValue) {
    const payload = this.getPayload(); // Reuse the payload when lengths are equal.

    if (newValue && newValue.length == payload.length) {
      (0,esm.each)(payload, (node, i) => node.setValue(newValue[i]));
    } else {
      // Remake the payload when length changes.
      this.source = this._makeAnimated(newValue);
      this.payload = this._makePayload(this.source);
    }
  }
  /** Convert the `from` and `to` values to an array of `Animated` nodes */


  _makeAnimated(from, to = from) {
    return from ? from.map((from, i) => ((0,esm.isAnimatedString)(from) ? AnimatedString : AnimatedValue).create(from, to[i])) : [];
  }

}

class AnimatedProps extends AnimatedObject {
  /** Equals true when an update is scheduled for "end of frame" */
  constructor(update) {
    super(null);
    this.update = update;
    this.dirty = false;
  }

  setValue(props, context) {
    if (!props) return; // The constructor passes null.

    if (context) {
      TreeContext.current = context;

      if (props.style) {
        const {
          createAnimatedStyle
        } = context.host;
        props = _extends(_extends({}, props), {}, {
          style: createAnimatedStyle(props.style)
        });
      }
    }

    super.setValue(props);
    TreeContext.current = null;
  }
  /** @internal */


  onParentChange({
    type
  }) {
    if (!this.dirty && type === 'change') {
      this.dirty = true;
      globals.frameLoop.onFrame(() => {
        this.dirty = false;
        this.update();
      });
    }
  }

}

const withAnimated = (Component, host) => (0,react.forwardRef)((rawProps, ref) => {
  const instanceRef = (0,react.useRef)(null);
  const hasInstance = // Function components must use "forwardRef" to avoid being
  // re-rendered on every animation frame.
  !esm.is.fun(Component) || Component.prototype && Component.prototype.isReactComponent;
  const forceUpdate = (0,esm.useForceUpdate)();
  const props = new AnimatedProps(() => {
    const instance = instanceRef.current;

    if (hasInstance && !instance) {
      return; // The wrapped component forgot to forward its ref.
    }

    const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false; // Re-render the component when native updates fail.

    if (didUpdate === false) {
      forceUpdate();
    }
  });
  const dependencies = new Set();
  props.setValue(rawProps, {
    dependencies,
    host
  });
  (0,useLayoutEffect/* useLayoutEffect */.b)(() => {
    (0,esm.each)(dependencies, dep => dep.addChild(props));
    return () => (0,esm.each)(dependencies, dep => dep.removeChild(props));
  });
  return /*#__PURE__*/(0,react.createElement)(Component, _extends({}, host.getComponentProps(props.getValue()), {
    ref: hasInstance && (value => {
      instanceRef.current = updateRef(ref, value);
    })
  }));
});

function updateRef(ref, value) {
  if (ref) {
    if (esm.is.fun(ref)) ref(value);else ref.current = value;
  }

  return value;
}

// For storing the animated version on the original component
const cacheKey = Symbol.for('AnimatedComponent');
const createHost = (components, {
  applyAnimatedValues = () => false,
  createAnimatedStyle = style => new AnimatedObject(style),
  getComponentProps = props => props
} = {}) => {
  const hostConfig = {
    applyAnimatedValues,
    createAnimatedStyle,
    getComponentProps
  };

  const animated = Component => {
    const displayName = getDisplayName(Component) || 'Anonymous';

    if (esm.is.str(Component)) {
      Component = withAnimated(Component, hostConfig);
    } else {
      Component = Component[cacheKey] || (Component[cacheKey] = withAnimated(Component, hostConfig));
    }

    Component.displayName = "Animated(" + displayName + ")";
    return Component;
  };

  (0,esm.each)(components, (Component, key) => {
    if (!esm.is.str(key)) {
      key = getDisplayName(Component);
    }

    animated[key] = animated(Component);
  });
  return {
    animated
  };
};

const getDisplayName = arg => esm.is.str(arg) ? arg : arg && esm.is.str(arg.displayName) ? arg.displayName : esm.is.fun(arg) && arg.name || null;


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 32825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Globals": function() { return /* reexport */ esm.Globals; },
  "config": function() { return /* binding */ config; },
  "useTransition": function() { return /* binding */ useTransition; }
});

// UNUSED EXPORTS: BailSignal, Controller, FrameLoop, FrameValue, Interpolation, Spring, SpringContext, SpringHandle, SpringValue, Trail, Transition, createInterpolator, inferTo, interpolate, to, update, useChain, useSpring, useSprings, useTrail

// EXTERNAL MODULE: ../../node_modules/react-layout-effect/dist/esm/useLayoutEffect.js
var esm_useLayoutEffect = __webpack_require__(76831);
// EXTERNAL MODULE: ../../node_modules/@react-spring/shared/esm/index.js + 2 modules
var esm = __webpack_require__(26673);
;// CONCATENATED MODULE: ../../node_modules/@react-spring/core/node_modules/@babel/runtime/helpers/esm/extends.js
function extends_extends() {
  return extends_extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, extends_extends.apply(null, arguments);
}

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@react-spring/animated/index.js + 1 modules
var animated = __webpack_require__(68156);
// EXTERNAL MODULE: ../../node_modules/@react-spring/shared/esm/globals.js
var globals = __webpack_require__(37994);
;// CONCATENATED MODULE: ../../node_modules/use-memo-one/dist/use-memo-one.esm.js


function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }

  return true;
}

function useMemoOne(getResult, inputs) {
  var initial = (0,react.useState)(function () {
    return {
      inputs: inputs,
      result: getResult()
    };
  })[0];
  var isFirstRun = (0,react.useRef)(true);
  var committed = (0,react.useRef)(initial);
  var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && areInputsEqual(inputs, committed.current.inputs));
  var cache = useCache ? committed.current : {
    inputs: inputs,
    result: getResult()
  };
  (0,react.useEffect)(function () {
    isFirstRun.current = false;
    committed.current = cache;
  }, [cache]);
  return cache.result;
}
function use_memo_one_esm_useCallbackOne(callback, inputs) {
  return useMemoOne(function () {
    return callback;
  }, inputs);
}
var useMemo = (/* unused pure expression or super */ null && (useMemoOne));
var useCallback = (/* unused pure expression or super */ null && (use_memo_one_esm_useCallbackOne));



;// CONCATENATED MODULE: ../../node_modules/@react-spring/shared/esm/deprecations.js
var prefix = 'react-spring: ';
var flagInterpolate = false;
function deprecations_deprecateInterpolate() {
    if (!flagInterpolate) {
        flagInterpolate = true;
        console.warn(prefix +
            'The "interpolate" function is deprecated in v10 (use "to" instead)');
    }
}
//# sourceMappingURL=deprecations.js.map
;// CONCATENATED MODULE: ../../node_modules/@react-spring/core/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}

// EXTERNAL MODULE: ../../node_modules/@react-spring/shared/esm/stringInterpolation.js + 4 modules
var stringInterpolation = __webpack_require__(68199);
// EXTERNAL MODULE: ../../node_modules/@react-spring/shared/esm/types.js
var types = __webpack_require__(18876);
;// CONCATENATED MODULE: ../../node_modules/@react-spring/core/index.js













/** API
 *  useChain(references, timeSteps, timeFrame)
 */

function useChain(refs, timeSteps, timeFrame = 1000) {
  useLayoutEffect(() => {
    if (timeSteps) {
      let prevDelay = 0;
      each(refs, (ref, i) => {
        if (!ref.current) return;
        const {
          controllers
        } = ref.current;

        if (controllers.length) {
          let delay = timeFrame * timeSteps[i]; // Use the previous delay if none exists.

          if (isNaN(delay)) delay = prevDelay;else prevDelay = delay;
          each(controllers, ctrl => {
            each(ctrl.queue, props => {
              props.delay = delay + (props.delay || 0);
            });
            ctrl.start();
          });
        }
      });
    } else {
      let p = Promise.resolve();
      each(refs, ref => {
        const {
          controllers,
          start
        } = ref.current || {};

        if (controllers && controllers.length) {
          // Take the queue of each controller
          const updates = controllers.map(ctrl => {
            const q = ctrl.queue;
            ctrl.queue = [];
            return q;
          }); // Apply the queue when the previous ref stops animating

          p = p.then(() => {
            each(controllers, (ctrl, i) => ctrl.queue.push(...updates[i]));
            return start();
          });
        }
      });
    }
  });
}

// The `mass` prop defaults to 1
const config = {
  default: {
    tension: 170,
    friction: 26
  },
  gentle: {
    tension: 120,
    friction: 14
  },
  wobbly: {
    tension: 180,
    friction: 12
  },
  stiff: {
    tension: 210,
    friction: 20
  },
  slow: {
    tension: 280,
    friction: 60
  },
  molasses: {
    tension: 280,
    friction: 120
  }
};

const linear = t => t;

const defaults = extends_extends(extends_extends({}, config.default), {}, {
  mass: 1,
  damping: 1,
  easing: linear,
  clamp: false
});

class AnimationConfig {
  /**
   * With higher tension, the spring will resist bouncing and try harder to stop at its end value.
   *
   * When tension is zero, no animation occurs.
   */

  /**
   * The damping ratio coefficient, or just the damping ratio when `speed` is defined.
   *
   * When `speed` is defined, this value should be between 0 and 1.
   *
   * Higher friction means the spring will slow down faster.
   */

  /**
   * The natural frequency (in seconds), which dictates the number of bounces
   * per second when no damping exists.
   *
   * When defined, `tension` is derived from this, and `friction` is derived
   * from `tension` and `damping`.
   */

  /**
   * The damping ratio, which dictates how the spring slows down.
   *
   * Set to `0` to never slow down. Set to `1` to slow down without bouncing.
   * Between `0` and `1` is for you to explore.
   *
   * Only works when `frequency` is defined.
   *
   * Defaults to 1
   */

  /**
   * Higher mass means more friction is required to slow down.
   *
   * Defaults to 1, which works fine most of the time.
   */

  /**
   * The initial velocity of one or more values.
   */

  /**
   * The smallest velocity before the animation is considered "not moving".
   *
   * When undefined, `precision` is used instead.
   */

  /**
   * The smallest distance from a value before that distance is essentially zero.
   *
   * This helps in deciding when a spring is "at rest". The spring must be within
   * this distance from its final value, and its velocity must be lower than this
   * value too (unless `restVelocity` is defined).
   */

  /**
   * For `duration` animations only. Note: The `duration` is not affected
   * by this property.
   *
   * Defaults to `0`, which means "start from the beginning".
   *
   * Setting to `1+` makes an immediate animation.
   *
   * Setting to `0.5` means "start from the middle of the easing function".
   *
   * Any number `>= 0` and `<= 1` makes sense here.
   */

  /**
   * Animation length in number of milliseconds.
   */

  /**
   * The animation curve. Only used when `duration` is defined.
   *
   * Defaults to quadratic ease-in-out.
   */

  /**
   * Avoid overshooting by ending abruptly at the goal value.
   */

  /**
   * When above zero, the spring will bounce instead of overshooting when
   * exceeding its goal value. Its velocity is multiplied by `-1 + bounce`
   * whenever its current value equals or exceeds its goal. For example,
   * setting `bounce` to `0.5` chops the velocity in half on each bounce,
   * in addition to any friction.
   */

  /**
   * "Decay animations" decelerate without an explicit goal value.
   * Useful for scrolling animations.
   *
   * Use `true` for the default exponential decay factor (`0.998`).
   *
   * When a `number` between `0` and `1` is given, a lower number makes the
   * animation slow down faster. And setting to `1` would make an unending
   * animation.
   */

  /**
   * While animating, round to the nearest multiple of this number.
   * The `from` and `to` values are never rounded, as well as any value
   * passed to the `set` method of an animated value.
   */
  constructor() {
    this.tension = void 0;
    this.friction = void 0;
    this.frequency = void 0;
    this.damping = void 0;
    this.mass = void 0;
    this.velocity = 0;
    this.restVelocity = void 0;
    this.precision = void 0;
    this.progress = void 0;
    this.duration = void 0;
    this.easing = void 0;
    this.clamp = void 0;
    this.bounce = void 0;
    this.decay = void 0;
    this.round = void 0;
    Object.assign(this, defaults);
  }

}
function mergeConfig(config, newConfig, defaultConfig) {
  if (defaultConfig) {
    defaultConfig = extends_extends({}, defaultConfig);
    sanitizeConfig(defaultConfig, newConfig);
    newConfig = extends_extends(extends_extends({}, defaultConfig), newConfig);
  }

  sanitizeConfig(config, newConfig);
  Object.assign(config, newConfig);

  for (const key in defaults) {
    if (config[key] == null) {
      config[key] = defaults[key];
    }
  }

  let {
    mass,
    frequency,
    damping
  } = config;

  if (!esm.is.und(frequency)) {
    if (frequency < 0.01) frequency = 0.01;
    if (damping < 0) damping = 0;
    config.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
    config.friction = 4 * Math.PI * damping * mass / frequency;
  }

  return config;
} // Prevent a config from accidentally overriding new props.
// This depends on which "config" props take precedence when defined.

function sanitizeConfig(config, props) {
  if (!esm.is.und(props.decay)) {
    config.duration = undefined;
  } else {
    const isTensionConfig = !esm.is.und(props.tension) || !esm.is.und(props.friction);

    if (isTensionConfig || !esm.is.und(props.frequency) || !esm.is.und(props.damping) || !esm.is.und(props.mass)) {
      config.duration = undefined;
      config.decay = undefined;
    }

    if (isTensionConfig) {
      config.frequency = undefined;
    }
  }
}

const emptyArray = [];
/** @internal */

/** An animation being executed by the frameloop */
class Animation {
  constructor() {
    this.changed = false;
    this.values = emptyArray;
    this.toValues = null;
    this.fromValues = emptyArray;
    this.to = void 0;
    this.from = void 0;
    this.config = new AnimationConfig();
    this.immediate = false;
    this.onStart = void 0;
    this.onChange = void 0;
    this.onRest = [];
  }

}

// @see https://github.com/alexreardon/use-memo-one/pull/10
const core_useMemo = (create, deps) => useMemoOne(create, deps || [{}]);
function callProp(value, ...args) {
  return esm.is.fun(value) ? value(...args) : value;
}
/** Try to coerce the given value into a boolean using the given key */

const matchProp = (value, key) => value === true || !!(key && value && (esm.is.fun(value) ? value(key) : (0,esm.toArray)(value).includes(key)));
const getProps = (props, i, arg) => props && (esm.is.fun(props) ? props(i, arg) : esm.is.arr(props) ? props[i] : extends_extends({}, props));
/** Returns `true` if the given prop is having its default value set. */

const hasDefaultProp = (props, key) => !esm.is.und(getDefaultProp(props, key));
/** Get the default value being set for the given `key` */

const getDefaultProp = (props, key) => props.default === true ? props[key] : props.default ? props.default[key] : undefined;
/**
 * Extract the default props from an update.
 *
 * When the `default` prop is falsy, this function still behaves as if
 * `default: true` was used. The `default` prop is always respected when
 * truthy.
 */

const getDefaultProps = (props, omitKeys = [], defaults = {}) => {
  let keys = DEFAULT_PROPS;

  if (props.default && props.default !== true) {
    props = props.default;
    keys = Object.keys(props);
  }

  for (const key of keys) {
    const value = props[key];

    if (!esm.is.und(value) && !omitKeys.includes(key)) {
      defaults[key] = value;
    }
  }

  return defaults;
};
/** Merge the default props of an update into a props cache. */

const mergeDefaultProps = (defaults, props, omitKeys) => getDefaultProps(props, omitKeys, defaults);
/** These props can have default values */

const DEFAULT_PROPS = ['pause', 'cancel', 'config', 'immediate', 'onDelayEnd', 'onProps', 'onStart', 'onChange', 'onRest'];
const RESERVED_PROPS = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  default: 1,
  delay: 1,
  onDelayEnd: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onRest: 1,
  // Transition props
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  // Internal props
  keys: 1,
  callId: 1,
  parentId: 1
};
/**
 * Extract any properties whose keys are *not* reserved for customizing your
 * animations. All hooks use this function, which means `useTransition` props
 * are reserved for `useSpring` calls, etc.
 */

function getForwardProps(props) {
  const forward = {};
  let count = 0;
  (0,esm.each)(props, (value, prop) => {
    if (!RESERVED_PROPS[prop]) {
      forward[prop] = value;
      count++;
    }
  });

  if (count) {
    return forward;
  }
}
/**
 * Clone the given `props` and move all non-reserved props
 * into the `to` prop.
 */


function inferTo(props) {
  const to = getForwardProps(props);

  if (to) {
    const out = {
      to
    };
    (0,esm.each)(props, (val, key) => key in to || (out[key] = val));
    return out;
  }

  return extends_extends({}, props);
} // Compute the goal value, converting "red" to "rgba(255, 0, 0, 1)" in the process

function computeGoal(value) {
  const config = (0,esm.getFluidConfig)(value);
  return config ? computeGoal(config.get()) : esm.is.arr(value) ? value.map(computeGoal) : (0,esm.isAnimatedString)(value) ? (0,globals.createStringInterpolator)({
    range: [0, 1],
    output: [value, value]
  })(1) : value;
}

/**
 * This function sets a timeout if both the `delay` prop exists and
 * the `cancel` prop is not `true`.
 *
 * The `actions.start` function must handle the `cancel` prop itself,
 * but the `pause` prop is taken care of.
 */
function scheduleProps(callId, {
  key,
  props,
  state,
  actions
}) {
  return new Promise((resolve, reject) => {
    let delay;
    let timeout;
    let pause = false;
    let cancel = matchProp(props.cancel, key);

    if (cancel) {
      onStart();
    } else {
      delay = callProp(props.delay || 0, key);
      pause = matchProp(props.pause, key);

      if (pause) {
        state.resumeQueue.add(onResume);
        actions.pause();
      } else {
        actions.resume();
        onResume();
      }
    }

    function onPause() {
      state.resumeQueue.add(onResume);
      timeout.cancel(); // Cache the remaining delay.

      delay = timeout.time - esm.Globals.now();
    }

    function onResume() {
      if (delay > 0) {
        state.pauseQueue.add(onPause);
        timeout = esm.Globals.frameLoop.setTimeout(onStart, delay);
      } else {
        onStart();
      }
    }

    function onStart() {
      state.pauseQueue.delete(onPause); // Maybe cancelled during its delay.

      if (callId <= (state.cancelId || 0)) {
        cancel = true;
      }

      try {
        actions.start(extends_extends(extends_extends({}, props), {}, {
          callId,
          delay,
          cancel,
          pause
        }), resolve);
      } catch (err) {
        reject(err);
      }
    }
  });
}

/** @internal */

/** The object given to the `onRest` prop and `start` promise. */

/** The promised result of an animation. */

/** @internal */
const getCombinedResult = (target, results) => results.length == 1 ? results[0] : results.some(result => result.cancelled) ? getCancelledResult(target) : results.every(result => result.noop) ? getNoopResult(target) : getFinishedResult(target, results.every(result => result.finished));
/** No-op results are for updates that never start an animation. */

const getNoopResult = (target, value = target.get()) => ({
  value,
  noop: true,
  finished: true,
  target
});
const getFinishedResult = (target, finished, value = target.get()) => ({
  value,
  finished,
  target
});
const getCancelledResult = (target, value = target.get()) => ({
  value,
  cancelled: true,
  target
});

/**
 * Start an async chain or an async script.
 *
 * Always call `runAsync` in the action callback of a `scheduleProps` call.
 *
 * The `T` parameter can be a set of animated values (as an object type)
 * or a primitive type for a single animated value.
 */
async function runAsync(to, props, state, target) {
  if (props.pause) {
    await new Promise(resume => {
      state.resumeQueue.add(resume);
    });
  }

  const {
    callId,
    parentId,
    onRest
  } = props;
  const {
    asyncTo: prevTo,
    promise: prevPromise
  } = state;

  if (!parentId && to === prevTo && !props.reset) {
    return prevPromise;
  }

  return state.promise = (async () => {
    state.asyncId = callId;
    state.asyncTo = to; // The default props of any `animate` calls.

    const defaultProps = getDefaultProps(props, [// The `onRest` prop is only called when the `runAsync` promise is resolved.
    'onRest']);
    let preventBail;
    let bail; // This promise is rejected when the animation is interrupted.

    const bailPromise = new Promise((resolve, reject) => (preventBail = resolve, bail = reject)); // Stop animating when an error is caught.

    const withBailHandler = fn => (...args) => {
      const onError = err => {
        if (err instanceof BailSignal) {
          bail(err); // Stop animating.
        }

        throw err;
      };

      try {
        return fn(...args).catch(onError);
      } catch (err) {
        onError(err);
      }
    };

    const bailIfEnded = bailSignal => {
      const bailResult = // The `cancel` prop or `stop` method was used.
      callId <= (state.cancelId || 0) && getCancelledResult(target) || // The async `to` prop was replaced.
      callId !== state.asyncId && getFinishedResult(target, false);

      if (bailResult) {
        bailSignal.result = bailResult;
        throw bailSignal;
      }
    }; // Note: This function cannot use the `async` keyword, because we want the
    // `throw` statements to interrupt the caller.


    const animate = withBailHandler((arg1, arg2) => {
      const bailSignal = new BailSignal();
      bailIfEnded(bailSignal);
      const props = esm.is.obj(arg1) ? extends_extends({}, arg1) : extends_extends(extends_extends({}, arg2), {}, {
        to: arg1
      });
      props.parentId = callId;
      (0,esm.each)(defaultProps, (value, key) => {
        if (esm.is.und(props[key])) {
          props[key] = value;
        }
      });
      return target.start(props).then(async result => {
        bailIfEnded(bailSignal);

        if (target.is('PAUSED')) {
          await new Promise(resume => {
            state.resumeQueue.add(resume);
          });
        }

        return result;
      });
    });
    let result;

    try {
      let animating; // Async sequence

      if (esm.is.arr(to)) {
        animating = (async queue => {
          for (const props of queue) {
            await animate(props);
          }
        })(to);
      } // Async script
      else if (esm.is.fun(to)) {
          animating = Promise.resolve(to(animate, target.stop.bind(target)));
        }

      await Promise.all([animating.then(preventBail), bailPromise]);
      result = getFinishedResult(target, true); // Bail handling
    } catch (err) {
      if (err instanceof BailSignal) {
        result = err.result;
      } else {
        throw err;
      } // Reset the async state.

    } finally {
      if (callId == state.asyncId) {
        state.asyncId = parentId;
        state.asyncTo = parentId ? prevTo : undefined;
        state.promise = parentId ? prevPromise : undefined;
      }
    }

    if (esm.is.fun(onRest)) {
      (0,globals.batchedUpdates)(() => {
        onRest(result);
      });
    }

    return result;
  })();
}
function cancelAsync(state, callId) {
  state.cancelId = callId;
  state.asyncId = state.asyncTo = state.promise = undefined;
}
/** This error is thrown to signal an interrupted async animation. */

class BailSignal extends Error {
  constructor() {
    super('An async animation has been interrupted. You see this error because you ' + 'forgot to use `await` or `.catch(...)` on its returned promise.');
    this.result = void 0;
  }

}

const isFrameValue = value => value instanceof FrameValue;
let nextId = 1;
/**
 * A kind of `FluidValue` that manages an `AnimatedValue` node.
 *
 * Its underlying value can be accessed and even observed.
 */

class FrameValue extends esm.FluidValue {
  constructor(...args) {
    super(...args);
    this.id = nextId++;
    this.key = void 0;
    this._priority = 0;
    this._children = new Set();
  }

  get priority() {
    return this._priority;
  }

  set priority(priority) {
    if (this._priority != priority) {
      this._priority = priority;

      this._onPriorityChange(priority);
    }
  }
  /** Get the current value */


  get() {
    const node = (0,animated/* getAnimated */.ys)(this);
    return node && node.getValue();
  }
  /** Create a spring that maps our value to another value */


  to(...args) {
    return (0,globals.to)(this, args);
  }
  /** @deprecated Use the `to` method instead. */


  interpolate(...args) {
    deprecations_deprecateInterpolate();
    return (0,globals.to)(this, args);
  }
  /** @internal */


  /** @internal */
  addChild(child) {
    if (!this._children.size) this._attach();

    this._children.add(child);
  }
  /** @internal */


  removeChild(child) {
    this._children.delete(child);

    if (!this._children.size) this._detach();
  }
  /** @internal */


  onParentChange({
    type
  }) {
    if (this.idle) {
      // Start animating when a parent does.
      if (type == 'start') {
        this._reset();

        this._start();
      }
    } // Reset our animation state when a parent does, but only when
    // our animation is active.
    else if (type == 'reset') {
        this._reset();
      }
  }
  /** Called when the first child is added. */


  _attach() {}
  /** Called when the last child is removed. */


  _detach() {}
  /**
   * Reset our animation state (eg: start values, velocity, etc)
   * and tell our children to do the same.
   *
   * This is called when our goal value is changed during (or before)
   * an animation.
   */


  _reset() {
    this._emit({
      type: 'reset',
      parent: this
    });
  }
  /**
   * Start animating if possible.
   *
   * Note: Be sure to call `_reset` first, or the animation will break.
   * This method would like to call `_reset` for you, but that would
   * interfere with paused animations.
   */


  _start() {
    this._emit({
      type: 'start',
      parent: this
    });
  }
  /** Tell our children about our new value */


  _onChange(value, idle = false) {
    this._emit({
      type: 'change',
      parent: this,
      value,
      idle
    });
  }
  /** Tell our children about our new priority */


  _onPriorityChange(priority) {
    if (!this.idle) {
      // Make the frameloop aware of our new priority.
      globals.frameLoop.start(this);
    }

    this._emit({
      type: 'priority',
      parent: this,
      priority
    });
  }

  _emit(event) {
    // Clone "_children" so it can be safely mutated inside the loop.
    (0,esm.each)(Array.from(this._children), child => {
      child.onParentChange(event);
    });
  }

}

// TODO: use "const enum" when Babel supports it

/** The spring has not animated yet */
const CREATED = 'CREATED';
/** The spring has animated before */

const IDLE = 'IDLE';
/** The spring is animating */

const ACTIVE = 'ACTIVE';
/** The spring is frozen in time */

const PAUSED = 'PAUSED';
/** The spring cannot be animated */

const DISPOSED = 'DISPOSED';

/**
 * Only numbers, strings, and arrays of numbers/strings are supported.
 * Non-animatable strings are also supported.
 */
class SpringValue extends FrameValue {
  /** The property name used when `to` or `from` is an object. Useful when debugging too. */

  /** The animation state */

  /** The queue of pending props */

  /** The lifecycle phase of this spring */

  /** The state for `runAsync` calls */

  /** Some props have customizable default values */

  /** The counter for tracking `scheduleProps` calls */

  /** The last `scheduleProps` call that changed the `to` prop */
  constructor(arg1, arg2) {
    super();
    this.key = void 0;
    this.animation = new Animation();
    this.queue = void 0;
    this._phase = CREATED;
    this._state = {
      pauseQueue: new Set(),
      resumeQueue: new Set()
    };
    this._defaultProps = {};
    this._lastCallId = 0;
    this._lastToId = 0;

    if (!esm.is.und(arg1) || !esm.is.und(arg2)) {
      const props = esm.is.obj(arg1) ? extends_extends({}, arg1) : extends_extends(extends_extends({}, arg2), {}, {
        from: arg1
      });
      props.default = true;
      this.start(props);
    }
  }

  get idle() {
    return !this.is(ACTIVE) && !this._state.asyncTo;
  }

  get goal() {
    return (0,esm.getFluidValue)(this.animation.to);
  }

  get velocity() {
    const node = (0,animated/* getAnimated */.ys)(this);
    return node instanceof animated/* AnimatedValue */.iG ? node.lastVelocity || 0 : node.getPayload().map(node => node.lastVelocity || 0);
  }
  /** Advance the current animation by a number of milliseconds */


  advance(dt) {
    let idle = true;
    let changed = false;
    const anim = this.animation;
    let {
      config,
      toValues
    } = anim;
    const payload = (0,animated/* getPayload */.He)(anim.to);

    if (!payload) {
      const toConfig = (0,esm.getFluidConfig)(anim.to);

      if (toConfig) {
        toValues = (0,esm.toArray)(toConfig.get());
      }
    }

    anim.values.forEach((node, i) => {
      if (node.done) return; // The "anim.toValues" array must exist when no parent exists.

      let to = payload ? payload[i].lastPosition : toValues[i];
      let finished = anim.immediate;
      let position = to;

      if (!finished) {
        position = node.lastPosition; // Loose springs never move.

        if (config.tension <= 0) {
          node.done = true;
          return;
        }

        const elapsed = node.elapsedTime += dt;
        const from = anim.fromValues[i];
        const v0 = node.v0 != null ? node.v0 : node.v0 = esm.is.arr(config.velocity) ? config.velocity[i] : config.velocity;
        let velocity; // Duration easing

        if (!esm.is.und(config.duration)) {
          let p = config.progress || 0;
          if (config.duration <= 0) p = 1;else p += (1 - p) * Math.min(1, elapsed / config.duration);
          position = from + config.easing(p) * (to - from);
          velocity = (position - node.lastPosition) / dt;
          finished = p == 1;
        } // Decay easing
        else if (config.decay) {
            const decay = config.decay === true ? 0.998 : config.decay;
            const e = Math.exp(-(1 - decay) * elapsed);
            position = from + v0 / (1 - decay) * (1 - e);
            finished = Math.abs(node.lastPosition - position) < 0.1; // derivative of position

            velocity = v0 * e;
          } // Spring easing
          else {
              velocity = node.lastVelocity == null ? v0 : node.lastVelocity;
              /** The smallest distance from a value before being treated like said value. */

              const precision = config.precision || (from == to ? 0.005 : Math.min(1, Math.abs(to - from) * 0.001));
              /** The velocity at which movement is essentially none */

              const restVelocity = config.restVelocity || precision / 10; // Bouncing is opt-in (not to be confused with overshooting)

              const bounceFactor = config.clamp ? 0 : config.bounce;
              const canBounce = !esm.is.und(bounceFactor);
              /** When `true`, the value is increasing over time */

              const isGrowing = from == to ? node.v0 > 0 : from < to;
              /** When `true`, the velocity is considered moving */

              let isMoving;
              /** When `true`, the velocity is being deflected or clamped */

              let isBouncing = false;
              const step = 1; // 1ms

              const numSteps = Math.ceil(dt / step);

              for (let n = 0; n < numSteps; ++n) {
                isMoving = Math.abs(velocity) > restVelocity;

                if (!isMoving) {
                  finished = Math.abs(to - position) <= precision;

                  if (finished) {
                    break;
                  }
                }

                if (canBounce) {
                  isBouncing = position == to || position > to == isGrowing; // Invert the velocity with a magnitude, or clamp it.

                  if (isBouncing) {
                    velocity = -velocity * bounceFactor;
                    position = to;
                  }
                }

                const springForce = -config.tension * 0.000001 * (position - to);
                const dampingForce = -config.friction * 0.001 * velocity;
                const acceleration = (springForce + dampingForce) / config.mass; // pt/ms^2

                velocity = velocity + acceleration * step; // pt/ms

                position = position + velocity * step;
              }
            }

        node.lastVelocity = velocity;

        if (Number.isNaN(position)) {
          console.warn("Got NaN while animating:", this);
          finished = true;
        }
      } // Parent springs must finish before their children can.


      if (payload && !payload[i].done) {
        finished = false;
      }

      if (finished) {
        node.done = true;
      } else {
        idle = false;
      }

      if (node.setValue(position, config.round)) {
        changed = true;
      }
    });

    if (idle) {
      this.finish();
    } else if (changed) {
      this._onChange(this.get());
    }

    return idle;
  }
  /** Check the current phase */


  is(phase) {
    return this._phase == phase;
  }
  /** Set the current value, while stopping the current animation */


  set(value) {
    (0,globals.batchedUpdates)(() => {
      this._focus(value);

      if (this._set(value)) {
        // Ensure change observers are notified. When active,
        // the "_stop" method handles this.
        if (!this.is(ACTIVE)) {
          return this._onChange(this.get(), true);
        }
      }

      this._stop();
    });
    return this;
  }
  /**
   * Freeze the active animation in time.
   * This does nothing when not animating.
   */


  pause() {
    checkDisposed(this, 'pause');

    if (!this.is(PAUSED)) {
      this._phase = PAUSED;
      (0,esm.flush)(this._state.pauseQueue, onPause => onPause());
    }
  }
  /** Resume the animation if paused. */


  resume() {
    checkDisposed(this, 'resume');

    if (this.is(PAUSED)) {
      this._start();

      (0,esm.flush)(this._state.resumeQueue, onResume => onResume());
    }
  }
  /**
   * Skip to the end of the current animation.
   *
   * All `onRest` callbacks are passed `{finished: true}`
   */


  finish(to) {
    this.resume();

    if (this.is(ACTIVE)) {
      const anim = this.animation; // Decay animations have an implicit goal.

      if (!anim.config.decay && esm.is.und(to)) {
        to = anim.to;
      } // Set the value if we can.


      if (!esm.is.und(to)) {
        this._set(to);
      }

      (0,globals.batchedUpdates)(() => {
        // Ensure the "onStart" and "onRest" props are called.
        if (!anim.changed) {
          anim.changed = true;

          if (anim.onStart) {
            anim.onStart(this);
          }
        } // Exit the frameloop.


        this._stop();
      });
    }

    return this;
  }
  /** Push props into the pending queue. */


  update(props) {
    checkDisposed(this, 'update');
    const queue = this.queue || (this.queue = []);
    queue.push(props);
    return this;
  }
  /**
   * Update this value's animation using the queue of pending props,
   * and unpause the current animation (if one is frozen).
   *
   * When arguments are passed, a new animation is created, and the
   * queued animations are left alone.
   */


  async start(to, arg2) {
    checkDisposed(this, 'start');
    let queue;

    if (!esm.is.und(to)) {
      queue = [esm.is.obj(to) ? to : extends_extends(extends_extends({}, arg2), {}, {
        to
      })];
    } else {
      queue = this.queue || [];
      this.queue = [];
    }

    const results = await Promise.all(queue.map(props => this._update(props)));
    return getCombinedResult(this, results);
  }
  /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */


  stop(cancel) {
    if (!this.is(DISPOSED)) {
      cancelAsync(this._state, this._lastCallId); // Ensure the `to` value equals the current value.

      this._focus(this.get()); // Exit the frameloop and notify `onRest` listeners.


      (0,globals.batchedUpdates)(() => this._stop(cancel));
    }

    return this;
  }
  /** Restart the animation. */


  reset() {
    this._update({
      reset: true
    });
  }
  /** Prevent future animations, and stop the current animation */


  dispose() {
    if (!this.is(DISPOSED)) {
      if (this.animation) {
        // Prevent "onRest" calls when disposed.
        this.animation.onRest = [];
      }

      this.stop();
      this._phase = DISPOSED;
    }
  }
  /** @internal */


  onParentChange(event) {
    super.onParentChange(event);

    if (event.type == 'change') {
      if (!this.is(ACTIVE)) {
        this._reset();

        if (!this.is(PAUSED)) {
          this._start();
        }
      }
    } else if (event.type == 'priority') {
      this.priority = event.priority + 1;
    }
  }
  /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */


  _prepareNode({
    to,
    from,
    reverse
  }) {
    const key = this.key || '';
    to = !esm.is.obj(to) || (0,esm.getFluidConfig)(to) ? to : to[key];
    from = !esm.is.obj(from) || (0,esm.getFluidConfig)(from) ? from : from[key]; // Create the range now to avoid "reverse" logic.

    const range = {
      to,
      from
    }; // Before ever animating, this method ensures an `Animated` node
    // exists and keeps its value in sync with the "from" prop.

    if (this.is(CREATED)) {
      if (reverse) [to, from] = [from, to];
      from = (0,esm.getFluidValue)(from);

      const node = this._updateNode(esm.is.und(from) ? (0,esm.getFluidValue)(to) : from);

      if (node && !esm.is.und(from)) {
        node.setValue(from);
      }
    }

    return range;
  }
  /**
   * Create an `Animated` node if none exists or the given value has an
   * incompatible type. Do nothing if `value` is undefined.
   *
   * The newest `Animated` node is returned.
   */


  _updateNode(value) {
    let node = (0,animated/* getAnimated */.ys)(this);

    if (!esm.is.und(value)) {
      const nodeType = this._getNodeType(value);

      if (!node || node.constructor !== nodeType) {
        (0,animated/* setAnimated */.f3)(this, node = nodeType.create(value));
      }
    }

    return node;
  }
  /** Return the `Animated` node constructor for a given value */


  _getNodeType(value) {
    const parentNode = (0,animated/* getAnimated */.ys)(value);
    return parentNode ? parentNode.constructor : esm.is.arr(value) ? animated/* AnimatedArray */["if"] : (0,esm.isAnimatedString)(value) ? animated/* AnimatedString */.eC : animated/* AnimatedValue */.iG;
  }
  /** Schedule an animation to run after an optional delay */


  _update(props, isLoop) {
    const defaultProps = this._defaultProps;

    const mergeDefaultProp = key => {
      const value = getDefaultProp(props, key);

      if (!esm.is.und(value)) {
        defaultProps[key] = value;
      } // For `cancel` and `pause`, a truthy default always wins.


      if (defaultProps[key]) {
        props[key] = defaultProps[key];
      }
    }; // These props are coerced into booleans by the `scheduleProps` function,
    // so they need their default values processed before then.


    mergeDefaultProp('cancel');
    mergeDefaultProp('pause'); // Ensure the initial value can be accessed by animated components.

    const range = this._prepareNode(props);

    return scheduleProps(++this._lastCallId, {
      key: this.key,
      props,
      state: this._state,
      actions: {
        pause: this.pause.bind(this),
        resume: this.resume.bind(this),
        start: this._merge.bind(this, range)
      }
    }).then(result => {
      if (props.loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = createLoopUpdate(props);

        if (nextProps) {
          return this._update(nextProps, true);
        }
      }

      return result;
    });
  }
  /** Merge props into the current animation */


  _merge(range, props, resolve) {
    // The "cancel" prop cancels all pending delays and it forces the
    // active animation to stop where it is.
    if (props.cancel) {
      this.stop(true);
      return resolve(getCancelledResult(this));
    }

    const {
      key,
      animation: anim
    } = this;
    const defaultProps = this._defaultProps;
    /** The "to" prop is defined. */

    const hasToProp = !esm.is.und(range.to);
    /** The "from" prop is defined. */

    const hasFromProp = !esm.is.und(range.from); // Avoid merging other props if implicitly prevented, except
    // when both the "to" and "from" props are undefined.

    if (hasToProp || hasFromProp) {
      if (props.callId > this._lastToId) {
        this._lastToId = props.callId;
      } else {
        return resolve(getCancelledResult(this));
      }
    }
    /** Get the value of a prop, or its default value */


    const get = prop => !esm.is.und(props[prop]) ? props[prop] : defaultProps[prop]; // Call "onDelayEnd" before merging props, but after cancellation checks.


    const onDelayEnd = coerceEventProp(get('onDelayEnd'), key);

    if (onDelayEnd) {
      onDelayEnd(props, this);
    }

    if (props.default) {
      mergeDefaultProps(defaultProps, props, ['pause', 'cancel']);
    }

    const {
      to: prevTo,
      from: prevFrom
    } = anim;
    let {
      to = prevTo,
      from = prevFrom
    } = range; // Focus the "from" value if changing without a "to" value.

    if (hasFromProp && !hasToProp) {
      to = from;
    } // Flip the current range if "reverse" is true.


    if (props.reverse) [to, from] = [from, to];
    /** The "from" value is changing. */

    const hasFromChanged = !(0,esm.isEqual)(from, prevFrom);

    if (hasFromChanged) {
      anim.from = from;
    }
    /** The "to" value is changing. */


    const hasToChanged = !(0,esm.isEqual)(to, prevTo);

    if (hasToChanged) {
      this._focus(to);
    } // Both "from" and "to" can use a fluid config (thanks to http://npmjs.org/fluids).


    const toConfig = (0,esm.getFluidConfig)(to);
    const fromConfig = (0,esm.getFluidConfig)(from);

    if (fromConfig) {
      from = fromConfig.get();
    }
    /** The "to" prop is async. */


    const hasAsyncTo = esm.is.arr(props.to) || esm.is.fun(props.to);
    const {
      config
    } = anim;
    const {
      decay,
      velocity
    } = config; // The "runAsync" function treats the "config" prop as a default,
    // so we must avoid merging it when the "to" prop is async.

    if (props.config && !hasAsyncTo) {
      mergeConfig(config, callProp(props.config, key), // Avoid calling the same "config" prop twice.
      props.config !== defaultProps.config ? callProp(defaultProps.config, key) : void 0);
    } // This instance might not have its Animated node yet. For example,
    // the constructor can be given props without a "to" or "from" value.


    let node = (0,animated/* getAnimated */.ys)(this);

    if (!node || esm.is.und(to)) {
      return resolve(getFinishedResult(this, true));
    }
    /** When true, start at the "from" value. */


    const reset = // When `reset` is undefined, the `from` prop implies `reset: true`,
    // except for declarative updates. When `reset` is defined, there
    // must exist a value to animate from.
    esm.is.und(props.reset) ? hasFromProp && !props.default : !esm.is.und(from) && matchProp(props.reset, key); // The current value, where the animation starts from.

    const value = reset ? from : this.get(); // The animation ends at this value, unless "to" is fluid.

    const goal = computeGoal(to); // Only specific types can be animated to/from.

    const isAnimatable = esm.is.num(goal) || esm.is.arr(goal) || (0,esm.isAnimatedString)(goal); // When true, the value changes instantly on the next frame.

    const immediate = !hasAsyncTo && (!isAnimatable || matchProp(defaultProps.immediate || props.immediate, key));

    if (hasToChanged) {
      if (immediate) {
        node = this._updateNode(goal);
      } else {
        const nodeType = this._getNodeType(to);

        if (nodeType !== node.constructor) {
          throw Error("Cannot animate between " + node.constructor.name + " and " + nodeType.name + ", as the \"to\" prop suggests");
        }
      }
    } // The type of Animated node for the goal value.


    const goalType = node.constructor; // When the goal value is fluid, we don't know if its value
    // will change before the next animation frame, so it always
    // starts the animation to be safe.

    let started = !!toConfig;
    let finished = false;

    if (!started) {
      // When true, the current value has probably changed.
      const hasValueChanged = reset || this.is(CREATED) && hasFromChanged; // When the "to" value or current value are changed,
      // start animating if not already finished.

      if (hasToChanged || hasValueChanged) {
        finished = (0,esm.isEqual)(computeGoal(value), goal);
        started = !finished;
      } // Changing "decay" or "velocity" starts the animation.


      if (!(0,esm.isEqual)(config.decay, decay) || !(0,esm.isEqual)(config.velocity, velocity)) {
        started = true;
      }
    } // When an active animation changes its goal to its current value:


    if (finished && this.is(ACTIVE)) {
      // Avoid an abrupt stop unless the animation is being reset.
      if (anim.changed && !reset) {
        started = true;
      } // Stop the animation before its first frame.
      else if (!started) {
          this._stop();
        }
    }

    if (!hasAsyncTo) {
      // Make sure our "toValues" are updated even if our previous
      // "to" prop is a fluid value whose current value is also ours.
      if (started || (0,esm.getFluidConfig)(prevTo)) {
        anim.values = node.getPayload();
        anim.toValues = toConfig ? null : goalType == animated/* AnimatedString */.eC ? [1] : (0,esm.toArray)(goal);
      }

      anim.immediate = immediate;
      anim.onStart = coerceEventProp(get('onStart'), key);
      anim.onChange = coerceEventProp(get('onChange'), key); // The "reset" prop tries to reuse the old "onRest" prop,
      // unless you defined a new "onRest" prop.

      const onRestQueue = anim.onRest;
      const onRest = reset && !props.onRest ? onRestQueue[0] || esm.noop : checkFinishedOnRest(coerceEventProp(get('onRest'), key), this); // In most cases, the animation after this one won't reuse our
      // "onRest" prop. Instead, the _default_ "onRest" prop is used
      // when the next animation has an undefined "onRest" prop.

      if (started) {
        anim.onRest = [onRest, checkFinishedOnRest(resolve, this)]; // Flush the "onRest" queue for the previous animation.

        let onRestIndex = reset ? 0 : 1;

        if (onRestIndex < onRestQueue.length) {
          (0,globals.batchedUpdates)(() => {
            for (; onRestIndex < onRestQueue.length; onRestIndex++) {
              onRestQueue[onRestIndex]();
            }
          });
        }
      } // The "onRest" prop is always first, and it can be updated even
      // if a new animation is not started by this update.
      else if (reset || props.onRest) {
          anim.onRest[0] = onRest;
        }
    } // By this point, every prop has been merged.


    const onProps = coerceEventProp(get('onProps'), key);

    if (onProps) {
      onProps(props, this);
    } // Update our node even if the animation is idle.


    if (reset) {
      node.setValue(value);
    }

    if (hasAsyncTo) {
      resolve(runAsync(props.to, props, this._state, this));
    } // Start an animation
    else if (started) {
        // Must be idle for "onStart" to be called again.
        if (reset) this._phase = IDLE;

        this._reset();

        this._start();
      } // Postpone promise resolution until the animation is finished,
      // so that no-op updates still resolve at the expected time.
      else if (this.is(ACTIVE) && !hasToChanged) {
          anim.onRest.push(checkFinishedOnRest(resolve, this));
        } // Resolve our promise immediately.
        else {
            resolve(getNoopResult(this, value));
          }
  }
  /** Update the `animation.to` value, which might be a `FluidValue` */


  _focus(value) {
    const anim = this.animation;

    if (value !== anim.to) {
      let config = (0,esm.getFluidConfig)(anim.to);

      if (config) {
        config.removeChild(this);
      }

      anim.to = value;
      let priority = 0;

      if (config = (0,esm.getFluidConfig)(value)) {
        config.addChild(this);

        if (isFrameValue(value)) {
          priority = (value.priority || 0) + 1;
        }
      }

      this.priority = priority;
    }
  }
  /** Set the current value and our `node` if necessary. The `_onChange` method is *not* called. */


  _set(value) {
    const config = (0,esm.getFluidConfig)(value);

    if (config) {
      value = config.get();
    }

    const node = (0,animated/* getAnimated */.ys)(this);
    const oldValue = node && node.getValue();

    if (node) {
      node.setValue(value);
    } else {
      this._updateNode(value);
    }

    return !(0,esm.isEqual)(value, oldValue);
  }

  _onChange(value, idle = false) {
    const anim = this.animation; // The "onStart" prop is called on the first change after entering the
    // frameloop, but never for immediate animations.

    if (!anim.changed && !idle) {
      anim.changed = true;

      if (anim.onStart) {
        anim.onStart(this);
      }
    }

    if (anim.onChange) {
      anim.onChange(value, this);
    }

    super._onChange(value, idle);
  }

  _reset() {
    const anim = this.animation; // Reset the state of each Animated node.

    (0,animated/* getAnimated */.ys)(this).reset(anim.to); // Ensure the `onStart` prop will be called.

    if (!this.is(ACTIVE)) {
      anim.changed = false;
    } // Use the current values as the from values.


    if (!anim.immediate) {
      anim.fromValues = anim.values.map(node => node.lastPosition);
    }

    super._reset();
  }

  _start() {
    if (!this.is(ACTIVE)) {
      this._phase = ACTIVE;

      super._start(); // The "skipAnimation" global avoids the frameloop.


      if (globals.skipAnimation) {
        this.finish();
      } else {
        globals.frameLoop.start(this);
      }
    }
  }
  /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */


  _stop(cancel) {
    this.resume();

    if (this.is(ACTIVE)) {
      this._phase = IDLE; // Always let change observers know when a spring becomes idle.

      this._onChange(this.get(), true);

      const anim = this.animation;
      (0,esm.each)(anim.values, node => {
        node.done = true;
      });
      const onRestQueue = anim.onRest;

      if (onRestQueue.length) {
        // Preserve the "onRest" prop when the goal is dynamic.
        anim.onRest = [anim.toValues ? esm.noop : onRestQueue[0]]; // Never call the "onRest" prop for no-op animations.

        if (!anim.changed) {
          onRestQueue[0] = esm.noop;
        }

        (0,esm.each)(onRestQueue, onRest => onRest(cancel));
      }
    }
  }

}

function checkDisposed(spring, name) {
  if (spring.is(DISPOSED)) {
    throw Error("Cannot call \"" + name + "\" of disposed \"" + spring.constructor.name + "\" object");
  }
}
/** Coerce an event prop to an event handler */


function coerceEventProp(prop, key) {
  return esm.is.fun(prop) ? prop : key && prop ? prop[key] : undefined;
}
/**
 * The "finished" value is determined by each "onRest" handler,
 * based on whether the current value equals the goal value that
 * was calculated at the time the "onRest" handler was set.
 */


const checkFinishedOnRest = (onRest, spring) => {
  const {
    to
  } = spring.animation;
  return onRest ? cancel => {
    if (cancel) {
      onRest(getCancelledResult(spring));
    } else {
      const goal = computeGoal(to);
      const value = computeGoal(spring.get());
      const finished = (0,esm.isEqual)(value, goal);
      onRest(getFinishedResult(spring, finished));
    }
  } : esm.noop;
};

function createLoopUpdate(props, loop = props.loop, to = props.to) {
  let loopRet = callProp(loop);

  if (loopRet) {
    const overrides = loopRet !== true && inferTo(loopRet);
    const reverse = (overrides || props).reverse;
    const reset = !overrides || overrides.reset;
    return createUpdate(extends_extends(extends_extends({}, props), {}, {
      loop,
      // Avoid updating default props when looping.
      default: false,
      // For the "reverse" prop to loop as expected, the "to" prop
      // must be undefined. The "reverse" prop is ignored when the
      // "to" prop is an array or function.
      to: !reverse || esm.is.arr(to) || esm.is.fun(to) ? to : undefined,
      // Avoid defining the "from" prop if a reset is unwanted.
      from: reset ? props.from : undefined,
      reset
    }, overrides));
  }
}
/**
 * Return a new object based on the given `props`.
 *
 * - All unreserved props are moved into the `to` prop object.
 * - The `to` and `from` props are deleted when falsy.
 * - The `keys` prop is set to an array of affected keys,
 *   or `null` if all keys are affected.
 */

function createUpdate(props) {
  const {
    to,
    from
  } = props = inferTo(props); // Collect the keys affected by this update.

  const keys = new Set();

  if (from) {
    findDefined(from, keys);
  } else {
    // Falsy values are deleted to avoid merging issues.
    delete props.from;
  }

  if (esm.is.obj(to)) {
    findDefined(to, keys);
  } else if (!to) {
    // Falsy values are deleted to avoid merging issues.
    delete props.to;
  } // The "keys" prop helps in applying updates to affected keys only.


  props.keys = keys.size ? Array.from(keys) : null;
  return props;
}
/**
 * A modified version of `createUpdate` meant for declarative APIs.
 */

function declareUpdate(props) {
  const update = createUpdate(props);

  if (is.und(update.default)) {
    update.default = getDefaultProps(update, [// Avoid forcing `immediate: true` onto imperative updates.
    update.immediate === true && 'immediate']);
  }

  return update;
}
/** Find keys with defined values */

function findDefined(values, keys) {
  (0,esm.each)(values, (value, key) => value != null && keys.add(key));
}

/** Events batched by the `Controller` class */
const BATCHED_EVENTS = ['onStart', 'onChange', 'onRest'];
let nextId$1 = 1;
/** Queue of pending updates for a `Controller` instance. */

class Controller {
  /** The animated values */

  /** The queue of props passed to the `update` method. */

  /** Custom handler for flushing update queues */

  /** These props are used by all future spring values */

  /** The combined phase of our spring values */

  /** The counter for tracking `scheduleProps` calls */

  /** The values currently being animated */

  /** State used by the `runAsync` function */

  /** The event queues that are flushed once per frame maximum */
  constructor(props, flush) {
    this.id = nextId$1++;
    this.springs = {};
    this.queue = [];
    this._flush = void 0;
    this._initialProps = void 0;
    this._phase = CREATED;
    this._lastAsyncId = 0;
    this._active = new Set();
    this._state = {
      pauseQueue: new Set(),
      resumeQueue: new Set()
    };
    this._events = {
      onStart: new Set(),
      onChange: new Set(),
      onRest: new Map()
    };
    this._onFrame = this._onFrame.bind(this);

    if (flush) {
      this._flush = flush;
    }

    if (props) {
      this.start(props);
    }
  }
  /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */


  get idle() {
    return !this._state.asyncTo && Object.values(this.springs).every(spring => spring.idle);
  }
  /** Check the current phase */


  is(phase) {
    return this._phase == phase;
  }
  /** Get the current values of our springs */


  get() {
    const values = {};
    this.each((spring, key) => values[key] = spring.get());
    return values;
  }
  /** Push an update onto the queue of each value. */


  update(props) {
    if (props) this.queue.push(createUpdate(props));
    return this;
  }
  /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */


  start(props) {
    const queue = props ? (0,esm.toArray)(props).map(createUpdate) : this.queue;

    if (!props) {
      this.queue = [];
    }

    if (this._flush) {
      return this._flush(this, queue);
    }

    prepareKeys(this, queue);
    return flushUpdateQueue(this, queue);
  }
  /** Stop one animation, some animations, or all animations */


  stop(keys) {
    if (esm.is.und(keys)) {
      this.each(spring => spring.stop());
      cancelAsync(this._state, this._lastAsyncId);
    } else {
      const springs = this.springs;
      (0,esm.each)((0,esm.toArray)(keys), key => springs[key].stop());
    }

    return this;
  }
  /** Freeze the active animation in time */


  pause(keys) {
    if (esm.is.und(keys)) {
      this.each(spring => spring.pause());
    } else {
      const springs = this.springs;
      (0,esm.each)((0,esm.toArray)(keys), key => springs[key].pause());
    }

    return this;
  }
  /** Resume the animation if paused. */


  resume(keys) {
    if (esm.is.und(keys)) {
      this.each(spring => spring.resume());
    } else {
      const springs = this.springs;
      (0,esm.each)((0,esm.toArray)(keys), key => springs[key].resume());
    }

    return this;
  }
  /** Restart every animation. */


  reset() {
    this.each(spring => spring.reset()); // TODO: restart async "to" prop

    return this;
  }
  /** Call a function once per spring value */


  each(iterator) {
    (0,esm.each)(this.springs, iterator);
  }
  /** Destroy every spring in this controller */


  dispose() {
    this._state.asyncTo = undefined;
    this.each(spring => spring.dispose());
    this.springs = {};
  }
  /** @internal Called at the end of every animation frame */


  _onFrame() {
    const {
      onStart,
      onChange,
      onRest
    } = this._events;
    const isActive = this._active.size > 0;

    if (isActive && this._phase != ACTIVE) {
      this._phase = ACTIVE;
      (0,esm.flush)(onStart, onStart => onStart(this));
    }

    const values = (onChange.size || !isActive && onRest.size) && this.get();
    (0,esm.flush)(onChange, onChange => onChange(values)); // The "onRest" queue is only flushed when all springs are idle.

    if (!isActive) {
      this._phase = IDLE;
      (0,esm.flush)(onRest, ([onRest, result]) => {
        result.value = values;
        onRest(result);
      });
    }
  }
  /** @internal */


  onParentChange(event) {
    if (event.type == 'change') {
      this._active[event.idle ? 'delete' : 'add'](event.parent);

      globals.frameLoop.onFrame(this._onFrame);
    }
  }

}
/**
 * Warning: Props might be mutated.
 */

function flushUpdateQueue(ctrl, queue) {
  return Promise.all(queue.map(props => flushUpdate(ctrl, props))).then(results => getCombinedResult(ctrl, results));
}
/**
 * Warning: Props might be mutated.
 *
 * Process a single set of props using the given controller.
 *
 * The returned promise resolves to `true` once the update is
 * applied and any animations it starts are finished without being
 * stopped or cancelled.
 */

function flushUpdate(ctrl, props, isLoop) {
  const {
    to,
    loop,
    onRest
  } = props; // Looping must be handled in this function, or else the values
  // would end up looping out-of-sync in many common cases.

  if (loop) {
    props.loop = false;
  }

  const asyncTo = esm.is.arr(to) || esm.is.fun(to) ? to : undefined;

  if (asyncTo) {
    props.to = undefined;
    props.onRest = undefined;
  } else {
    // For certain events, use batching to prevent multiple calls per frame.
    // However, batching is avoided when the `to` prop is async, because any
    // event props are used as default props instead.
    (0,esm.each)(BATCHED_EVENTS, key => {
      const handler = props[key];

      if (esm.is.fun(handler)) {
        const queue = ctrl['_events'][key];

        if (queue instanceof Set) {
          props[key] = () => queue.add(handler);
        } else {
          props[key] = ({
            finished,
            cancelled
          }) => {
            const result = queue.get(handler);

            if (result) {
              if (!finished) result.finished = false;
              if (cancelled) result.cancelled = true;
            } else {
              // The "value" is set before the "handler" is called.
              queue.set(handler, {
                value: null,
                finished,
                cancelled
              });
            }
          };
        }
      }
    });
  }

  const keys = props.keys || Object.keys(ctrl.springs);
  const promises = keys.map(key => ctrl.springs[key].start(props)); // Schedule the "asyncTo" if defined.

  const state = ctrl['_state'];

  if (asyncTo) {
    promises.push(scheduleProps(++ctrl['_lastAsyncId'], {
      props,
      state,
      actions: {
        pause: esm.noop,
        resume: esm.noop,

        start(props, resolve) {
          props.onRest = onRest;

          if (!props.cancel) {
            resolve(runAsync(asyncTo, props, state, ctrl));
          } // Prevent `cancel: true` from ending the current `runAsync` call,
          // except when the default `cancel` prop is being set.
          else if (hasDefaultProp(props, 'cancel')) {
              cancelAsync(state, props.callId);
            }
        }

      }
    }));
  } // Respect the `cancel` prop when no keys are affected.
  else if (!props.keys && props.cancel === true) {
      cancelAsync(state, ctrl['_lastAsyncId']);
    }

  return Promise.all(promises).then(results => {
    const result = getCombinedResult(ctrl, results);

    if (loop && result.finished && !(isLoop && result.noop)) {
      const nextProps = createLoopUpdate(props, loop, to);

      if (nextProps) {
        prepareKeys(ctrl, [nextProps]);
        return flushUpdate(ctrl, nextProps, true);
      }
    }

    return result;
  });
}
/**
 * From an array of updates, get the map of `SpringValue` objects
 * by their keys. Springs are created when any update wants to
 * animate a new key.
 *
 * Springs created by `getSprings` are neither cached nor observed
 * until they're given to `setSprings`.
 */

function getSprings(ctrl, props) {
  const springs = extends_extends({}, ctrl.springs);

  if (props) {
    (0,esm.each)((0,esm.toArray)(props), props => {
      if (esm.is.und(props.keys)) {
        props = createUpdate(props);
      }

      if (!esm.is.obj(props.to)) {
        // Avoid passing array/function to each spring.
        props = extends_extends(extends_extends({}, props), {}, {
          to: undefined
        });
      }

      prepareSprings(springs, props, key => {
        return createSpring(key);
      });
    });
  }

  return springs;
}
/**
 * Tell a controller to manage the given `SpringValue` objects
 * whose key is not already in use.
 */

function setSprings(ctrl, springs) {
  (0,esm.each)(springs, (spring, key) => {
    if (!ctrl.springs[key]) {
      ctrl.springs[key] = spring;
      spring.addChild(ctrl);
    }
  });
}

function createSpring(key, observer) {
  const spring = new SpringValue();
  spring.key = key;

  if (observer) {
    spring.addChild(observer);
  }

  return spring;
}
/**
 * Ensure spring objects exist for each defined key.
 *
 * Using the `props`, the `Animated` node of each `SpringValue` may
 * be created or updated.
 */


function prepareSprings(springs, props, create) {
  if (props.keys) {
    (0,esm.each)(props.keys, key => {
      const spring = springs[key] || (springs[key] = create(key));
      spring['_prepareNode'](props);
    });
  }
}
/**
 * Ensure spring objects exist for each defined key, and attach the
 * `ctrl` to them for observation.
 *
 * The queue is expected to contain `createUpdate` results.
 */


function prepareKeys(ctrl, queue) {
  (0,esm.each)(queue, props => {
    prepareSprings(ctrl.springs, props, key => {
      return createSpring(key, ctrl);
    });
  });
}

/**
 * This context affects all new and existing `SpringValue` objects
 * created with the hook API or the renderprops API.
 */

const ctx = (0,react.createContext)({});
const SpringContext = (_ref) => {
  let {
    children
  } = _ref,
      props = objectWithoutPropertiesLoose_objectWithoutPropertiesLoose(_ref, ["children"]);

  const inherited = (0,react.useContext)(ctx); // Memoize the context to avoid unwanted renders.

  props = core_useMemo(() => extends_extends(extends_extends({}, inherited), props), [inherited, props.pause, props.cancel, props.immediate, props.config]);
  const {
    Provider
  } = ctx;
  return /*#__PURE__*/(0,react.createElement)(Provider, {
    value: props
  }, children);
};
SpringContext.Provider = ctx.Provider;
SpringContext.Consumer = ctx.Consumer;
/** Get the current values of nearest `SpringContext` component. */

const useSpringContext = () => (0,react.useContext)(ctx);

/** Create an imperative API for manipulating an array of `Controller` objects. */
const SpringHandle = {
  create: getControllers => ({
    get controllers() {
      return getControllers();
    },

    update(props) {
      (0,esm.each)(getControllers(), (ctrl, i) => {
        ctrl.update(getProps(props, i, ctrl));
      });
      return this;
    },

    async start(props) {
      const results = await Promise.all(getControllers().map((ctrl, i) => {
        const update = getProps(props, i, ctrl);
        return ctrl.start(update);
      }));
      return {
        value: results.map(result => result.value),
        finished: results.every(result => result.finished)
      };
    },

    stop: keys => (0,esm.each)(getControllers(), ctrl => ctrl.stop(keys)),
    pause: keys => (0,esm.each)(getControllers(), ctrl => ctrl.pause(keys)),
    resume: keys => (0,esm.each)(getControllers(), ctrl => ctrl.resume(keys))
  })
};

/** @internal */
function useSprings(length, props, deps) {
  const propsFn = is.fun(props) && props;
  if (propsFn && !deps) deps = [];
  // Set to 0 to prevent sync flush.
  const layoutId = useRef(0);
  const forceUpdate = useForceUpdate(); // State is updated on commit.

  const [state] = useState(() => ({
    ctrls: [],
    queue: [],

    flush(ctrl, updates) {
      const springs = getSprings(ctrl, updates); // Flushing is postponed until the component's commit phase
      // if a spring was created since the last commit.

      const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs).some(key => !ctrl.springs[key]);
      return canFlushSync ? flushUpdateQueue(ctrl, updates) : new Promise(resolve => {
        setSprings(ctrl, springs);
        state.queue.push(() => {
          resolve(flushUpdateQueue(ctrl, updates));
        });
        forceUpdate();
      });
    }

  })); // The imperative API ref from the props of the first controller.

  const refProp = useRef();
  const ctrls = [...state.ctrls];
  const updates = []; // Cache old controllers to dispose in the commit phase.

  const prevLength = usePrev(length) || 0;
  const disposed = ctrls.slice(length, prevLength); // Create new controllers when "length" increases, and destroy
  // the affected controllers when "length" decreases.

  core_useMemo(() => {
    ctrls.length = length;
    declareUpdates(prevLength, length);
  }, [length]); // Update existing controllers when "deps" are changed.

  core_useMemo(() => {
    declareUpdates(0, Math.min(prevLength, length));
  }, deps);
  /** Fill the `updates` array with declarative updates for the given index range. */

  function declareUpdates(startIndex, endIndex) {
    for (let i = startIndex; i < endIndex; i++) {
      const ctrl = ctrls[i] || (ctrls[i] = new Controller(null, state.flush));
      let update = propsFn ? propsFn(i, ctrl) : props[i];

      if (update) {
        update = updates[i] = declareUpdate(update);

        if (i == 0) {
          refProp.current = update.ref;
          update.ref = undefined;
        }
      }
    }
  }

  const api = useMemo$1(() => {
    return SpringHandle.create(() => state.ctrls);
  }, []); // New springs are created during render so users can pass them to
  // their animated components, but new springs aren't cached until the
  // commit phase (see the `useLayoutEffect` callback below).

  const springs = ctrls.map((ctrl, i) => getSprings(ctrl, updates[i]));
  const context = useSpringContext();
  useLayoutEffect(() => {
    layoutId.current++; // Replace the cached controllers.

    state.ctrls = ctrls; // Update the ref prop.

    if (refProp.current) {
      refProp.current.current = api;
    } // Flush the commit queue.


    const {
      queue
    } = state;

    if (queue.length) {
      state.queue = [];
      each(queue, cb => cb());
    } // Dispose unused controllers.


    each(disposed, ctrl => ctrl.dispose()); // Update existing controllers.

    each(ctrls, (ctrl, i) => {
      const values = springs[i];
      setSprings(ctrl, values); // Update the default props.

      ctrl.start({
        default: context
      }); // Apply updates created during render.

      const update = updates[i];

      if (update) {
        // Start animating unless a ref exists.
        if (refProp.current) {
          ctrl.queue.push(update);
        } else {
          ctrl.start(update);
        }
      }
    });
  }); // Dispose all controllers on unmount.

  useOnce(() => () => {
    each(state.ctrls, ctrl => ctrl.dispose());
  }); // Return a deep copy of the `springs` array so the caller can
  // safely mutate it during render.

  const values = springs.map(x => _extends({}, x));
  return propsFn || arguments.length == 3 ? [values, api.start, api.stop] : values;
}

/**
 * The props that `useSpring` recognizes.
 */

/** @internal */
function useSpring(props, deps) {
  const isFn = is.fun(props);
  const [[values], update, stop] = useSprings(1, isFn ? props : [props], isFn ? deps || [] : deps);
  return isFn || arguments.length == 2 ? [values, update, stop] : values;
}

function useTrail(length, propsArg, deps) {
  const propsFn = is.fun(propsArg) && propsArg;
  if (propsFn && !deps) deps = [];
  const ctrls = [];
  const result = useSprings(length, (i, ctrl) => {
    ctrls[i] = ctrl;
    return getProps(propsArg, i, ctrl);
  }, // Ensure the props function is called when no deps exist.
  // This works around the 3 argument rule.
  deps || [{}]);
  useLayoutEffect(() => {
    const reverse = is.obj(propsArg) && propsArg.reverse;

    for (let i = 0; i < ctrls.length; i++) {
      const parent = ctrls[i + (reverse ? 1 : -1)];
      if (parent) ctrls[i].update({
        to: parent.springs
      }).start();
    }
  }, deps);

  if (propsFn || arguments.length == 3) {
    const update = result[1];
    result[1] = useCallbackOne(propsArg => {
      const reverse = is.obj(propsArg) && propsArg.reverse;
      return update((i, ctrl) => {
        const props = getProps(propsArg, i, ctrl);
        const parent = ctrls[i + (reverse ? 1 : -1)];
        if (parent) props.to = parent.springs;
        return props;
      });
    }, deps);
    return result;
  }

  return result[0];
}

// TODO: convert to "const enum" once Babel supports it

/** This transition is being mounted */
const MOUNT = 'mount';
/** This transition is entering or has entered */

const ENTER = 'enter';
/** This transition had its animations updated */

const UPDATE = 'update';
/** This transition will expire after animating */

const LEAVE = 'leave';

function useTransition(data, props, deps) {
  const {
    ref,
    reset,
    sort,
    trail = 0,
    expires = true
  } = props; // Every item has its own transition.

  const items = (0,esm.toArray)(data);
  const transitions = []; // Keys help with reusing transitions between renders.
  // The `key` prop can be undefined (which means the items themselves are used
  // as keys), or a function (which maps each item to its key), or an array of
  // keys (which are assigned to each item by index).

  const keys = getKeys(items, props); // The "onRest" callbacks need a ref to the latest transitions.

  const usedTransitions = (0,react.useRef)(null);
  const prevTransitions = reset ? null : usedTransitions.current;
  (0,esm_useLayoutEffect/* useLayoutEffect */.b)(() => {
    usedTransitions.current = transitions;
  }); // Destroy all transitions on dismount.

  (0,esm.useOnce)(() => () => (0,esm.each)(usedTransitions.current, t => {
    if (t.expired) {
      clearTimeout(t.expirationId);
    }

    t.ctrl.dispose();
  })); // Map old indices to new indices.

  const reused = [];
  if (prevTransitions) (0,esm.each)(prevTransitions, (t, i) => {
    // Expired transitions are not rendered.
    if (t.expired) {
      clearTimeout(t.expirationId);
    } else {
      i = reused[i] = keys.indexOf(t.key);
      if (~i) transitions[i] = t;
    }
  }); // Mount new items with fresh transitions.

  (0,esm.each)(items, (item, i) => {
    transitions[i] || (transitions[i] = {
      key: keys[i],
      item,
      phase: MOUNT,
      ctrl: new Controller()
    });
  }); // Update the item of any transition whose key still exists,
  // and ensure leaving transitions are rendered until they finish.

  if (reused.length) {
    let i = -1;
    (0,esm.each)(reused, (keyIndex, prevIndex) => {
      const t = prevTransitions[prevIndex];

      if (~keyIndex) {
        i = transitions.indexOf(t);
        transitions[i] = extends_extends(extends_extends({}, t), {}, {
          item: items[keyIndex]
        });
      } else if (props.leave) {
        transitions.splice(++i, 0, t);
      }
    });
  }

  if (esm.is.fun(sort)) {
    transitions.sort((a, b) => sort(a.item, b.item));
  } // Track cumulative delay for the "trail" prop.


  let delay = -trail; // Expired transitions use this to dismount.

  const forceUpdate = (0,esm.useForceUpdate)(); // These props are inherited by every phase change.

  const defaultProps = getDefaultProps(props); // Generate changes to apply in useEffect.

  const changes = new Map();
  (0,esm.each)(transitions, (t, i) => {
    const key = t.key;
    const prevPhase = t.phase;
    let to;
    let phase;

    if (prevPhase == MOUNT) {
      to = props.enter;
      phase = ENTER;
    } else {
      const isLeave = keys.indexOf(key) < 0;

      if (prevPhase != LEAVE) {
        if (isLeave) {
          to = props.leave;
          phase = LEAVE;
        } else if (to = props.update) {
          phase = UPDATE;
        } else return;
      } else if (!isLeave) {
        to = props.enter;
        phase = ENTER;
      } else return;
    } // When "to" is a function, it can return (1) an array of "useSpring" props,
    // (2) an async function, or (3) an object with any "useSpring" props.


    to = callProp(to, t.item, i);
    to = esm.is.obj(to) ? inferTo(to) : {
      to
    };

    if (!to.config) {
      const config = props.config || defaultProps.config;
      to.config = callProp(config, t.item, i);
    } // The payload is used to update the spring props once the current render is committed.


    const payload = extends_extends(extends_extends({}, defaultProps), {}, {
      delay: delay += trail,
      // This prevents implied resets.
      reset: false
    }, to);

    if (phase == ENTER && esm.is.und(payload.from)) {
      // The `initial` prop is used on the first render of our parent component,
      // as well as when `reset: true` is passed. It overrides the `from` prop
      // when defined, and it makes `enter` instant when null.
      const from = esm.is.und(props.initial) || prevTransitions ? props.from : props.initial;
      payload.from = callProp(from, t.item, i);
    }

    const {
      onRest
    } = payload;

    payload.onRest = result => {
      const transitions = usedTransitions.current;
      const t = transitions.find(t => t.key === key);
      if (!t) return;

      if (esm.is.fun(onRest)) {
        onRest(result, t);
      } // Reset the phase of a cancelled enter/leave transition, so it can
      // retry the animation on the next render.


      if (result.cancelled && t.phase != UPDATE) {
        t.phase = prevPhase;
        return;
      }

      if (t.ctrl.idle) {
        const idle = transitions.every(t => t.ctrl.idle);

        if (t.phase == LEAVE) {
          const expiry = callProp(expires, t.item);

          if (expiry !== false) {
            const expiryMs = expiry === true ? 0 : expiry;
            t.expired = true; // Force update once the expiration delay ends.

            if (!idle && expiryMs > 0) {
              // The maximum timeout is 2^31-1
              if (expiryMs <= 0x7fffffff) t.expirationId = setTimeout(forceUpdate, expiryMs);
              return;
            }
          }
        } // Force update once idle and expired items exist.


        if (idle && transitions.some(t => t.expired)) {
          forceUpdate();
        }
      }
    };

    const springs = getSprings(t.ctrl, payload);
    changes.set(t, {
      phase,
      springs,
      payload
    });
  }); // The prop overrides from an ancestor.

  const context = useSpringContext(); // Merge the context into each transition.

  (0,esm_useLayoutEffect/* useLayoutEffect */.b)(() => {
    (0,esm.each)(transitions, t => {
      t.ctrl.start({
        default: context
      });
    });
  }, [context]);
  const api = (0,react.useMemo)(() => {
    return SpringHandle.create(() => {
      return usedTransitions.current.map(t => t.ctrl);
    });
  }, []);
  (0,react.useImperativeHandle)(ref, () => api);
  (0,esm_useLayoutEffect/* useLayoutEffect */.b)(() => {
    (0,esm.each)(changes, ({
      phase,
      springs,
      payload
    }, t) => {
      setSprings(t.ctrl, springs);

      if (!context.cancel) {
        t.phase = phase;

        if (phase == ENTER) {
          t.ctrl.start({
            default: context
          });
        }

        t.ctrl[ref ? 'update' : 'start'](payload);
      }
    });
  }, reset ? void 0 : deps);

  const renderTransitions = render => /*#__PURE__*/(0,react.createElement)(react.Fragment, null, transitions.map((t, i) => {
    const {
      springs
    } = changes.get(t) || t.ctrl;
    const elem = render(extends_extends({}, springs), t.item, t, i);
    return elem && elem.type ? /*#__PURE__*/(0,react.createElement)(elem.type, extends_extends({}, elem.props, {
      key: esm.is.str(t.key) || esm.is.num(t.key) ? t.key : t.ctrl.id,
      ref: elem.ref
    })) : elem;
  }));

  return arguments.length == 3 ? [renderTransitions, api.start, api.stop] : renderTransitions;
}

function getKeys(items, {
  key,
  keys = key
}) {
  return esm.is.und(keys) ? items : esm.is.fun(keys) ? items.map(keys) : (0,esm.toArray)(keys);
}

/**
 * The `Spring` component passes `SpringValue` objects to your render prop.
 */
function Spring(_ref) {
  let {
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return children(useSpring(props));
}

function Trail(_ref) {
  let {
    items,
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["items", "children"]);

  const trails = useTrail(items.length, props);
  return items.map((item, index) => {
    const result = children(item, index);
    return is.fun(result) ? result(trails[index]) : result;
  });
}

function Transition(_ref) {
  let {
    items,
    children
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["items", "children"]);

  return /*#__PURE__*/createElement(Fragment, null, useTransition(items, props)(children));
}

/**
 * An `Interpolation` is a memoized value that's computed whenever one of its
 * `FluidValue` dependencies has its value changed.
 *
 * Other `FrameValue` objects can depend on this. For example, passing an
 * `Interpolation` as the `to` prop of a `useSpring` call will trigger an
 * animation toward the memoized value.
 */

class Interpolation extends FrameValue {
  /** Useful for debugging. */

  /** Equals false when in the frameloop */

  /** The function that maps inputs values to output */
  constructor(source, args) {
    super();
    this.source = source;
    this.key = void 0;
    this.idle = true;
    this.calc = void 0;
    this.calc = (0,esm.createInterpolator)(...args);

    const value = this._get();

    const nodeType = esm.is.arr(value) ? animated/* AnimatedArray */["if"] : animated/* AnimatedValue */.iG; // Assume the computed value never changes type.

    (0,animated/* setAnimated */.f3)(this, nodeType.create(value));
  }

  advance(_dt) {
    const value = this._get();

    const oldValue = this.get();

    if (!(0,esm.isEqual)(value, oldValue)) {
      (0,animated/* getAnimated */.ys)(this).setValue(value);

      this._onChange(value, this.idle);
    }
  }

  _get() {
    const inputs = esm.is.arr(this.source) ? this.source.map(node => node.get()) : (0,esm.toArray)(this.source.get());
    return this.calc(...inputs);
  }

  _reset() {
    (0,esm.each)((0,animated/* getPayload */.He)(this), node => node.reset());

    super._reset();
  }

  _start() {
    this.idle = false;

    super._start();

    if (globals.skipAnimation) {
      this.idle = true;
      this.advance();
    } else {
      globals.frameLoop.start(this);
    }
  }

  _attach() {
    // Start observing our "source" once we have an observer.
    let idle = true;
    let priority = 1;
    (0,esm.each)((0,esm.toArray)(this.source), source => {
      if (isFrameValue(source)) {
        if (!source.idle) idle = false;
        priority = Math.max(priority, source.priority + 1);
      }

      source.addChild(this);
    });
    this.priority = priority;

    if (!idle) {
      this._reset();

      this._start();
    }
  }

  _detach() {
    // Stop observing our "source" once we have no observers.
    (0,esm.each)((0,esm.toArray)(this.source), source => {
      source.removeChild(this);
    }); // This removes us from the frameloop.

    this.idle = true;
  }
  /** @internal */


  onParentChange(event) {
    // Ensure our start value respects our parent values, in case
    // any of their animations were restarted with the "reset" prop.
    if (event.type == 'start') {
      this.advance();
    } // Change events are useful for (1) reacting to non-animated parents
    // and (2) reacting to the last change in a parent animation.
    else if (event.type == 'change') {
        // If we're idle, we know for sure that this change is *not*
        // caused by an animation.
        if (this.idle) {
          this.advance();
        } // Leave the frameloop when all parents are done animating.
        else if (event.idle) {
            this.idle = (0,esm.toArray)(this.source).every(source => source.idle !== false);

            if (this.idle) {
              this.advance();
              (0,esm.each)((0,animated/* getPayload */.He)(this), node => {
                node.done = true;
              });
            }
          }
      } // Ensure our priority is greater than all parents, which means
      // our value won't be updated until our parents have updated.
      else if (event.type == 'priority') {
          this.priority = (0,esm.toArray)(this.source).reduce((max, source) => Math.max(max, (source.priority || 0) + 1), 0);
        }

    super.onParentChange(event);
  }

}

/** Map the value of one or more dependencies */

const to = (source, ...args) => new Interpolation(source, args);
/** @deprecated Use the `to` export instead */

const interpolate = (source, ...args) => (deprecateInterpolate(), new Interpolation(source, args));
/** Extract the raw value types that are being interpolated */

esm.Globals.assign({
  createStringInterpolator: stringInterpolation/* createStringInterpolator */.q,
  to: (source, args) => new Interpolation(source, args)
});
/** Advance all animations forward one frame */

const update = () => Globals.frameLoop.advance();


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 3360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ FrameLoop; }
/* harmony export */ });
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37994);
/* provided dependency */ var process = __webpack_require__(34406);

// The global `requestAnimationFrame` must be dereferenced to avoid "Illegal invocation" errors
var requestAnimationFrame = function (fn) {
    return (void 0, _globals__WEBPACK_IMPORTED_MODULE_0__.requestAnimationFrame)(fn);
};
/**
 * FrameLoop executes its animations in order of lowest priority first.
 * Animations are retained until idle.
 */
var FrameLoop = /** @class */ (function () {
    function FrameLoop(raf) {
        if (raf === void 0) { raf = requestAnimationFrame; }
        var idle = true;
        var writing = false;
        // The most recent framestamp
        var lastTime = 0;
        // The active animations for the current frame, sorted by lowest priority first
        var animations = [];
        // The priority of the currently advancing animation.
        // To protect against a race condition whenever a frame is being processed,
        // where the filtering of `animations` is corrupted with a shifting index,
        // causing animations to potentially advance 2x faster than intended.
        var priority = 0;
        // Animations starting on the next frame
        var startQueue = new Set();
        // Flushed after all animations are updated.
        // Used to dispatch events to an "onFrame" prop, for example.
        var frameQueue = new Set();
        // Flushed at the very end of each frame.
        // Used to avoid layout thrashing in @react-spring/web, for example.
        var writeQueue = new Set();
        // Add an animation to the frameloop
        var start = function (animation) {
            var index = animations.indexOf(animation);
            if (index < 0) {
                index = animations.findIndex(function (other) { return other.priority > animation.priority; });
                animations.splice(~index ? index : animations.length, 0, animation);
            }
        };
        var loop = function () {
            if (idle)
                return;
            try {
                advance();
                raf(loop);
            }
            catch (e) {
                console.error(e);
            }
        };
        // Start the frameloop
        var kickoff = function () {
            if (idle) {
                idle = false;
                // To minimize frame skips, the frameloop never stops.
                if (lastTime == 0) {
                    lastTime = _globals__WEBPACK_IMPORTED_MODULE_0__.now();
                    raf(loop);
                }
            }
        };
        var timeoutQueue = [];
        this.setTimeout = function (handler, ms) {
            var time = _globals__WEBPACK_IMPORTED_MODULE_0__.now() + ms;
            var cancel = function () {
                var index = timeoutQueue.findIndex(function (t) { return t.cancel == cancel; });
                if (index >= 0) {
                    timeoutQueue.splice(index, 1);
                }
            };
            var index = findIndex(timeoutQueue, function (t) { return t.time > time; });
            var timeout = { time: time, handler: handler, cancel: cancel };
            timeoutQueue.splice(index, 0, timeout);
            kickoff();
            return timeout;
        };
        // Process the current frame.
        var advance = (this.advance = function () {
            var time = _globals__WEBPACK_IMPORTED_MODULE_0__.now();
            // Start animations that were added during last frame.
            if (startQueue.size) {
                startQueue.forEach(start);
                startQueue.clear();
            }
            // Flush the timeout queue.
            if (timeoutQueue.length) {
                _globals__WEBPACK_IMPORTED_MODULE_0__.batchedUpdates(function () {
                    var count = findIndex(timeoutQueue, function (t) { return t.time > time; });
                    timeoutQueue.splice(0, count).forEach(function (t) { return t.handler(); });
                });
            }
            if (time > lastTime) {
                // http://gafferongames.com/game-physics/fix-your-timestep/
                var dt_1 = Math.min(64, time - lastTime);
                lastTime = time;
                _globals__WEBPACK_IMPORTED_MODULE_0__.batchedUpdates(function () {
                    // Animations can be added while the frameloop is updating,
                    // but they need a higher priority to be started on this frame.
                    if (animations.length) {
                        _globals__WEBPACK_IMPORTED_MODULE_0__.willAdvance(animations);
                        animations = animations.filter(function (animation) {
                            priority = animation.priority;
                            // Animations may go idle before the next frame.
                            if (!animation.idle) {
                                animation.advance(dt_1);
                            }
                            // Remove idle animations.
                            return !animation.idle;
                        });
                        priority = 0;
                    }
                    if (frameQueue.size) {
                        frameQueue.forEach(function (onFrame) { return onFrame(time); });
                        frameQueue.clear();
                    }
                    if (writeQueue.size) {
                        writing = true;
                        writeQueue.forEach(function (write) { return write(time); });
                        writeQueue.clear();
                        writing = false;
                    }
                });
            }
        });
        this.start = function (animation) {
            if (priority > animation.priority) {
                startQueue.add(animation);
            }
            else {
                start(animation);
                kickoff();
            }
        };
        this.onFrame = function (cb) {
            frameQueue.add(cb);
            kickoff();
        };
        this.onWrite = function (cb) {
            if (writing)
                cb(lastTime);
            else
                writeQueue.add(cb);
        };
        // Expose internals for testing.
        if (typeof process !== 'undefined' &&
            "production" !== 'production') { var dispose_1; }
    }
    return FrameLoop;
}());

/** Like `Array.prototype.findIndex` but returns `arr.length` instead of `-1` */
function findIndex(arr, test) {
    var index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
//# sourceMappingURL=FrameLoop.js.map

/***/ }),

/***/ 10612:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
// http://www.w3.org/TR/css3-color/#svg-color
var colors = {
    transparent: 0x00000000,
    aliceblue: 0xf0f8ffff,
    antiquewhite: 0xfaebd7ff,
    aqua: 0x00ffffff,
    aquamarine: 0x7fffd4ff,
    azure: 0xf0ffffff,
    beige: 0xf5f5dcff,
    bisque: 0xffe4c4ff,
    black: 0x000000ff,
    blanchedalmond: 0xffebcdff,
    blue: 0x0000ffff,
    blueviolet: 0x8a2be2ff,
    brown: 0xa52a2aff,
    burlywood: 0xdeb887ff,
    burntsienna: 0xea7e5dff,
    cadetblue: 0x5f9ea0ff,
    chartreuse: 0x7fff00ff,
    chocolate: 0xd2691eff,
    coral: 0xff7f50ff,
    cornflowerblue: 0x6495edff,
    cornsilk: 0xfff8dcff,
    crimson: 0xdc143cff,
    cyan: 0x00ffffff,
    darkblue: 0x00008bff,
    darkcyan: 0x008b8bff,
    darkgoldenrod: 0xb8860bff,
    darkgray: 0xa9a9a9ff,
    darkgreen: 0x006400ff,
    darkgrey: 0xa9a9a9ff,
    darkkhaki: 0xbdb76bff,
    darkmagenta: 0x8b008bff,
    darkolivegreen: 0x556b2fff,
    darkorange: 0xff8c00ff,
    darkorchid: 0x9932ccff,
    darkred: 0x8b0000ff,
    darksalmon: 0xe9967aff,
    darkseagreen: 0x8fbc8fff,
    darkslateblue: 0x483d8bff,
    darkslategray: 0x2f4f4fff,
    darkslategrey: 0x2f4f4fff,
    darkturquoise: 0x00ced1ff,
    darkviolet: 0x9400d3ff,
    deeppink: 0xff1493ff,
    deepskyblue: 0x00bfffff,
    dimgray: 0x696969ff,
    dimgrey: 0x696969ff,
    dodgerblue: 0x1e90ffff,
    firebrick: 0xb22222ff,
    floralwhite: 0xfffaf0ff,
    forestgreen: 0x228b22ff,
    fuchsia: 0xff00ffff,
    gainsboro: 0xdcdcdcff,
    ghostwhite: 0xf8f8ffff,
    gold: 0xffd700ff,
    goldenrod: 0xdaa520ff,
    gray: 0x808080ff,
    green: 0x008000ff,
    greenyellow: 0xadff2fff,
    grey: 0x808080ff,
    honeydew: 0xf0fff0ff,
    hotpink: 0xff69b4ff,
    indianred: 0xcd5c5cff,
    indigo: 0x4b0082ff,
    ivory: 0xfffff0ff,
    khaki: 0xf0e68cff,
    lavender: 0xe6e6faff,
    lavenderblush: 0xfff0f5ff,
    lawngreen: 0x7cfc00ff,
    lemonchiffon: 0xfffacdff,
    lightblue: 0xadd8e6ff,
    lightcoral: 0xf08080ff,
    lightcyan: 0xe0ffffff,
    lightgoldenrodyellow: 0xfafad2ff,
    lightgray: 0xd3d3d3ff,
    lightgreen: 0x90ee90ff,
    lightgrey: 0xd3d3d3ff,
    lightpink: 0xffb6c1ff,
    lightsalmon: 0xffa07aff,
    lightseagreen: 0x20b2aaff,
    lightskyblue: 0x87cefaff,
    lightslategray: 0x778899ff,
    lightslategrey: 0x778899ff,
    lightsteelblue: 0xb0c4deff,
    lightyellow: 0xffffe0ff,
    lime: 0x00ff00ff,
    limegreen: 0x32cd32ff,
    linen: 0xfaf0e6ff,
    magenta: 0xff00ffff,
    maroon: 0x800000ff,
    mediumaquamarine: 0x66cdaaff,
    mediumblue: 0x0000cdff,
    mediumorchid: 0xba55d3ff,
    mediumpurple: 0x9370dbff,
    mediumseagreen: 0x3cb371ff,
    mediumslateblue: 0x7b68eeff,
    mediumspringgreen: 0x00fa9aff,
    mediumturquoise: 0x48d1ccff,
    mediumvioletred: 0xc71585ff,
    midnightblue: 0x191970ff,
    mintcream: 0xf5fffaff,
    mistyrose: 0xffe4e1ff,
    moccasin: 0xffe4b5ff,
    navajowhite: 0xffdeadff,
    navy: 0x000080ff,
    oldlace: 0xfdf5e6ff,
    olive: 0x808000ff,
    olivedrab: 0x6b8e23ff,
    orange: 0xffa500ff,
    orangered: 0xff4500ff,
    orchid: 0xda70d6ff,
    palegoldenrod: 0xeee8aaff,
    palegreen: 0x98fb98ff,
    paleturquoise: 0xafeeeeff,
    palevioletred: 0xdb7093ff,
    papayawhip: 0xffefd5ff,
    peachpuff: 0xffdab9ff,
    peru: 0xcd853fff,
    pink: 0xffc0cbff,
    plum: 0xdda0ddff,
    powderblue: 0xb0e0e6ff,
    purple: 0x800080ff,
    rebeccapurple: 0x663399ff,
    red: 0xff0000ff,
    rosybrown: 0xbc8f8fff,
    royalblue: 0x4169e1ff,
    saddlebrown: 0x8b4513ff,
    salmon: 0xfa8072ff,
    sandybrown: 0xf4a460ff,
    seagreen: 0x2e8b57ff,
    seashell: 0xfff5eeff,
    sienna: 0xa0522dff,
    silver: 0xc0c0c0ff,
    skyblue: 0x87ceebff,
    slateblue: 0x6a5acdff,
    slategray: 0x708090ff,
    slategrey: 0x708090ff,
    snow: 0xfffafaff,
    springgreen: 0x00ff7fff,
    steelblue: 0x4682b4ff,
    tan: 0xd2b48cff,
    teal: 0x008080ff,
    thistle: 0xd8bfd8ff,
    tomato: 0xff6347ff,
    turquoise: 0x40e0d0ff,
    violet: 0xee82eeff,
    wheat: 0xf5deb3ff,
    white: 0xffffffff,
    whitesmoke: 0xf5f5f5ff,
    yellow: 0xffff00ff,
    yellowgreen: 0x9acd32ff,
};
/* harmony default export */ __webpack_exports__["Z"] = (colors);
//# sourceMappingURL=colors.js.map

/***/ }),

/***/ 25863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ createInterpolator; }
/* harmony export */ });
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37994);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52986);


var createInterpolator = function (range, output, extrapolate) {
    if (_helpers__WEBPACK_IMPORTED_MODULE_1__.is.fun(range)) {
        return range;
    }
    if (_helpers__WEBPACK_IMPORTED_MODULE_1__.is.arr(range)) {
        return createInterpolator({
            range: range,
            output: output,
            extrapolate: extrapolate,
        });
    }
    if (_helpers__WEBPACK_IMPORTED_MODULE_1__.is.str(range.output[0])) {
        return _globals__WEBPACK_IMPORTED_MODULE_0__.createStringInterpolator(range);
    }
    var config = range;
    var outputRange = config.output;
    var inputRange = config.range || [0, 1];
    var extrapolateLeft = config.extrapolateLeft || config.extrapolate || 'extend';
    var extrapolateRight = config.extrapolateRight || config.extrapolate || 'extend';
    var easing = config.easing || (function (t) { return t; });
    return function (input) {
        var range = findRange(input, inputRange);
        return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    var result = map ? map(input) : input;
    // Extrapolate
    if (result < inputMin) {
        if (extrapolateLeft === 'identity')
            return result;
        else if (extrapolateLeft === 'clamp')
            result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === 'identity')
            return result;
        else if (extrapolateRight === 'clamp')
            result = inputMax;
    }
    if (outputMin === outputMax)
        return outputMin;
    if (inputMin === inputMax)
        return input <= inputMin ? outputMin : outputMax;
    // Input Range
    if (inputMin === -Infinity)
        result = -result;
    else if (inputMax === Infinity)
        result = result - inputMin;
    else
        result = (result - inputMin) / (inputMax - inputMin);
    // Easing
    result = easing(result);
    // Output Range
    if (outputMin === -Infinity)
        result = -result;
    else if (outputMax === Infinity)
        result = result + outputMin;
    else
        result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function findRange(input, inputRange) {
    for (var i = 1; i < inputRange.length - 1; ++i)
        if (inputRange[i] >= input)
            break;
    return i - 1;
}
//# sourceMappingURL=createInterpolator.js.map

/***/ }),

/***/ 37994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "assign": function() { return /* binding */ assign; },
/* harmony export */   "batchedUpdates": function() { return /* binding */ batchedUpdates; },
/* harmony export */   "colorNames": function() { return /* binding */ colorNames; },
/* harmony export */   "createStringInterpolator": function() { return /* binding */ createStringInterpolator; },
/* harmony export */   "frameLoop": function() { return /* binding */ frameLoop; },
/* harmony export */   "now": function() { return /* binding */ now; },
/* harmony export */   "requestAnimationFrame": function() { return /* binding */ requestAnimationFrame; },
/* harmony export */   "skipAnimation": function() { return /* binding */ skipAnimation; },
/* harmony export */   "to": function() { return /* binding */ to; },
/* harmony export */   "willAdvance": function() { return /* binding */ willAdvance; }
/* harmony export */ });
/* harmony import */ var _FrameLoop__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3360);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52986);


//
// Required
//
var createStringInterpolator;
var frameLoop = new _FrameLoop__WEBPACK_IMPORTED_MODULE_0__/* .FrameLoop */ .V();
//
// Optional
//
var to;
var now = function () { return performance.now(); };
var colorNames = null;
var skipAnimation = false;
var requestAnimationFrame = typeof window !== 'undefined' ? window.requestAnimationFrame : function () { return -1; };
var batchedUpdates = function (callback) { return callback(); };
var willAdvance = _helpers__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT;
var assign = function (globals) {
    var _a;
    return (_a = Object.assign({
        to: to,
        now: now,
        frameLoop: frameLoop,
        colorNames: colorNames,
        skipAnimation: skipAnimation,
        createStringInterpolator: createStringInterpolator,
        requestAnimationFrame: requestAnimationFrame,
        batchedUpdates: batchedUpdates,
        willAdvance: willAdvance,
    }, pluckDefined(globals)), to = _a.to, now = _a.now, frameLoop = _a.frameLoop, colorNames = _a.colorNames, skipAnimation = _a.skipAnimation, createStringInterpolator = _a.createStringInterpolator, requestAnimationFrame = _a.requestAnimationFrame, batchedUpdates = _a.batchedUpdates, willAdvance = _a.willAdvance, _a);
};
// Ignore undefined values
function pluckDefined(globals) {
    var defined = {};
    for (var key in globals) {
        if (globals[key] !== undefined)
            defined[key] = globals[key];
    }
    return defined;
}
//# sourceMappingURL=globals.js.map

/***/ }),

/***/ 52986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Df": function() { return /* binding */ isAnimatedString; },
/* harmony export */   "S6": function() { return /* binding */ each; },
/* harmony export */   "Xy": function() { return /* binding */ isEqual; },
/* harmony export */   "ZT": function() { return /* binding */ noop; },
/* harmony export */   "dE": function() { return /* binding */ defineHidden; },
/* harmony export */   "is": function() { return /* binding */ is; },
/* harmony export */   "qo": function() { return /* binding */ toArray; },
/* harmony export */   "yl": function() { return /* binding */ flush; }
/* harmony export */ });
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37994);

var noop = function () { };
var defineHidden = function (obj, key, value) {
    return Object.defineProperty(obj, key, { value: value, writable: true, configurable: true });
};
var is = {
    arr: Array.isArray,
    obj: function (a) {
        return !!a && a.constructor.name === 'Object';
    },
    fun: function (a) { return typeof a === 'function'; },
    str: function (a) { return typeof a === 'string'; },
    num: function (a) { return typeof a === 'number'; },
    und: function (a) { return a === undefined; },
};
/** Compare animatable values */
function isEqual(a, b) {
    if (is.arr(a)) {
        if (!is.arr(b) || a.length !== b.length)
            return false;
        for (var i = 0; i < a.length; i++) {
            if (a[i] !== b[i])
                return false;
        }
        return true;
    }
    return a === b;
}
// Not all strings can be animated (eg: {display: "none"})
var isAnimatedString = function (value) {
    return is.str(value) &&
        (value[0] == '#' ||
            /\d/.test(value) ||
            !!(_globals__WEBPACK_IMPORTED_MODULE_0__.colorNames && _globals__WEBPACK_IMPORTED_MODULE_0__.colorNames[value]));
};
/** An unsafe object/array/set iterator that allows for better minification */
var each = function (obj, cb, ctx) {
    if (is.fun(obj.forEach)) {
        obj.forEach(cb, ctx);
    }
    else {
        Object.keys(obj).forEach(function (key) {
            return cb.call(ctx, obj[key], key);
        });
    }
};
var toArray = function (a) {
    return is.und(a) ? [] : is.arr(a) ? a : [a];
};
function flush(queue, iterator) {
    if (queue.size) {
        var items = Array.from(queue);
        queue.clear();
        each(items, iterator);
    }
}
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ 26673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FluidValue": function() { return /* reexport */ esm/* FluidValue */.B0; },
  "Globals": function() { return /* reexport */ globals; },
  "createInterpolator": function() { return /* reexport */ createInterpolator/* createInterpolator */.m; },
  "defineHidden": function() { return /* reexport */ helpers/* defineHidden */.dE; },
  "each": function() { return /* reexport */ helpers/* each */.S6; },
  "flush": function() { return /* reexport */ helpers/* flush */.yl; },
  "getFluidConfig": function() { return /* reexport */ esm/* getFluidConfig */.Qb; },
  "getFluidValue": function() { return /* reexport */ esm/* getFluidValue */.je; },
  "is": function() { return /* reexport */ helpers.is; },
  "isAnimatedString": function() { return /* reexport */ helpers/* isAnimatedString */.Df; },
  "isEqual": function() { return /* reexport */ helpers/* isEqual */.Xy; },
  "noop": function() { return /* reexport */ helpers/* noop */.ZT; },
  "toArray": function() { return /* reexport */ helpers/* toArray */.qo; },
  "useForceUpdate": function() { return /* reexport */ useForceUpdate; },
  "useOnce": function() { return /* reexport */ useOnce; }
});

// UNUSED EXPORTS: FrameLoop, addFluidObserver, hasFluidValue, setFluidConfig, usePrev

// EXTERNAL MODULE: ../../node_modules/@react-spring/shared/esm/globals.js
var globals = __webpack_require__(37994);
// EXTERNAL MODULE: ../../node_modules/@alloc/types/index.js
var types = __webpack_require__(1678);
;// CONCATENATED MODULE: ../../node_modules/@react-spring/shared/esm/types.util.js

//# sourceMappingURL=types.util.js.map
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/@react-spring/shared/esm/hooks.js

var useOnce = function (effect) { return (0,react.useEffect)(effect, []); };
/** Return a function that re-renders this component, if still mounted */
var useForceUpdate = function () {
    var update = (0,react.useState)(0)[1];
    var unmounted = (0,react.useRef)(false);
    useOnce(function () { return function () {
        unmounted.current = true;
    }; });
    return function () {
        if (!unmounted.current) {
            update({});
        }
    };
};
/** Use a value from the previous render */
function usePrev(value) {
    var prevRef = useRef(undefined);
    useEffect(function () {
        prevRef.current = value;
    });
    return prevRef.current;
}
//# sourceMappingURL=hooks.js.map
// EXTERNAL MODULE: ../../node_modules/@react-spring/shared/esm/helpers.js
var helpers = __webpack_require__(52986);
// EXTERNAL MODULE: ../../node_modules/@react-spring/shared/esm/FrameLoop.js
var FrameLoop = __webpack_require__(3360);
// EXTERNAL MODULE: ../../node_modules/@react-spring/shared/esm/createInterpolator.js
var createInterpolator = __webpack_require__(25863);
// EXTERNAL MODULE: ../../node_modules/fluids/dist/esm/index.js
var esm = __webpack_require__(12853);
;// CONCATENATED MODULE: ../../node_modules/@react-spring/shared/esm/index.js








//# sourceMappingURL=index.js.map

/***/ }),

/***/ 68199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ createStringInterpolator; }
});

;// CONCATENATED MODULE: ../../node_modules/@react-spring/shared/node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}

// EXTERNAL MODULE: ../../node_modules/fluids/dist/esm/index.js
var esm = __webpack_require__(12853);
// EXTERNAL MODULE: ../../node_modules/@react-spring/shared/esm/createInterpolator.js
var createInterpolator = __webpack_require__(25863);
;// CONCATENATED MODULE: ../../node_modules/@react-spring/shared/esm/colorMatchers.js
// const INTEGER = '[-+]?\\d+';
var NUMBER = '[-+]?\\d*\\.?\\d+';
var PERCENTAGE = NUMBER + '%';
function call() {
    var parts = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        parts[_i] = arguments[_i];
    }
    return '\\(\\s*(' + parts.join(')\\s*,\\s*(') + ')\\s*\\)';
}
var rgb = new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER));
var rgba = new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER));
var hsl = new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE));
var hsla = new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER));
var hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex6 = /^#([0-9a-fA-F]{6})$/;
var hex8 = /^#([0-9a-fA-F]{8})$/;
//# sourceMappingURL=colorMatchers.js.map
// EXTERNAL MODULE: ../../node_modules/@react-spring/shared/esm/globals.js
var globals = __webpack_require__(37994);
;// CONCATENATED MODULE: ../../node_modules/@react-spring/shared/esm/normalizeColor.js
/*
https://github.com/react-community/normalize-css-color

BSD 3-Clause License

Copyright (c) 2016, React Community
All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

* Redistributions of source code must retain the above copyright notice, this
  list of conditions and the following disclaimer.

* Redistributions in binary form must reproduce the above copyright notice,
  this list of conditions and the following disclaimer in the documentation
  and/or other materials provided with the distribution.

* Neither the name of the copyright holder nor the names of its
  contributors may be used to endorse or promote products derived from
  this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/


function normalizeColor(color) {
    var match;
    if (typeof color === 'number') {
        return color >>> 0 === color && color >= 0 && color <= 0xffffffff
            ? color
            : null;
    }
    // Ordered based on occurrences on Facebook codebase
    if ((match = hex6.exec(color)))
        return parseInt(match[1] + 'ff', 16) >>> 0;
    if (globals.colorNames && globals.colorNames[color] !== undefined) {
        return globals.colorNames[color];
    }
    if ((match = rgb.exec(color))) {
        return (((parse255(match[1]) << 24) | // r
            (parse255(match[2]) << 16) | // g
            (parse255(match[3]) << 8) | // b
            0x000000ff) >>> // a
            0);
    }
    if ((match = rgba.exec(color))) {
        return (((parse255(match[1]) << 24) | // r
            (parse255(match[2]) << 16) | // g
            (parse255(match[3]) << 8) | // b
            parse1(match[4])) >>> // a
            0);
    }
    if ((match = hex3.exec(color))) {
        return (parseInt(match[1] +
            match[1] + // r
            match[2] +
            match[2] + // g
            match[3] +
            match[3] + // b
            'ff', // a
        16) >>> 0);
    }
    // https://drafts.csswg.org/css-color-4/#hex-notation
    if ((match = hex8.exec(color)))
        return parseInt(match[1], 16) >>> 0;
    if ((match = hex4.exec(color))) {
        return (parseInt(match[1] +
            match[1] + // r
            match[2] +
            match[2] + // g
            match[3] +
            match[3] + // b
            match[4] +
            match[4], // a
        16) >>> 0);
    }
    if ((match = hsl.exec(color))) {
        return ((hslToRgb(parse360(match[1]), // h
        parsePercentage(match[2]), // s
        parsePercentage(match[3]) // l
        ) |
            0x000000ff) >>> // a
            0);
    }
    if ((match = hsla.exec(color))) {
        return ((hslToRgb(parse360(match[1]), // h
        parsePercentage(match[2]), // s
        parsePercentage(match[3]) // l
        ) |
            parse1(match[4])) >>> // a
            0);
    }
    return null;
}
function hue2rgb(h, c, x) {
    if (h < 60)
        return [c, x, 0];
    if (h < 120)
        return [x, c, 0];
    if (h < 180)
        return [0, c, x];
    if (h < 240)
        return [0, x, c];
    if (h < 300)
        return [x, 0, c];
    return [c, 0, x];
}
function hslToRgb(h, s, l) {
    var C = (1 - Math.abs(2 * l - 1)) * s;
    var X = C * (1 - Math.abs(((h / 60) % 2) - 1));
    var M = l - C / 2;
    var _a = hue2rgb(h, C, X), R1 = _a[0], G1 = _a[1], B1 = _a[2];
    return ((Math.round((R1 + M) * 255) << 24) |
        (Math.round((G1 + M) * 255) << 16) |
        (Math.round((B1 + M) * 255) << 8));
}
function parse255(str) {
    var int = parseInt(str, 10);
    if (int < 0)
        return 0;
    if (int > 255)
        return 255;
    return int;
}
function parse360(str) {
    var int = parseFloat(str);
    return (((int % 360) + 360) % 360) / 360;
}
function parse1(str) {
    var num = parseFloat(str);
    if (num < 0)
        return 0;
    if (num > 1)
        return 255;
    return Math.round(num * 255);
}
function parsePercentage(str) {
    // parseFloat conveniently ignores the final %
    var int = parseFloat(str);
    if (int < 0)
        return 0;
    if (int > 100)
        return 1;
    return int / 100;
}
//# sourceMappingURL=normalizeColor.js.map
;// CONCATENATED MODULE: ../../node_modules/@react-spring/shared/esm/colorToRgba.js

function colorToRgba(input) {
    var int32Color = normalizeColor(input);
    if (int32Color === null)
        return input;
    int32Color = int32Color || 0;
    var r = (int32Color & 0xff000000) >>> 24;
    var g = (int32Color & 0x00ff0000) >>> 16;
    var b = (int32Color & 0x0000ff00) >>> 8;
    var a = (int32Color & 0x000000ff) / 255;
    return "rgba(" + r + ", " + g + ", " + b + ", " + a + ")";
}
//# sourceMappingURL=colorToRgba.js.map
;// CONCATENATED MODULE: ../../node_modules/@react-spring/shared/esm/stringInterpolation.js





// Problem: https://github.com/animatedjs/animated/pull/102
// Solution: https://stackoverflow.com/questions/638565/parsing-scientific-notation-sensibly/658662
var numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
// Covers rgb, rgba, hsl, hsla
// Taken from https://gist.github.com/olmokramer/82ccce673f86db7cda5e
var colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
// Covers color names (transparent, blue, etc.)
var colorNamesRegex;
// rgba requires that the r,g,b are integers.... so we want to round them,
// but we *dont* want to round the opacity (4th column).
var rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var rgbaRound = function (_, p1, p2, p3, p4) {
    return "rgba(" + Math.round(p1) + ", " + Math.round(p2) + ", " + Math.round(p3) + ", " + p4 + ")";
};
/**
 * Supports string shapes by extracting numbers so new values can be computed,
 * and recombines those values into new strings of the same shape.  Supports
 * things like:
 *
 *     "rgba(123, 42, 99, 0.36)"           // colors
 *     "-45deg"                            // values with units
 *     "0 2px 2px 0px rgba(0, 0, 0, 0.12)" // CSS box-shadows
 *     "rotate(0deg) translate(2px, 3px)"  // CSS transforms
 */
var createStringInterpolator = function (config) {
    if (!colorNamesRegex)
        colorNamesRegex = globals.colorNames
            ? new RegExp("(" + Object.keys(globals.colorNames).join('|') + ")", 'g')
            : /^\b$/; // never match
    // Convert colors to rgba(...)
    var output = config.output.map(function (value) {
        return (0,esm/* getFluidValue */.je)(value)
            .replace(colorRegex, colorToRgba)
            .replace(colorNamesRegex, colorToRgba);
    });
    // Convert ["1px 2px", "0px 0px"] into [[1, 2], [0, 0]]
    var keyframes = output.map(function (value) { return value.match(numberRegex).map(Number); });
    // Convert ["1px 2px", "0px 0px"] into [[1, 0], [2, 0]]
    var outputRanges = keyframes[0].map(function (_, i) {
        return keyframes.map(function (values) {
            if (!(i in values)) {
                throw Error('The arity of each "output" value must be equal');
            }
            return values[i];
        });
    });
    // Create an interpolator for each animated number
    var interpolators = outputRanges.map(function (output) {
        return (0,createInterpolator/* createInterpolator */.m)(__assign(__assign({}, config), { output: output }));
    });
    // Use the first `output` as a template for each call
    return function (input) {
        var i = 0;
        return output[0]
            .replace(numberRegex, function () { return String(interpolators[i++](input)); })
            .replace(rgbaRegex, rgbaRound);
    };
};
//# sourceMappingURL=stringInterpolation.js.map

/***/ }),

/***/ 18876:
/***/ (function() {

//# sourceMappingURL=types.js.map

/***/ }),

/***/ 57747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "animated": function() { return /* binding */ animated; },
/* harmony export */   "config": function() { return /* reexport safe */ _react_spring_core__WEBPACK_IMPORTED_MODULE_1__.config; },
/* harmony export */   "useTransition": function() { return /* reexport safe */ _react_spring_core__WEBPACK_IMPORTED_MODULE_1__.useTransition; }
/* harmony export */ });
/* unused harmony export a */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43090);
/* harmony import */ var _react_spring_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32825);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28316);
/* harmony import */ var _react_spring_shared_stringInterpolation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68199);
/* harmony import */ var _react_spring_shared_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10612);
/* harmony import */ var _react_spring_animated__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68156);
/* harmony import */ var _react_spring_shared__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26673);









const isCustomPropRE = /^--/;

function dangerousStyleValue(name, value) {
  if (value == null || typeof value === 'boolean' || value === '') return '';
  if (typeof value === 'number' && value !== 0 && !isCustomPropRE.test(name) && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers

  return ('' + value).trim();
}

const attributeCache = {};
function applyAnimatedValues(instance, props) {
  if (!instance.nodeType || !instance.setAttribute) {
    return false;
  }

  const isFilterElement = instance.nodeName === 'filter' || instance.parentNode && instance.parentNode.nodeName === 'filter';

  const _ref = props,
        {
    style,
    children,
    scrollTop,
    scrollLeft
  } = _ref,
        attributes = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref, ["style", "children", "scrollTop", "scrollLeft"]);

  const values = Object.values(attributes);
  const names = Object.keys(attributes).map(name => isFilterElement || instance.hasAttribute(name) ? name : attributeCache[name] || (attributeCache[name] = name.replace(/([A-Z])/g, // Attributes are written in dash case
  n => '-' + n.toLowerCase())));
  _react_spring_shared__WEBPACK_IMPORTED_MODULE_6__.Globals.frameLoop.onWrite(() => {
    if (children !== void 0) {
      instance.textContent = children;
    } // Apply CSS styles


    for (let name in style) {
      if (style.hasOwnProperty(name)) {
        const value = dangerousStyleValue(name, style[name]);
        if (name === 'float') name = 'cssFloat';else if (isCustomPropRE.test(name)) {
          instance.style.setProperty(name, value);
        } else {
          instance.style[name] = value;
        }
      }
    } // Apply DOM attributes


    names.forEach((name, i) => {
      instance.setAttribute(name, values[i]);
    });

    if (scrollTop !== void 0) {
      instance.scrollTop = scrollTop;
    }

    if (scrollLeft !== void 0) {
      instance.scrollLeft = scrollLeft;
    }
  });
}
let isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

const prefixKey = (prefix, key) => prefix + key.charAt(0).toUpperCase() + key.substring(1);

const prefixes = ['Webkit', 'Ms', 'Moz', 'O'];
isUnitlessNumber = Object.keys(isUnitlessNumber).reduce((acc, prop) => {
  prefixes.forEach(prefix => acc[prefixKey(prefix, prop)] = acc[prop]);
  return acc;
}, isUnitlessNumber);

/** The transform-functions
 * (https://developer.mozilla.org/fr/docs/Web/CSS/transform-function)
 * that you can pass as keys to your animated component style and that will be
 * animated. Perspective has been left out as it would conflict with the
 * non-transform perspective style.
 */

const domTransforms = /^(matrix|translate|scale|rotate|skew)/; // These keys have "px" units by default

const pxTransforms = /^(translate)/; // These keys have "deg" units by default

const degTransforms = /^(rotate|skew)/;

/** Add a unit to the value when the value is unit-less (eg: a number) */
const addUnit = (value, unit) => _react_spring_shared__WEBPACK_IMPORTED_MODULE_6__.is.num(value) && value !== 0 ? value + unit : value;
/**
 * Checks if the input value matches the identity value.
 *
 *     isValueIdentity(0, 0)              // => true
 *     isValueIdentity('0px', 0)          // => true
 *     isValueIdentity([0, '0px', 0], 0)  // => true
 */


const isValueIdentity = (value, id) => _react_spring_shared__WEBPACK_IMPORTED_MODULE_6__.is.arr(value) ? value.every(v => isValueIdentity(v, id)) : _react_spring_shared__WEBPACK_IMPORTED_MODULE_6__.is.num(value) ? value === id : parseFloat(value) === id;

/**
 * This AnimatedStyle will simplify animated components transforms by
 * interpolating all transform function passed as keys in the style object
 * including shortcuts such as x, y and z for translateX/Y/Z
 */
class AnimatedStyle extends _react_spring_animated__WEBPACK_IMPORTED_MODULE_5__/* .AnimatedObject */ .rS {
  constructor(_ref) {
    let {
      x,
      y,
      z
    } = _ref,
        style = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref, ["x", "y", "z"]);

    /**
     * An array of arrays that contains the values (static or fluid)
     * used by each transform function.
     */
    const inputs = [];
    /**
     * An array of functions that take a list of values (static or fluid)
     * and returns (1) a CSS transform string and (2) a boolean that's true
     * when the transform has no effect (eg: an identity transform).
     */

    const transforms = []; // Combine x/y/z into translate3d

    if (x || y || z) {
      inputs.push([x || 0, y || 0, z || 0]);
      transforms.push(xyz => ["translate3d(" + xyz.map(v => addUnit(v, 'px')).join(',') + ")", // prettier-ignore
      isValueIdentity(xyz, 0)]);
    } // Pluck any other transform-related props


    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_6__.each)(style, (value, key) => {
      if (key === 'transform') {
        inputs.push([value || '']);
        transforms.push(transform => [transform, transform === '']);
      } else if (domTransforms.test(key)) {
        delete style[key];
        if (_react_spring_shared__WEBPACK_IMPORTED_MODULE_6__.is.und(value)) return;
        const unit = pxTransforms.test(key) ? 'px' : degTransforms.test(key) ? 'deg' : '';
        inputs.push((0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_6__.toArray)(value));
        transforms.push(key === 'rotate3d' ? ([x, y, z, deg]) => ["rotate3d(" + x + "," + y + "," + z + "," + addUnit(deg, unit) + ")", isValueIdentity(deg, 0)] : input => [key + "(" + input.map(v => addUnit(v, unit)).join(',') + ")", isValueIdentity(input, key.startsWith('scale') ? 1 : 0)]);
      }
    });

    if (inputs.length) {
      style.transform = new FluidTransform(inputs, transforms);
    }

    super(style);
  }

}
/** @internal */

class FluidTransform extends _react_spring_shared__WEBPACK_IMPORTED_MODULE_6__.FluidValue {
  constructor(inputs, transforms) {
    super();
    this.inputs = inputs;
    this.transforms = transforms;
    this._value = null;
    this._children = new Set();
  }

  get() {
    return this._value || (this._value = this._get());
  }

  _get() {
    let transform = '';
    let identity = true;
    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_6__.each)(this.inputs, (input, i) => {
      const arg1 = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_6__.getFluidValue)(input[0]);
      const [t, id] = this.transforms[i](_react_spring_shared__WEBPACK_IMPORTED_MODULE_6__.is.arr(arg1) ? arg1 : input.map(_react_spring_shared__WEBPACK_IMPORTED_MODULE_6__.getFluidValue));
      transform += ' ' + t;
      identity = identity && id;
    });
    return identity ? 'none' : transform;
  }

  addChild(child) {
    if (!this._children.size) {
      // Start observing our inputs once we have an observer.
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_6__.each)(this.inputs, input => (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_6__.each)(input, value => {
        const config = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_6__.getFluidConfig)(value);
        if (config) config.addChild(this);
      }));
    }

    this._children.add(child);
  }

  removeChild(child) {
    this._children.delete(child);

    if (!this._children.size) {
      // Stop observing our inputs once we have no observers.
      (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_6__.each)(this.inputs, input => (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_6__.each)(input, value => {
        const config = (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_6__.getFluidConfig)(value);
        if (config) config.removeChild(this);
      }));
    }
  }

  onParentChange(event) {
    if (event.type == 'change') {
      this._value = null;
    }

    (0,_react_spring_shared__WEBPACK_IMPORTED_MODULE_6__.each)(this._children, child => {
      child.onParentChange(event);
    });
  }

}

const primitives = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

_react_spring_core__WEBPACK_IMPORTED_MODULE_1__.Globals.assign({
  colorNames: _react_spring_shared_colors__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
  createStringInterpolator: _react_spring_shared_stringInterpolation__WEBPACK_IMPORTED_MODULE_3__/* .createStringInterpolator */ .q,
  batchedUpdates: react_dom__WEBPACK_IMPORTED_MODULE_2__.unstable_batchedUpdates
});
const host = (0,_react_spring_animated__WEBPACK_IMPORTED_MODULE_5__/* .createHost */ .Ld)(primitives, {
  applyAnimatedValues,
  createAnimatedStyle: style => new AnimatedStyle(style),
  getComponentProps: (_ref) => {
    let props = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref, ["scrollTop", "scrollLeft"]);

    return props;
  }
});
const animated = host.animated;


//# sourceMappingURL=index.js.map


/***/ }),

/***/ 63761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addDays; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42765);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}

/***/ }),

/***/ 2463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ compareAsc; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

/***/ }),

/***/ 80189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ differenceInMonths; }
});

// EXTERNAL MODULE: ../../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(66700);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(19785);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/differenceInCalendarMonths/index.js


/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/compareAsc/index.js
var compareAsc = __webpack_require__(2463);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isLastDayOfMonth/index.js
var isLastDayOfMonth = __webpack_require__(12582);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/differenceInMonths/index.js





/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */
function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var sign = (0,compareAsc/* default */.Z)(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight));
  var result;

  // Check for the difference of less than month
  if (difference < 1) {
    result = 0;
  } else {
    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
      // This will check if the date is end of Feb and assign a higher end of month date
      // to compare it with Jan
      dateLeft.setDate(30);
    }
    dateLeft.setMonth(dateLeft.getMonth() - sign * difference);

    // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastMonthNotFull = (0,compareAsc/* default */.Z)(dateLeft, dateRight) === -sign;

    // Check for cases of one full calendar month
    if ((0,isLastDayOfMonth/* default */.Z)((0,toDate/* default */.Z)(dirtyDateLeft)) && difference === 1 && (0,compareAsc/* default */.Z)(dirtyDateLeft, dateRight) === 1) {
      isLastMonthNotFull = false;
    }
    result = sign * (difference - Number(isLastMonthNotFull));
  }

  // Prevent negative zero
  return result === 0 ? 0 : result;
}

/***/ }),

/***/ 48701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ differenceInYears; }
});

// EXTERNAL MODULE: ../../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(66700);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(19785);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/differenceInCalendarYears/index.js


/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/compareAsc/index.js
var compareAsc = __webpack_require__(2463);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/differenceInYears/index.js




/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */
function differenceInYears(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var sign = (0,compareAsc/* default */.Z)(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight));

  // Set both dates to a valid leap year for accurate comparison when dealing
  // with leap days
  dateLeft.setFullYear(1584);
  dateRight.setFullYear(1584);

  // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastYearNotFull = (0,compareAsc/* default */.Z)(dateLeft, dateRight) === -sign;
  var result = sign * (difference - Number(isLastYearNotFull));
  // Prevent negative zero
  return result === 0 ? 0 : result;
}

/***/ }),

/***/ 11106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ endOfDay; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),

/***/ 8548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ endOfMonth; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),

/***/ 12582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isLastDayOfMonth; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _endOfDay_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11106);
/* harmony import */ var _endOfMonth_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8548);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);




/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */
function isLastDayOfMonth(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  return (0,_endOfDay_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(date).getTime() === (0,_endOfMonth_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(date).getTime();
}

/***/ }),

/***/ 82276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isSameDay; }
/* harmony export */ });
/* harmony import */ var _startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10405);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeftStartOfDay = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateLeft);
  var dateRightStartOfDay = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/***/ }),

/***/ 53009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isSameMonth; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeft = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateLeft);
  var dateRight = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

/***/ }),

/***/ 82236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isToday; }
/* harmony export */ });
/* harmony import */ var _isSameDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82276);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is today
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */
function isToday(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  return (0,_isSameDay_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate, Date.now());
}

/***/ }),

/***/ 27131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ setDate; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42765);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);



/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} dayOfMonth - the day of the month of the new date
 * @returns {Date} the new date with the day of the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * const result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */
function setDate(dirtyDate, dirtyDayOfMonth) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var dayOfMonth = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyDayOfMonth);
  date.setDate(dayOfMonth);
  return date;
}

/***/ }),

/***/ 10405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ startOfDay; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 12853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B0": function() { return /* binding */ FluidValue; },
/* harmony export */   "Qb": function() { return /* binding */ getFluidConfig; },
/* harmony export */   "je": function() { return /* binding */ getFluidValue; }
/* harmony export */ });
/* unused harmony exports hasFluidValue, setFluidConfig, addFluidObserver */
var $config = Symbol.for('FluidValue:config');

/** Does the given value have a `FluidConfig` object? */
var hasFluidValue = function (arg) { return !!getFluidConfig(arg); };
function getFluidValue(arg) {
    var config = getFluidConfig(arg);
    return config ? config.get() : arg;
}
function getFluidConfig(arg) {
    if (arg)
        return arg[$config];
}
/** Set the methods for observing the given object. */
function setFluidConfig(target, config) {
    Object.defineProperty(target, $config, {
        value: config,
        configurable: true,
    });
}
function addFluidObserver(target, observer) {
    var config = getFluidConfig(target);
    if (config) {
        config.addChild(observer);
        return function () { return config.removeChild(observer); };
    }
}
/**
 * This class stores a single dynamic value, which can be observed by multiple `FluidObserver` objects.
 *
 * In order to support non-writable streams, this class doesn't expect a `set` method to exist.
 *
 * It can send *any* event to observers, not only change events.
 */
var FluidValue = /** @class */ (function () {
    function FluidValue() {
        setFluidConfig(this, this);
    }
    return FluidValue;
}());

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 67581:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath =  false || '';

function getDomainLocale(path, locale, locales, domainLocales) {
  if (true) {
    var normalizeLocalePath = (__webpack_require__(76146).normalizeLocalePath);

    var detectDomainLocale = (__webpack_require__(5369).detectDomainLocale);

    var target = locale || normalizeLocalePath(path, locales).detectedLocale;
    var domain = detectDomainLocale(domainLocales, undefined, target);

    if (domain) {
      var proto = "http".concat(domain.http ? '' : 's', "://");
      var finalLocale = target === domain.defaultLocale ? '' : "/".concat(target);
      return "".concat(proto).concat(domain.domain).concat(basePath).concat(finalLocale).concat(path);
    }

    return false;
  } else {}
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 2817:
/***/ (function(module, exports, __webpack_require__) {

"use client";
"use strict";

var _slicedToArray = __webpack_require__(44429);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);

var _object_without_properties_loose = (__webpack_require__(15154)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var _router = __webpack_require__(17744);

var _formatUrl = __webpack_require__(4696);

var _addLocale = __webpack_require__(17640);

var _routerContext = __webpack_require__(37258);

var _appRouterContext = __webpack_require__(84117);

var _useIntersection = __webpack_require__(91514);

var _getDomainLocale = __webpack_require__(67581);

var _addBasePath = __webpack_require__(5409);

'use client';
var prefetched = new Set();

function prefetch(router, href, as, options) {
  if (false) {}

  if (!(0, _router).isLocalURL(href)) {
    return;
  } // We should only dedupe requests when experimental.optimisticClientCache is
  // disabled.


  if (!options.bypassPrefetchedCheck) {
    var locale = // Let the link's locale prop override the default router locale.
    typeof options.locale !== 'undefined' ? options.locale : 'locale' in router ? router.locale : undefined;
    var prefetchedKey = href + '%' + as + '%' + locale; // If we've already fetched the key, then don't prefetch it again!

    if (prefetched.has(prefetchedKey)) {
      return;
    } // Mark this URL as prefetched.


    prefetched.add(prefetchedKey);
  } // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch


  Promise.resolve(router.prefetch(href, as, options))["catch"](function (err) {
    if (false) {}
  });
}

function isModifiedEvent(event) {
  var target = event.currentTarget.target;
  return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}

function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
  var nodeName = e.currentTarget.nodeName; // anchors inside an svg have a lowercase nodeName

  var isAnchorNodeName = nodeName.toUpperCase() === 'A';

  if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
    // ignore click for browser’s default behavior
    return;
  }

  e.preventDefault();

  var navigate = function navigate() {
    // If the router is an NextRouter instance it will have `beforePopState`
    if ('beforePopState' in router) {
      router[replace ? 'replace' : 'push'](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
      });
    } else {
      router[replace ? 'replace' : 'push'](as || href, {
        forceOptimisticNavigation: !prefetchEnabled
      });
    }
  };

  if (isAppRouter) {
    // @ts-expect-error startTransition exists.
    _react["default"].startTransition(navigate);
  } else {
    navigate();
  }
}

function formatStringOrUrl(urlObjOrString) {
  if (typeof urlObjOrString === 'string') {
    return urlObjOrString;
  }

  return (0, _formatUrl).formatUrl(urlObjOrString);
}
/**
 * React Component that enables client-side transitions between routes.
 */


var Link = /*#__PURE__*/_react["default"].forwardRef(function LinkComponent(props, forwardedRef) {
  if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }

  var children;

  var hrefProp = props.href,
      asProp = props.as,
      childrenProp = props.children,
      prefetchProp = props.prefetch,
      passHref = props.passHref,
      replace = props.replace,
      shallow = props.shallow,
      scroll = props.scroll,
      locale = props.locale,
      _onClick = props.onClick,
      onMouseEnterProp = props.onMouseEnter,
      onTouchStartProp = props.onTouchStart,
      _props$legacyBehavior = props.legacyBehavior,
      legacyBehavior = _props$legacyBehavior === void 0 ? Boolean(true) !== true : _props$legacyBehavior,
      restProps = _object_without_properties_loose(props, ["href", "as", "children", "prefetch", "passHref", "replace", "shallow", "scroll", "locale", "onClick", "onMouseEnter", "onTouchStart", "legacyBehavior"]);

  children = childrenProp;

  if (legacyBehavior && (typeof children === 'string' || typeof children === 'number')) {
    children = /*#__PURE__*/_react["default"].createElement("a", null, children);
  }

  var prefetchEnabled = prefetchProp !== false;

  var pagesRouter = _react["default"].useContext(_routerContext.RouterContext);

  var appRouter = _react["default"].useContext(_appRouterContext.AppRouterContext);

  var router = pagesRouter != null ? pagesRouter : appRouter; // We're in the app directory if there is no pages router.

  var isAppRouter = !pagesRouter;

  var _react$default$useMem = _react["default"].useMemo(function () {
    if (!pagesRouter) {
      var _resolvedHref = formatStringOrUrl(hrefProp);

      return {
        href: _resolvedHref,
        as: asProp ? formatStringOrUrl(asProp) : _resolvedHref
      };
    }

    var _resolveHref = (0, _router).resolveHref(pagesRouter, hrefProp, true),
        _resolveHref2 = _slicedToArray(_resolveHref, 2),
        resolvedHref = _resolveHref2[0],
        resolvedAs = _resolveHref2[1];

    return {
      href: resolvedHref,
      as: asProp ? (0, _router).resolveHref(pagesRouter, asProp) : resolvedAs || resolvedHref
    };
  }, [pagesRouter, hrefProp, asProp]),
      href = _react$default$useMem.href,
      as = _react$default$useMem.as;

  var previousHref = _react["default"].useRef(href);

  var previousAs = _react["default"].useRef(as); // This will return the first child, if multiple are provided it will throw an error


  var child;

  if (legacyBehavior) {
    if (false) {} else {
      child = _react["default"].Children.only(children);
    }
  } else {
    if (false) { var ref; }
  }

  var childRef = legacyBehavior ? child && typeof child === 'object' && child.ref : forwardedRef;

  var _useIntersection2 = (0, _useIntersection).useIntersection({
    rootMargin: '200px'
  }),
      _useIntersection3 = _slicedToArray(_useIntersection2, 3),
      setIntersectionRef = _useIntersection3[0],
      isVisible = _useIntersection3[1],
      resetVisible = _useIntersection3[2];

  var setRef = _react["default"].useCallback(function (el) {
    // Before the link getting observed, check if visible state need to be reset
    if (previousAs.current !== as || previousHref.current !== href) {
      resetVisible();
      previousAs.current = as;
      previousHref.current = href;
    }

    setIntersectionRef(el);

    if (childRef) {
      if (typeof childRef === 'function') childRef(el);else if (typeof childRef === 'object') {
        childRef.current = el;
      }
    }
  }, [as, childRef, href, resetVisible, setIntersectionRef]); // Prefetch the URL if we haven't already and it's visible.


  _react["default"].useEffect(function () {
    if (!router) {
      return;
    } // If we don't need to prefetch the URL, don't do prefetch.


    if (!isVisible || !prefetchEnabled) {
      return;
    } // Prefetch the URL.


    prefetch(router, href, as, {
      locale: locale
    });
  }, [as, href, isVisible, locale, prefetchEnabled, pagesRouter == null ? void 0 : pagesRouter.locale, router]);

  var childProps = {
    ref: setRef,
    onClick: function onClick(e) {
      if (false) {}

      if (!legacyBehavior && typeof _onClick === 'function') {
        _onClick(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }

      if (!router) {
        return;
      }

      if (e.defaultPrevented) {
        return;
      }

      linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled);
    },
    onMouseEnter: function onMouseEnter(e) {
      if (!legacyBehavior && typeof onMouseEnterProp === 'function') {
        onMouseEnterProp(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onMouseEnter === 'function') {
        child.props.onMouseEnter(e);
      }

      if (!router) {
        return;
      }

      if (!prefetchEnabled && isAppRouter) {
        return;
      }

      prefetch(router, href, as, {
        locale: locale,
        priority: true,
        // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
        bypassPrefetchedCheck: true
      });
    },
    onTouchStart: function onTouchStart(e) {
      if (!legacyBehavior && typeof onTouchStartProp === 'function') {
        onTouchStartProp(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onTouchStart === 'function') {
        child.props.onTouchStart(e);
      }

      if (!router) {
        return;
      }

      if (!prefetchEnabled && isAppRouter) {
        return;
      }

      prefetch(router, href, as, {
        locale: locale,
        priority: true,
        // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
        bypassPrefetchedCheck: true
      });
    }
  }; // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user

  if (!legacyBehavior || passHref || child.type === 'a' && !('href' in child.props)) {
    var curLocale = typeof locale !== 'undefined' ? locale : pagesRouter == null ? void 0 : pagesRouter.locale; // we only render domain locales if we are currently on a domain locale
    // so that locale links are still visitable in development/preview envs

    var localeDomain = (pagesRouter == null ? void 0 : pagesRouter.isLocaleDomain) && (0, _getDomainLocale).getDomainLocale(as, curLocale, pagesRouter == null ? void 0 : pagesRouter.locales, pagesRouter == null ? void 0 : pagesRouter.domainLocales);
    childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, pagesRouter == null ? void 0 : pagesRouter.defaultLocale));
  }

  return legacyBehavior ? /*#__PURE__*/_react["default"].cloneElement(child, childProps) : /*#__PURE__*/_react["default"].createElement("a", Object.assign({}, restProps, childProps), children);
});

var _default = Link;
exports["default"] = _default;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 76146:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.normalizeLocalePath = void 0;

var normalizeLocalePath = function normalizeLocalePath(pathname, locales) {
  if (true) {
    return (__webpack_require__(40716).normalizeLocalePath)(pathname, locales);
  }

  return {
    pathname: pathname,
    detectedLocale: undefined
  };
};

exports.normalizeLocalePath = normalizeLocalePath;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 91514:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(44429);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useIntersection = useIntersection;

var _react = __webpack_require__(2784);

var _requestIdleCallback = __webpack_require__(11859);

var hasIntersectionObserver = typeof IntersectionObserver === 'function';
var observers = new Map();
var idList = [];

function createObserver(options) {
  var id = {
    root: options.root || null,
    margin: options.rootMargin || ''
  };
  var existing = idList.find(function (obj) {
    return obj.root === id.root && obj.margin === id.margin;
  });
  var instance;

  if (existing) {
    instance = observers.get(existing);

    if (instance) {
      return instance;
    }
  }

  var elements = new Map();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var callback = elements.get(entry.target);
      var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;

      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  instance = {
    id: id,
    observer: observer,
    elements: elements
  };
  idList.push(id);
  observers.set(id, instance);
  return instance;
}

function observe(element, callback, options) {
  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements;

  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    elements["delete"](element);
    observer.unobserve(element); // Destroy observer when there's nothing left to watch:

    if (elements.size === 0) {
      observer.disconnect();
      observers["delete"](id);
      var index = idList.findIndex(function (obj) {
        return obj.root === id.root && obj.margin === id.margin;
      });

      if (index > -1) {
        idList.splice(index, 1);
      }
    }
  };
}

function useIntersection(_ref) {
  var rootRef = _ref.rootRef,
      rootMargin = _ref.rootMargin,
      disabled = _ref.disabled;
  var isDisabled = disabled || !hasIntersectionObserver;

  var _useState = (0, _react).useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react).useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      element = _useState4[0],
      setElement = _useState4[1];

  (0, _react).useEffect(function () {
    if (hasIntersectionObserver) {
      if (isDisabled || visible) return;

      if (element && element.tagName) {
        var unobserve = observe(element, function (isVisible) {
          return isVisible && setVisible(isVisible);
        }, {
          root: rootRef == null ? void 0 : rootRef.current,
          rootMargin: rootMargin
        });
        return unobserve;
      }
    } else {
      if (!visible) {
        var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function () {
          return setVisible(true);
        });
        return function () {
          return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
        };
      }
    }
  }, [element, isDisabled, rootMargin, rootRef, visible]);
  var resetVisible = (0, _react).useCallback(function () {
    setVisible(false);
  }, []);
  return [setElement, visible, resetVisible];
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 3556:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 39097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(2817)


/***/ }),

/***/ 76831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useLayoutEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var useLayoutEffect = typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
    ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect
    : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;


/***/ }),

/***/ 2212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "animated": function() { return /* reexport safe */ _react_spring_web__WEBPACK_IMPORTED_MODULE_0__.animated; }
/* harmony export */ });
/* harmony import */ var _react_spring_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57747);
/* harmony reexport (checked) */ if(__webpack_require__.o(_react_spring_web__WEBPACK_IMPORTED_MODULE_0__, "config")) __webpack_require__.d(__webpack_exports__, { "config": function() { return _react_spring_web__WEBPACK_IMPORTED_MODULE_0__.config; } });
/* harmony reexport (checked) */ if(__webpack_require__.o(_react_spring_web__WEBPACK_IMPORTED_MODULE_0__, "useTransition")) __webpack_require__.d(__webpack_exports__, { "useTransition": function() { return _react_spring_web__WEBPACK_IMPORTED_MODULE_0__.useTransition; } });



/***/ }),

/***/ 28249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QS": function() { return /* binding */ useSwipeable; }
/* harmony export */ });
/* unused harmony exports DOWN, LEFT, RIGHT, Swipeable, UP */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var defaultProps = {
  preventDefaultTouchmoveEvent: false,
  delta: 10,
  rotationAngle: 0,
  trackMouse: false,
  trackTouch: true
};
var initialState = {
  xy: [0, 0],
  swiping: false,
  eventData: undefined,
  start: undefined
};
var LEFT = 'Left';
var RIGHT = 'Right';
var UP = 'Up';
var DOWN = 'Down';
var touchStart = 'touchstart';
var touchMove = 'touchmove';
var touchEnd = 'touchend';
var mouseMove = 'mousemove';
var mouseUp = 'mouseup';

function getDirection(absX, absY, deltaX, deltaY) {
  if (absX > absY) {
    if (deltaX > 0) {
      return LEFT;
    }

    return RIGHT;
  } else if (deltaY > 0) {
    return UP;
  }

  return DOWN;
}

function rotateXYByAngle(pos, angle) {
  if (angle === 0) return pos;
  var angleInRadians = Math.PI / 180 * angle;
  var x = pos[0] * Math.cos(angleInRadians) + pos[1] * Math.sin(angleInRadians);
  var y = pos[1] * Math.cos(angleInRadians) - pos[0] * Math.sin(angleInRadians);
  return [x, y];
}

function getHandlers(set, handlerProps) {
  var onStart = function onStart(event) {
    // if more than a single touch don't track, for now...
    if (event.touches && event.touches.length > 1) return;
    set(function (state, props) {
      // setup mouse listeners on document to track swipe since swipe can leave container
      if (props.trackMouse) {
        document.addEventListener(mouseMove, onMove);
        document.addEventListener(mouseUp, onUp);
      }

      var _ref = event.touches ? event.touches[0] : event,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      var xy = rotateXYByAngle([clientX, clientY], props.rotationAngle);
      return _extends({}, state, initialState, {
        eventData: {
          initial: [].concat(xy),
          first: true
        },
        xy: xy,
        start: event.timeStamp || 0
      });
    });
  };

  var onMove = function onMove(event) {
    set(function (state, props) {
      if (!state.xy[0] || !state.xy[1] || event.touches && event.touches.length > 1) {
        return state;
      }

      var _ref2 = event.touches ? event.touches[0] : event,
          clientX = _ref2.clientX,
          clientY = _ref2.clientY;

      var _rotateXYByAngle = rotateXYByAngle([clientX, clientY], props.rotationAngle),
          x = _rotateXYByAngle[0],
          y = _rotateXYByAngle[1];

      var deltaX = state.xy[0] - x;
      var deltaY = state.xy[1] - y;
      var absX = Math.abs(deltaX);
      var absY = Math.abs(deltaY);
      var time = (event.timeStamp || 0) - state.start;
      var velocity = Math.sqrt(absX * absX + absY * absY) / (time || 1); // if swipe is under delta and we have not started to track a swipe: skip update

      if (absX < props.delta && absY < props.delta && !state.swiping) return state;
      var dir = getDirection(absX, absY, deltaX, deltaY);

      var eventData = _extends({}, state.eventData, {
        event: event,
        absX: absX,
        absY: absY,
        deltaX: deltaX,
        deltaY: deltaY,
        velocity: velocity,
        dir: dir
      });

      props.onSwiping && props.onSwiping(eventData); // track if a swipe is cancelable(handler for swiping or swiped(dir) exists)
      // so we can call preventDefault if needed

      var cancelablePageSwipe = false;

      if (props.onSwiping || props.onSwiped || props["onSwiped" + dir]) {
        cancelablePageSwipe = true;
      }

      if (cancelablePageSwipe && props.preventDefaultTouchmoveEvent && props.trackTouch && event.cancelable) event.preventDefault(); // first is now always false

      return _extends({}, state, {
        eventData: _extends({}, eventData, {
          first: false
        }),
        swiping: true
      });
    });
  };

  var onEnd = function onEnd(event) {
    set(function (state, props) {
      var eventData;

      if (state.swiping) {
        eventData = _extends({}, state.eventData, {
          event: event
        });
        props.onSwiped && props.onSwiped(eventData);
        props["onSwiped" + eventData.dir] && props["onSwiped" + eventData.dir](eventData);
      }

      return _extends({}, state, initialState, {
        eventData: eventData
      });
    });
  };

  var cleanUpMouse = function cleanUpMouse() {
    // safe to just call removeEventListener
    document.removeEventListener(mouseMove, onMove);
    document.removeEventListener(mouseUp, onUp);
  };

  var onUp = function onUp(e) {
    cleanUpMouse();
    onEnd(e);
  };

  var attachTouch = function attachTouch(el) {
    if (el && el.addEventListener) {
      // attach touch event listeners and handlers
      var tls = [[touchStart, onStart], [touchMove, onMove], [touchEnd, onEnd]];
      tls.forEach(function (_ref3) {
        var e = _ref3[0],
            h = _ref3[1];
        return el.addEventListener(e, h);
      }); // return properly scoped cleanup method for removing listeners

      return function () {
        return tls.forEach(function (_ref4) {
          var e = _ref4[0],
              h = _ref4[1];
          return el.removeEventListener(e, h);
        });
      };
    }
  };

  var onRef = function onRef(el) {
    // "inline" ref functions are called twice on render, once with null then again with DOM element
    // ignore null here
    if (el === null) return;
    set(function (state, props) {
      // if the same DOM el as previous just return state
      if (state.el === el) return state;
      var addState = {}; // if new DOM el clean up old DOM and reset cleanUpTouch

      if (state.el && state.el !== el && state.cleanUpTouch) {
        state.cleanUpTouch();
        addState.cleanUpTouch = null;
      } // only attach if we want to track touch


      if (props.trackTouch && el) {
        addState.cleanUpTouch = attachTouch(el);
      } // store event attached DOM el for comparison, clean up, and re-attachment


      return _extends({}, state, {
        el: el
      }, addState);
    });
  }; // set ref callback to attach touch event listeners


  var output = {
    ref: onRef // if track mouse attach mouse down listener

  };

  if (handlerProps.trackMouse) {
    output.onMouseDown = onStart;
  }

  return [output, attachTouch];
}

function updateTransientState(state, props, attachTouch) {
  var addState = {}; // clean up touch handlers if no longer tracking touches

  if (!props.trackTouch && state.cleanUpTouch) {
    state.cleanUpTouch();
    addState.cleanUpTouch = null;
  } else if (props.trackTouch && !state.cleanUpTouch) {
    // attach/re-attach touch handlers
    if (state.el) {
      addState.cleanUpTouch = attachTouch(state.el);
    }
  }

  return _extends({}, state, addState);
}

function useSwipeable(props) {
  var trackMouse = props.trackMouse;
  var transientState = react__WEBPACK_IMPORTED_MODULE_0__.useRef(_extends({}, initialState, {
    type: 'hook'
  }));
  var transientProps = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  transientProps.current = _extends({}, defaultProps, props);

  var _React$useMemo = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    return getHandlers(function (cb) {
      return transientState.current = cb(transientState.current, transientProps.current);
    }, {
      trackMouse: trackMouse
    });
  }, [trackMouse]),
      handlers = _React$useMemo[0],
      attachTouch = _React$useMemo[1];

  transientState.current = updateTransientState(transientState.current, transientProps.current, attachTouch);
  return handlers;
}
var Swipeable =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(Swipeable, _React$PureComponent);

  function Swipeable(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;

    _this._set = function (cb) {
      _this.transientState = cb(_this.transientState, _this.props);
    };

    _this.transientState = _extends({}, initialState, {
      type: 'class'
    });
    return _this;
  }

  var _proto = Swipeable.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        style = _this$props.style,
        _this$props$nodeName = _this$props.nodeName,
        nodeName = _this$props$nodeName === void 0 ? 'div' : _this$props$nodeName,
        innerRef = _this$props.innerRef,
        children = _this$props.children,
        trackMouse = _this$props.trackMouse;

    var _getHandlers = getHandlers(this._set, {
      trackMouse: trackMouse
    }),
        handlers = _getHandlers[0],
        attachTouch = _getHandlers[1];

    this.transientState = updateTransientState(this.transientState, this.props, attachTouch);
    var ref = innerRef ? function (el) {
      return innerRef(el), handlers.ref(el);
    } : handlers.ref;
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(nodeName, _extends({}, handlers, {
      className: className,
      style: style,
      ref: ref
    }), children);
  };

  return Swipeable;
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent);
Swipeable.propTypes = {
  onSwiped: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  onSwiping: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  onSwipedUp: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  onSwipedRight: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  onSwipedDown: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  onSwipedLeft: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  delta: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number),
  preventDefaultTouchmoveEvent: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  nodeName: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  trackMouse: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  trackTouch: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
  innerRef: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func),
  rotationAngle: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)
};
Swipeable.defaultProps = defaultProps;




/***/ }),

/***/ 89565:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// Copyright 2023 Google LLC
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.YouTubeEmbed = exports.GoogleMapsEmbed = exports.GoogleAnalytics = void 0;
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//     https://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var google_analytics_1 = __webpack_require__(77386);
Object.defineProperty(exports, "GoogleAnalytics", ({ enumerable: true, get: function () { return google_analytics_1.GoogleAnalytics; } }));
var google_maps_embed_1 = __webpack_require__(75377);
Object.defineProperty(exports, "GoogleMapsEmbed", ({ enumerable: true, get: function () { return google_maps_embed_1.GoogleMapsEmbed; } }));
var youtube_embed_1 = __webpack_require__(82415);
Object.defineProperty(exports, "YouTubeEmbed", ({ enumerable: true, get: function () { return youtube_embed_1.YouTubeEmbed; } }));


/***/ }),

/***/ 77386:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// Copyright 2023 Google LLC
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GoogleAnalytics = void 0;
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//     https://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
const data_json_1 = __importDefault(__webpack_require__(48847));
const utils_1 = __webpack_require__(35539);
const GoogleAnalytics = (_a) => {
    var args = __rest(_a, []);
    return (0, utils_1.formatData)(data_json_1.default, args);
};
exports.GoogleAnalytics = GoogleAnalytics;


/***/ }),

/***/ 75377:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// Copyright 2023 Google LLC
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.GoogleMapsEmbed = void 0;
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//     https://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
const data_json_1 = __importDefault(__webpack_require__(13240));
const utils_1 = __webpack_require__(35539);
const GoogleMapsEmbed = (_a) => {
    var args = __rest(_a, []);
    return (0, utils_1.formatData)(data_json_1.default, args);
};
exports.GoogleMapsEmbed = GoogleMapsEmbed;


/***/ }),

/***/ 82415:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// Copyright 2023 Google LLC
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.YouTubeEmbed = void 0;
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//     https://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
const data_json_1 = __importDefault(__webpack_require__(51991));
const utils_1 = __webpack_require__(35539);
const YouTubeEmbed = (_a) => {
    var args = __rest(_a, []);
    return (0, utils_1.formatData)(data_json_1.default, args);
};
exports.YouTubeEmbed = YouTubeEmbed;


/***/ }),

/***/ 35539:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.formatData = exports.createHtml = exports.formatUrl = void 0;
function filterArgs(args, selectedArgs, inverse = false) {
    if (!selectedArgs)
        return {};
    return Object.keys(args)
        .filter((key) => inverse ? !selectedArgs.includes(key) : selectedArgs.includes(key))
        .reduce((obj, key) => {
        obj[key] = args[key];
        return obj;
    }, {});
}
// Add all required search params with user inputs as values
function formatUrl(url, params, args, slug) {
    const newUrl = slug && Object.keys(slug).length > 0
        ? new URL(Object.values(slug)[0], url) // If there's a user inputted param for the URL slug, replace the default existing slug or include it
        : new URL(url);
    if (params && args) {
        params.forEach((param) => {
            if (args[param])
                newUrl.searchParams.set(param, args[param]);
        });
    }
    return newUrl.toString();
}
exports.formatUrl = formatUrl;
// Construct HTML element and include all default attributes and user-inputted attributes
function createHtml(element, attributes, htmlAttrArgs, urlQueryParamArgs, slugParamArg) {
    var _a;
    if (!attributes)
        return `<${element}></${element}>`;
    const formattedAttributes = ((_a = attributes.src) === null || _a === void 0 ? void 0 : _a.url)
        ? Object.assign(Object.assign({}, attributes), { src: formatUrl(attributes.src.url, attributes.src.params, urlQueryParamArgs, slugParamArg) }) : attributes;
    const htmlAttributes = Object.keys(Object.assign(Object.assign({}, formattedAttributes), htmlAttrArgs)).reduce((acc, name) => {
        const userVal = htmlAttrArgs === null || htmlAttrArgs === void 0 ? void 0 : htmlAttrArgs[name];
        const defaultVal = formattedAttributes[name];
        const finalVal = userVal !== null && userVal !== void 0 ? userVal : defaultVal; // overwrite
        const attrString = finalVal === true ? name : `${name}="${finalVal}"`;
        return finalVal ? acc + ` ${attrString}` : acc;
    }, '');
    return `<${element}${htmlAttributes}></${element}>`;
}
exports.createHtml = createHtml;
// Format JSON by including all default and user-required parameters
function formatData(data, args) {
    var _a, _b, _c, _d, _e;
    const allScriptParams = (_a = data.scripts) === null || _a === void 0 ? void 0 : _a.reduce((acc, script) => [
        ...acc,
        ...(Array.isArray(script.params) ? script.params : []),
    ], []);
    // First, find all input arguments that map to parameters passed to script URLs
    const scriptUrlParamInputs = filterArgs(args, allScriptParams);
    // Second, find all input arguments that map to parameters passed to the HTML src attribute
    const htmlUrlParamInputs = filterArgs(args, (_c = (_b = data.html) === null || _b === void 0 ? void 0 : _b.attributes.src) === null || _c === void 0 ? void 0 : _c.params);
    // Third, find the input argument that maps to the slug parameter passed to the HTML src attribute if present
    const htmlSlugParamInput = filterArgs(args, [
        (_e = (_d = data.html) === null || _d === void 0 ? void 0 : _d.attributes.src) === null || _e === void 0 ? void 0 : _e.slugParam,
    ]);
    // Lastly, all remaining arguments are forwarded as separate HTML attributes
    const htmlAttrInputs = filterArgs(args, [
        ...Object.keys(scriptUrlParamInputs),
        ...Object.keys(htmlUrlParamInputs),
        ...Object.keys(htmlSlugParamInput),
    ], true);
    return Object.assign(Object.assign({}, data), { 
        // Pass any custom attributes to HTML content
        html: data.html
            ? createHtml(data.html.element, data.html.attributes, htmlAttrInputs, htmlUrlParamInputs, htmlSlugParamInput)
            : null, 
        // Pass any required query params with user values for relevant scripts
        scripts: data.scripts
            ? data.scripts.map((script) => (Object.assign(Object.assign({}, script), { url: formatUrl(script.url, script.params, scriptUrlParamInputs) })))
            : null });
}
exports.formatData = formatData;


/***/ }),

/***/ 92387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c0": function() { return /* binding */ useDrag; }
/* harmony export */ });
/* unused harmony exports addV, rubberbandIfOutOfBounds, subV, useGesture, useHover, useMove, usePinch, useScroll, useWheel */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


// vector add
function addV(v1, v2) {
  return v1.map(function (v, i) {
    return v + v2[i];
  });
} // vector substract

function subV(v1, v2) {
  return v1.map(function (v, i) {
    return v - v2[i];
  });
}
/**
 * Calculates velocity
 * @param delta the difference between current and previous vectors
 * @param delta_t the time offset
 * @param len the length of the delta vector
 * @returns velocity
 */

function calculateVelocity(delta, delta_t, len) {
  len = len || Math.hypot.apply(Math, delta);
  return delta_t ? len / delta_t : 0;
}
/**
 * Calculates velocities vector
 * @template T the expected vector type
 * @param delta the difference between current and previous vectors
 * @param delta_t the time offset
 * @returns velocities vector
 */

function calculateVelocities(delta, delta_t) {
  return delta_t ? delta.map(function (v) {
    return v / delta_t;
  }) : Array(delta.length).fill(0);
}
/**
 * Calculates distance
 * @param movement the difference between current and initial vectors
 * @returns distance
 */

function calculateDistance(movement) {
  return Math.hypot.apply(Math, movement);
}
/**
 * Calculates direction
 * @template T the expected vector type
 * @param delta
 * @param len
 * @returns direction
 */

function calculateDirection(delta, len) {
  len = len || Math.hypot.apply(Math, delta) || 1;
  return delta.map(function (v) {
    return v / len;
  });
}
/**
 * Calculates all kinematics
 * @template T the expected vector type
 * @param movement the difference between current and initial vectors
 * @param delta the difference between current and previous vectors
 * @param delta_t the time difference between current and previous timestamps
 * @returns all kinematics
 */

function calculateAllKinematics(movement, delta, delta_t) {
  var len = Math.hypot.apply(Math, delta);
  return {
    velocities: calculateVelocities(delta, delta_t),
    velocity: calculateVelocity(delta, delta_t, len),
    distance: calculateDistance(movement),
    direction: calculateDirection(delta, len)
  };
}
/**
 * Because IE doesn't support `Math.sign` function, so we use the polyfill version of the function.
 * This polyfill function is suggested by Mozilla
 * :https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign#Polyfill
 * @param x target number
 */

function sign(x) {
  if (Math.sign) return Math.sign(x);
  return Number(x > 0) - Number(x < 0) || +x;
}
function getIntentionalDisplacement(movement, threshold) {
  var abs = Math.abs(movement);
  return abs >= threshold ? sign(movement) * threshold : false;
}

function minMax(value, min, max) {
  return Math.max(min, Math.min(value, max));
} // Based on @aholachek ;)
// https://twitter.com/chpwn/status/285540192096497664
// iOS constant = 0.55
// https://medium.com/@nathangitter/building-fluid-interfaces-ios-swift-9732bb934bf5


function rubberband2(distance, constant) {
  // default constant from the article is 0.7
  return Math.pow(distance, constant * 5);
}

function rubberband(distance, dimension, constant) {
  if (dimension === 0 || Math.abs(dimension) === Infinity) return rubberband2(distance, constant);
  return distance * dimension * constant / (dimension + constant * distance);
}

function rubberbandIfOutOfBounds(position, min, max, constant) {
  if (constant === void 0) {
    constant = 0.15;
  }

  if (constant === 0) return minMax(position, min, max);

  if (position < min) {
    return -rubberband(min - position, max - min, constant) + min;
  }

  if (position > max) {
    return rubberband(position - max, max - min, constant) + max;
  }

  return position;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o) {
  var i = 0;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  i = o[Symbol.iterator]();
  return i.next.bind(i);
}

// blank function
function noop() {} // returns a function that chains all functions given as parameters

var chainFns = function chainFns() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return fns.forEach(function (fn) {
      return fn.apply(void 0, args);
    });
  };
};
var def = {
  array: function array(value) {
    return Array.isArray(value) ? value : [value, value];
  },
  withDefault: function withDefault(value, defaultIfUndefined) {
    return value !== void 0 ? value : defaultIfUndefined;
  }
};
function matchKeysFromObject(obj, matchingObject) {
  var o = {};
  Object.entries(obj).forEach(function (_ref) {
    var key = _ref[0],
        value = _ref[1];
    return (value !== void 0 || key in matchingObject) && (o[key] = value);
  });
  return o;
}
function valueFn(v) {
  return typeof v === 'function' ? v() : v;
}

function getInitialState() {
  // common initial state for all gestures
  var initialCommon = {
    _active: false,
    _blocked: false,
    _intentional: [false, false],
    _movement: [0, 0],
    _initial: [0, 0],
    _lastEventType: undefined,
    event: undefined,
    // currentTarget: undefined,
    // pointerId: undefined,
    values: [0, 0],
    velocities: [0, 0],
    delta: [0, 0],
    movement: [0, 0],
    offset: [0, 0],
    lastOffset: [0, 0],
    direction: [0, 0],
    initial: [0, 0],
    previous: [0, 0],
    first: false,
    last: false,
    active: false,
    timeStamp: 0,
    startTime: 0,
    elapsedTime: 0,
    cancel: noop,
    canceled: false,
    memo: undefined,
    args: undefined
  }; // initial state for coordinates-based gestures

  var initialCoordinates = {
    axis: undefined,
    xy: [0, 0],
    vxvy: [0, 0],
    velocity: 0,
    distance: 0
  }; // initial state for distance and angle-based gestures (pinch)

  var initialDistanceAngle = {
    da: [0, 0],
    vdva: [0, 0],
    origin: undefined,
    turns: 0
  }; // initial state object (used by the gesture controller)

  return {
    shared: {
      hovering: false,
      scrolling: false,
      wheeling: false,
      dragging: false,
      moving: false,
      pinching: false,
      touches: 0,
      buttons: 0,
      down: false,
      shiftKey: false,
      altKey: false,
      metaKey: false,
      ctrlKey: false
    },
    drag: _extends(_extends(_extends({}, initialCommon), initialCoordinates), {}, {
      _isTap: true,
      _delayedEvent: false,
      tap: false,
      swipe: [0, 0]
    }),
    pinch: _extends(_extends({}, initialCommon), initialDistanceAngle),
    wheel: _extends(_extends({}, initialCommon), initialCoordinates),
    move: _extends(_extends({}, initialCommon), initialCoordinates),
    scroll: _extends(_extends({}, initialCommon), initialCoordinates)
  };
}

var setListeners = function setListeners(add) {
  return function (el, listeners, options) {
    var action = add ? 'addEventListener' : 'removeEventListener';
    listeners.forEach(function (_ref) {
      var eventName = _ref[0],
          fn = _ref[1];
      return el[action](eventName, fn, options);
    });
  };
};
/**
 * Whether the browser supports GestureEvent (ie Safari)
 * @returns true if the browser supports gesture event
 */


function supportsGestureEvents() {
  try {
    // TODO [TS] possibly find GestureEvent definitions?
    // @ts-ignore: no type definitions for webkit GestureEvents
    return 'constructor' in GestureEvent;
  } catch (e) {
    return false;
  }
}
var addListeners = /*#__PURE__*/setListeners(true);
var removeListeners = /*#__PURE__*/setListeners(false);
/**
 * Gets modifier keys from event
 * @param event
 * @returns modifier keys
 */

function getModifierKeys(event) {
  var shiftKey = event.shiftKey,
      altKey = event.altKey,
      metaKey = event.metaKey,
      ctrlKey = event.ctrlKey;
  return {
    shiftKey: shiftKey,
    altKey: altKey,
    metaKey: metaKey,
    ctrlKey: ctrlKey
  };
}

function getTouchEvents(event) {
  if ('touches' in event) {
    var touches = event.touches,
        changedTouches = event.changedTouches;
    return touches.length > 0 ? touches : changedTouches;
  }

  return null;
}

function getGenericEventData(event) {
  var buttons = 'buttons' in event ? event.buttons : 0;
  var touchEvents = getTouchEvents(event);
  var touches = touchEvents && touchEvents.length || 0;
  var down = touches > 0 || buttons > 0;
  return _extends({
    touches: touches,
    down: down,
    buttons: buttons
  }, getModifierKeys(event));
}
/**
 * Gets scroll event values
 * @param event
 * @returns scroll event values
 */

function getScrollEventValues(event) {
  // If the currentTarget is the window then we return the scrollX/Y position.
  // If not (ie the currentTarget is a DOM element), then we return scrollLeft/Top
  var _event$currentTarget = event.currentTarget,
      scrollX = _event$currentTarget.scrollX,
      scrollY = _event$currentTarget.scrollY,
      scrollLeft = _event$currentTarget.scrollLeft,
      scrollTop = _event$currentTarget.scrollTop;
  return {
    values: [scrollX || scrollLeft || 0, scrollY || scrollTop || 0]
  };
}
/**
 * Gets wheel event values.
 * @param event
 * @returns wheel event values
 */

function getWheelEventValues(event) {
  var deltaX = event.deltaX,
      deltaY = event.deltaY; //TODO implement polyfill ?
  // https://developer.mozilla.org/en-US/docs/Web/Events/wheel#Polyfill

  return {
    values: [deltaX, deltaY]
  };
}
/**
 * Gets pointer event values.
 * @param event
 * @returns pointer event values
 */

function getPointerEventValues(event) {
  var touchEvents = getTouchEvents(event);

  var _ref2 = touchEvents ? touchEvents[0] : event,
      clientX = _ref2.clientX,
      clientY = _ref2.clientY;

  return {
    values: [clientX, clientY]
  };
}
var WEBKIT_DISTANCE_SCALE_FACTOR = 260;
/**
 * Gets webkit gesture event values.
 * @param event
 * @returns webkit gesture event values
 */

function getWebkitGestureEventValues(event) {
  return {
    values: [event.scale * WEBKIT_DISTANCE_SCALE_FACTOR, event.rotation]
  };
}
/**
 * Gets two touches event data
 * @param event
 * @returns two touches event data
 */

function getTwoTouchesEventData(event) {
  var touches = event.touches;
  var dx = touches[1].clientX - touches[0].clientX;
  var dy = touches[1].clientY - touches[0].clientY;
  var values = [Math.hypot(dx, dy), -(Math.atan2(dx, dy) * 180) / Math.PI];
  var origin = [(touches[1].clientX + touches[0].clientX) / 2, (touches[1].clientY + touches[0].clientY) / 2];
  return {
    values: values,
    origin: origin
  };
}

/**
 * The controller will keep track of the state for all gestures and also keep
 * track of timeouts, and window listeners.
 *
 * @template BinderType the type the bind function should return
 */

var Controller = function Controller() {
  var _this = this;

  this.state = getInitialState(); // state for all gestures

  this.timeouts = {}; // keeping track of timeouts for debounced gestures (such as move, scroll, wheel)

  this.domListeners = []; // when config.domTarget is set, we attach events directly to the dom

  this.windowListeners = {}; // keeps track of window listeners added by gestures (drag only at the moment)

  this.bindings = {}; // an object holding the handlers associated to the gestures

  /**
   * Function ran on component unmount: cleans timeouts and removes dom listeners set by the bind function.
   */

  this.clean = function () {
    _this.resetBindings();

    Object.values(_this.timeouts).forEach(clearTimeout);
    Object.keys(_this.windowListeners).forEach(function (stateKey) {
      return _this.removeWindowListeners(stateKey);
    });
  };
  /**
   * Function run every time the bind function is run (ie on every render).
   * Resets the binding object and remove dom listeners attached to config.domTarget
   */


  this.resetBindings = function () {
    _this.bindings = {};

    var domTarget = _this.getDomTarget();

    if (domTarget) {
      removeListeners(domTarget, _this.domListeners, _this.config.eventOptions);
      _this.domListeners = [];
    }
  };
  /**
   * Returns the domTarget element and parses a ref if needed.
   */


  this.getDomTarget = function () {
    var domTarget = _this.config.domTarget;
    return domTarget && 'current' in domTarget ? domTarget.current : domTarget;
  };
  /**
   * Commodity function to let recognizers simply add listeners to config.window.
   */


  this.addWindowListeners = function (stateKey, listeners) {
    if (!_this.config.window) return; // we use this.windowListeners to keep track of the listeners we add

    _this.windowListeners[stateKey] = listeners;
    addListeners(_this.config.window, listeners, _this.config.eventOptions);
  };
  /**
   * Commodity function to let recognizers simply remove listeners to config.window.
   */


  this.removeWindowListeners = function (stateKey) {
    if (!_this.config.window) return;
    var listeners = _this.windowListeners[stateKey];

    if (listeners) {
      removeListeners(_this.config.window, listeners, _this.config.eventOptions);
      delete _this.windowListeners[stateKey];
    }
  };
  /**
   * When config.domTarget is set, this function will add dom listeners to it
   */


  this.addDomTargetListeners = function (target) {
    /** We iterate on the entries of this.binding for each event, then we chain
     * the array of functions mapped to it and push them to this.domListeners
     */
    Object.entries(_this.bindings).forEach(function (_ref) {
      var event = _ref[0],
          fns = _ref[1];

      _this.domListeners.push([event.substr(2).toLowerCase(), chainFns.apply(void 0, fns)]);
    });
    addListeners(target, _this.domListeners, _this.config.eventOptions);
  };
  /**
   * this.bindings is an object which keys match ReactEventHandlerKeys.
   * Since a recognizer might want to bind a handler function to an event key already used by a previously
   * added recognizer, we need to make sure that each event key is an array of all the functions mapped for
   * that key.
   */


  this.addBindings = function (eventNames, fn) {
    var eventNamesArray = !Array.isArray(eventNames) ? [eventNames] : eventNames;
    eventNamesArray.forEach(function (eventName) {
      if (_this.bindings[eventName]) _this.bindings[eventName].push(fn);else _this.bindings[eventName] = [fn];
    });
  };
  /**
   * getBindings will return an object that will be bound by users
   * to the react component they want to interact with.
   */


  this.getBindings = function () {
    var bindings = {};
    var captureString = _this.config.captureString;
    Object.entries(_this.bindings).forEach(function (_ref2) {
      var event = _ref2[0],
          fns = _ref2[1];
      var fnsArray = Array.isArray(fns) ? fns : [fns];
      var key = event + captureString;
      bindings[key] = chainFns.apply(void 0, fnsArray);
    });
    return bindings;
  };

  this.getBind = function () {
    // If config.domTarget is set we add event listeners to it and return the clean function.
    if (_this.config.domTarget) {
      var domTarget = _this.getDomTarget();

      domTarget && _this.addDomTargetListeners(domTarget);
      return _this.clean;
    } // If not, we return an object that contains gesture handlers mapped to react handler event keys.


    return _this.getBindings();
  };
};

/**
 * @private
 *
 * Utility hook called by all gesture hooks and that will be responsible for the internals.
 *
 * @param {Partial<InternalHandlers>} handlers
 * @param {RecognizerClasses} classes
 * @param {InternalConfig} config
 * @param {NativeHandlersPartial} nativeHandlers - native handlers such as onClick, onMouseDown, etc.
 * @returns {(...args: any[]) => HookReturnType<Config>}
 */

function useRecognizers(handlers, classes, config, nativeHandlers) {
  // The gesture controller keeping track of all gesture states
  var controller = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    var current = new Controller();
    /**
     * The bind function will create gesture recognizers and return the right
     * bind object depending on whether `domTarget` was specified in the config object.
     */

    var bind = function bind() {
      current.resetBindings();

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      for (var _iterator = _createForOfIteratorHelperLoose(classes), _step; !(_step = _iterator()).done;) {
        var RecognizerClass = _step.value;
        new RecognizerClass(current, args).addBindings();
      } // we also add event bindings for native handlers


      if (controller.nativeRefs) {
        for (var eventName in controller.nativeRefs) {
          current.addBindings(eventName, // @ts-ignore we're cheating when it comes to event type :(
          controller.nativeRefs[eventName]);
        }
      }

      return current.getBind();
    };

    return {
      nativeRefs: nativeHandlers,
      current: current,
      bind: bind
    };
  }, []); // We reassign the config and handlers to the controller on every render.

  controller.current.config = config;
  controller.current.handlers = handlers; // We assign nativeHandlers, otherwise they won't be refreshed on the next render.

  controller.nativeRefs = nativeHandlers; // Run controller clean functions on unmount.

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    return controller.current.clean;
  }, []);
  return controller.bind;
}

/**
 * @private
 * Recognizer abstract class.
 *
 * @protected
 * @abstract
 * @type {StateKey<T>} whether the Recognizer should deal with coordinates or distance / angle
 */

var Recognizer = /*#__PURE__*/function () {
  /**
   * Creates an instance of a gesture recognizer.
   * @param stateKey drag, move, pinch, etc.
   * @param controller the controller attached to the gesture
   * @param [args] the args that should be passed to the gesture handler
   */
  function Recognizer(stateKey, controller, args) {
    var _this = this;

    if (args === void 0) {
      args = [];
    }

    this.stateKey = stateKey;
    this.controller = controller;
    this.args = args;
    this.debounced = true; // Convenience method to set a timeout for a given gesture

    this.setTimeout = function (callback, ms) {
      var _window;

      if (ms === void 0) {
        ms = 140;
      }

      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      _this.controller.timeouts[_this.stateKey] = (_window = window).setTimeout.apply(_window, [callback, ms].concat(args));
    }; // Convenience method to clear a timeout for a given gesture


    this.clearTimeout = function () {
      clearTimeout(_this.controller.timeouts[_this.stateKey]);
    }; // Convenience method to add window listeners for a given gesture


    this.addWindowListeners = function (listeners) {
      _this.controller.addWindowListeners(_this.stateKey, listeners);
    }; // Convenience method to remove window listeners for a given gesture


    this.removeWindowListeners = function () {
      _this.controller.removeWindowListeners(_this.stateKey);
    };
    /**
     * Returns the reinitialized start state for the gesture.
     * Should be common to all gestures.
     *
     * @param {Vector2} values
     * @param {UseGestureEvent} event
     * @returns - the start state for the gesture
     */


    this.getStartGestureState = function (values, event) {
      return _extends(_extends({}, getInitialState()[_this.stateKey]), {}, {
        _active: true,
        values: values,
        initial: values,
        offset: _this.state.offset,
        lastOffset: _this.state.offset,
        startTime: event.timeStamp
      });
    }; // Runs rubberband on a vector


    this.rubberband = function (vector, rubberband) {
      var bounds = _this.config.bounds;
      /**
       * [x, y]: [rubberband(x, min, max), rubberband(y, min, max)]
       */

      return vector.map(function (v, i) {
        return rubberbandIfOutOfBounds(v, bounds[i][0], bounds[i][1], rubberband[i]);
      });
    };
    /**
     * Fires the gesture handler
     *
     * @param {boolean} [forceFlag] - if true, then the handler will fire even if the gesture is not intentional
     */


    this.fireGestureHandler = function (forceFlag) {
      /**
       * If the gesture has been blocked (this can happen when the gesture has started in an unwanted direction),
       * clean everything and don't do anything.
       */
      if (_this.state._blocked) {
        // we need debounced gestures to end by themselves
        if (!_this.debounced) {
          _this.state._active = false;

          _this.clean();
        }

        return null;
      } // If the gesture has no intentional dimension, don't do fire the handler.


      var _this$state$_intentio = _this.state._intentional,
          intentionalX = _this$state$_intentio[0],
          intentionalY = _this$state$_intentio[1];
      if (!forceFlag && intentionalX === false && intentionalY === false) return null;
      var _this$state = _this.state,
          _active = _this$state._active,
          active = _this$state.active;
      _this.state.active = _active;
      _this.state.first = _active && !active; // `first` is true when the gesture becomes active

      _this.state.last = active && !_active; // `last` is true when the gesture becomes inactive

      _this.controller.state.shared[_this.ingKey] = _active; // Sets dragging, pinching, etc. to the gesture active state

      var state = _extends(_extends(_extends({}, _this.controller.state.shared), _this.state), _this.mapStateValues(_this.state)); // @ts-ignore


      var newMemo = _this.handler(state); // Sets memo to the returned value of the handler (unless it's not undefined)


      _this.state.memo = newMemo !== void 0 ? newMemo : _this.state.memo; // Cleans the gesture when the gesture is no longer active.

      if (!_active) _this.clean();
      return state;
    };
  } // Returns the gesture config


  var _proto = Recognizer.prototype;

  // Conveninence method to update the shared state
  _proto.updateSharedState = function updateSharedState(sharedState) {
    Object.assign(this.controller.state.shared, sharedState);
  } // Conveninence method to update the gesture state
  ;

  _proto.updateGestureState = function updateGestureState(gestureState) {
    Object.assign(this.state, gestureState);
  }
  /**
   * Returns a generic, common payload for all gestures from an event.
   *
   * @param {UseGestureEvent} event
   * @param {boolean} [isStartEvent]
   * @returns - the generic gesture payload
   */
  ;

  _proto.getGenericPayload = function getGenericPayload(event, isStartEvent) {
    var timeStamp = event.timeStamp,
        type = event.type;
    var _this$state2 = this.state,
        values = _this$state2.values,
        startTime = _this$state2.startTime;
    return {
      _lastEventType: type,
      event: event,
      timeStamp: timeStamp,
      elapsedTime: isStartEvent ? 0 : timeStamp - startTime,
      args: this.args,
      previous: values
    };
  }
  /**
   * Returns state properties depending on the movement and state.
   *
   * Should be overriden for custom behavior, doesn't do anything in the implementation
   * below.
   */
  ;

  _proto.checkIntentionality = function checkIntentionality(_intentional, _movement, _state) {
    return {
      _intentional: _intentional,
      _blocked: false
    };
  }
  /**
   * Returns basic movement properties for the gesture based on the next values and current state.
   */
  ;

  _proto.getMovement = function getMovement(values, state) {
    if (state === void 0) {
      state = this.state;
    }

    var _this$config = this.config,
        initial = _this$config.initial,
        threshold = _this$config.threshold,
        rubberband = _this$config.rubberband;
    var t0 = threshold[0],
        t1 = threshold[1];
    var _state2 = state,
        _initial = _state2._initial,
        _active = _state2._active,
        intentional = _state2._intentional,
        lastOffset = _state2.lastOffset,
        prevMovement = _state2.movement;
    var i0 = intentional[0],
        i1 = intentional[1];

    var _this$getInternalMove = this.getInternalMovement(values, state),
        _m0 = _this$getInternalMove[0],
        _m1 = _this$getInternalMove[1];
    /**
     * For both dimensions of the gesture, check its intentionality on each frame.
     */


    if (i0 === false) {
      i0 = getIntentionalDisplacement(_m0, t0);
    }

    if (i1 === false) {
      i1 = getIntentionalDisplacement(_m1, t1);
    } // Get gesture specific state properties based on intentionality and movement.


    var intentionalityCheck = this.checkIntentionality([i0, i1], [_m0, _m1], state);
    var _intentional = intentionalityCheck._intentional,
        _blocked = intentionalityCheck._blocked;
    var _i0 = _intentional[0],
        _i1 = _intentional[1];
    var _movement = [_m0, _m1];
    if (_i0 !== false && intentional[0] === false) _initial[0] = valueFn(initial)[0];
    if (_i1 !== false && intentional[1] === false) _initial[1] = valueFn(initial)[1];
    /**
     * If the gesture has been blocked (from gesture specific checkIntentionality),
     * stop right there.
     */

    if (_blocked) return _extends(_extends({}, intentionalityCheck), {}, {
      _movement: _movement,
      delta: [0, 0]
    });
    /**
     * The movement sent to the handler has 0 in its dimensions when intentionality is false.
     * It is calculated from the actual movement minus the threshold.
     */

    var movement = [_i0 !== false ? _m0 - _i0 : valueFn(initial)[0], _i1 !== false ? _m1 - _i1 : valueFn(initial)[1]];
    var offset = addV(movement, lastOffset);
    /**
     * Rubberband should be 0 when the gesture is no longer active, so that movement
     * and offset can return within their bounds.
     */

    var _rubberband = _active ? rubberband : [0, 0];

    movement = this.rubberband(addV(movement, _initial), _rubberband); // rubberbanded movement

    return _extends(_extends({}, intentionalityCheck), {}, {
      _initial: _initial,
      _movement: _movement,
      movement: movement,
      offset: this.rubberband(offset, _rubberband),
      delta: subV(movement, prevMovement)
    });
  } // Cleans the gesture. Can be overriden by gestures.
  ;

  _proto.clean = function clean() {
    this.clearTimeout();
    this.removeWindowListeners();
  };

  _createClass(Recognizer, [{
    key: "config",
    get: function get() {
      return this.controller.config[this.stateKey];
    } // Is the gesture enabled

  }, {
    key: "enabled",
    get: function get() {
      return this.controller.config.enabled && this.config.enabled;
    } // Returns the controller state for a given gesture

  }, {
    key: "state",
    get: function get() {
      return this.controller.state[this.stateKey];
    } // Returns the gesture handler

  }, {
    key: "handler",
    get: function get() {
      return this.controller.handlers[this.stateKey];
    }
  }]);

  return Recognizer;
}();

/**
 * @private
 * Abstract class for coordinates-based gesture recongizers
 * @abstract
 * @class CoordinatesRecognizer
 * @extends {Recognizer<T>}
 * @template T
 */

var CoordinatesRecognizer = /*#__PURE__*/function (_Recognizer) {
  _inheritsLoose(CoordinatesRecognizer, _Recognizer);

  function CoordinatesRecognizer() {
    return _Recognizer.apply(this, arguments) || this;
  }

  var _proto = CoordinatesRecognizer.prototype;

  /**
   * Returns the real movement (without taking intentionality into acount)
   */
  _proto.getInternalMovement = function getInternalMovement(values, state) {
    return subV(values, state.initial);
  }
  /**
   * In coordinates-based gesture, this function will detect the first intentional axis,
   * lock the gesture axis if lockDirection is specified in the config, block the gesture
   * if the first intentional axis doesn't match the specified axis in config.
   *
   * @param {[FalseOrNumber, FalseOrNumber]} _intentional
   * @param {Vector2} _movement
   * @param {PartialGestureState<T>} state
   */
  ;

  _proto.checkIntentionality = function checkIntentionality(_intentional, _movement, state) {
    var _intentional2 = _intentional,
        _ix = _intentional2[0],
        _iy = _intentional2[1];
    var intentionalMovement = _ix !== false || _iy !== false;
    var axis = state.axis;
    var _blocked = false; // If the movement is intentional, we can compute axis.

    if (intentionalMovement) {
      var _movement$map = _movement.map(Math.abs),
          absX = _movement$map[0],
          absY = _movement$map[1];

      var _this$config = this.config,
          configAxis = _this$config.axis,
          lockDirection = _this$config.lockDirection; // We make sure we only set axis value if it hadn't been detected before.

      axis = axis || (absX > absY ? 'x' : absX < absY ? 'y' : undefined);

      if (!!configAxis || lockDirection) {
        if (!!axis) {
          // If the detected axis doesn't match the config axis we block the gesture
          if (!!configAxis && axis !== configAxis) _blocked = true;else {
            // Otherwise we prevent the gesture from updating the unwanted axis.
            var lockedIndex = axis === 'x' ? 1 : 0;
            _intentional[lockedIndex] = false;
          }
        } else {
          // Until we've detected the axis, we prevent the hnadler from updating.
          _intentional = [false, false];
        }
      }
    }

    return {
      _intentional: _intentional,
      _blocked: _blocked,
      axis: axis
    };
  };

  _proto.getKinematics = function getKinematics(values, event) {
    var timeStamp = this.state.timeStamp;
    var movementDetection = this.getMovement(values, this.state);
    var _blocked = movementDetection._blocked,
        delta = movementDetection.delta,
        movement = movementDetection.movement;
    if (_blocked) return movementDetection;
    var delta_t = event.timeStamp - timeStamp;
    var kinematics = calculateAllKinematics(movement, delta, delta_t);
    return _extends(_extends({
      values: values,
      delta: delta
    }, movementDetection), kinematics);
  };

  _proto.mapStateValues = function mapStateValues(state) {
    return {
      xy: state.values,
      vxvy: state.velocities
    };
  };

  return CoordinatesRecognizer;
}(Recognizer);

var TAP_DISTANCE_THRESHOLD = 3;
var SWIPE_MAX_ELAPSED_TIME = 220;
var FILTER_REPEATED_EVENTS_DELAY = 200;

var DragRecognizer = /*#__PURE__*/function (_CoordinatesRecognize) {
  _inheritsLoose(DragRecognizer, _CoordinatesRecognize);

  function DragRecognizer(controller, args) {
    var _this;

    _this = _CoordinatesRecognize.call(this, 'drag', controller, args) || this;
    _this.ingKey = 'dragging';
    _this.wasTouch = false;

    _this.isEventTypeTouch = function (type) {
      return !!type && type.indexOf('touch') === 0;
    };

    _this.dragShouldStart = function (event) {
      var _getGenericEventData = getGenericEventData(event),
          touches = _getGenericEventData.touches;

      var _lastEventType = _this.state._lastEventType;
      /**
       * This tries to filter out mouse events triggered by touch screens
       * */
      // If the previous gesture was touch-based, and the current one is mouse based,
      // this means that we might be dealing with mouse simulated events if they're close to
      // each other. We're only doing this check when we're not using pointer events.

      if (!_this.controller.config.pointer && _this.isEventTypeTouch(_lastEventType) && !_this.isEventTypeTouch(event.type)) {
        var delay = Math.abs(event.timeStamp - _this.state.startTime);
        if (delay < FILTER_REPEATED_EVENTS_DELAY) return false;
      }

      return _this.enabled && touches < 2;
    };

    _this.setPointers = function (event) {
      var currentTarget = event.currentTarget,
          pointerId = event.pointerId;
      if (currentTarget) currentTarget.setPointerCapture(pointerId);

      _this.updateGestureState({
        currentTarget: currentTarget,
        pointerId: pointerId
      });
    };

    _this.removePointers = function () {
      var _this$state = _this.state,
          currentTarget = _this$state.currentTarget,
          pointerId = _this$state.pointerId;
      if (currentTarget && pointerId) currentTarget.releasePointerCapture(pointerId);
    };

    _this.setListeners = function (isTouch) {
      _this.removeWindowListeners();

      var dragListeners = isTouch ? [['touchmove', _this.onDragChange], ['touchend', _this.onDragEnd], ['touchcancel', _this.onDragEnd]] : [['mousemove', _this.onDragChange], ['mouseup', _this.onDragEnd]];

      _this.addWindowListeners(dragListeners);
    };

    _this.onDragStart = function (event) {
      if (!_this.dragShouldStart(event)) return; // if pointers events

      if (_this.controller.config.pointer) _this.setPointers(event);else _this.setListeners(_this.isEventTypeTouch(event.type));

      if (_this.config.delay > 0) {
        _this.state._delayedEvent = true;
        if (typeof event.persist === 'function') event.persist();

        _this.setTimeout(function () {
          return _this.startDrag(event);
        }, _this.config.delay);
      } else {
        _this.startDrag(event);
      }
    };

    _this.onDragChange = function (event) {
      var canceled = _this.state.canceled;
      if (canceled) return;

      if (!_this.state._active) {
        if (_this.state._delayedEvent) {
          _this.clearTimeout();

          _this.startDrag(event);
        }

        return;
      }

      var genericEventData = getGenericEventData(event);

      if (!genericEventData.down) {
        _this.onDragEnd(event);

        return;
      }

      _this.updateSharedState(genericEventData);

      var _getPointerEventValue = getPointerEventValues(event),
          values = _getPointerEventValue.values;

      var kinematics = _this.getKinematics(values, event);

      var _isTap = _this.state._isTap;
      if (_isTap && calculateDistance(kinematics._movement) >= TAP_DISTANCE_THRESHOLD) _isTap = false;

      _this.updateGestureState(_extends(_extends(_extends({}, _this.getGenericPayload(event)), kinematics), {}, {
        _isTap: _isTap,
        cancel: function cancel() {
          return _this.onCancel();
        }
      }));

      _this.fireGestureHandler();
    };

    _this.onDragEnd = function (event) {
      _this.state._active = false;

      _this.updateSharedState({
        down: false,
        buttons: 0,
        touches: 0
      });

      var _this$state2 = _this.state,
          _isTap = _this$state2._isTap,
          values = _this$state2.values,
          _this$state2$velociti = _this$state2.velocities,
          vx = _this$state2$velociti[0],
          vy = _this$state2$velociti[1],
          _this$state2$movement = _this$state2.movement,
          mx = _this$state2$movement[0],
          my = _this$state2$movement[1],
          _this$state2$_intenti = _this$state2._intentional,
          ix = _this$state2$_intenti[0],
          iy = _this$state2$_intenti[1];

      var endState = _extends(_extends({}, _this.getGenericPayload(event)), _this.getMovement(values));

      var elapsedTime = endState.elapsedTime;
      var _this$config = _this.config,
          _this$config$swipeVel = _this$config.swipeVelocity,
          svx = _this$config$swipeVel[0],
          svy = _this$config$swipeVel[1],
          _this$config$swipeDis = _this$config.swipeDistance,
          sx = _this$config$swipeDis[0],
          sy = _this$config$swipeDis[1];
      var swipe = [0, 0];

      if (elapsedTime < SWIPE_MAX_ELAPSED_TIME) {
        if (ix !== false && Math.abs(vx) > svx && Math.abs(mx) > sx) swipe[0] = sign(vx);
        if (iy !== false && Math.abs(vy) > svy && Math.abs(my) > sy) swipe[1] = sign(vy);
      }

      _this.updateGestureState(_extends(_extends({
        event: event
      }, endState), {}, {
        tap: _isTap,
        swipe: swipe
      }));

      _this.fireGestureHandler(_this.config.filterTaps && _this.state._isTap);
    };

    _this.clean = function () {
      _CoordinatesRecognize.prototype.clean.call(_assertThisInitialized(_this));

      _this.state._delayedEvent = false;
      if (_this.controller.config.pointer) _this.removePointers();
    };

    _this.onCancel = function () {
      _this.updateGestureState({
        canceled: true,
        cancel: noop
      });

      _this.state._active = false;

      _this.updateSharedState({
        down: false,
        buttons: 0,
        touches: 0
      });

      requestAnimationFrame(function () {
        return _this.fireGestureHandler();
      });
    };

    return _this;
  }

  var _proto = DragRecognizer.prototype;

  _proto.startDrag = function startDrag(event) {
    var _this2 = this;

    var _getPointerEventValue2 = getPointerEventValues(event),
        values = _getPointerEventValue2.values;

    this.updateSharedState(getGenericEventData(event));

    var startState = _extends(_extends({}, this.getStartGestureState(values, event)), this.getGenericPayload(event, true));

    this.updateGestureState(_extends(_extends(_extends({}, startState), this.getMovement(values, startState)), {}, {
      cancel: function cancel() {
        return _this2.onCancel();
      }
    }));
    this.fireGestureHandler();
  };

  _proto.addBindings = function addBindings() {
    if (this.controller.config.pointer) {
      this.controller.addBindings('onPointerDown', this.onDragStart);
      this.controller.addBindings('onPointerMove', this.onDragChange);
      this.controller.addBindings(['onPointerUp', 'onPointerCancel'], this.onDragEnd);
    } else {
      this.controller.addBindings(['onTouchStart', 'onMouseDown'], this.onDragStart);
    }
  };

  return DragRecognizer;
}(CoordinatesRecognizer);

var DEFAULT_DRAG_DELAY = 180;
var DEFAULT_RUBBERBAND = 0.15;
var DEFAULT_SWIPE_VELOCITY = 0.5;
var DEFAULT_SWIPE_DISTANCE = 60;
var defaultWindow = typeof window !== 'undefined' ? window : undefined;
var defaultCoordinatesOptions = {
  lockDirection: false,
  axis: undefined,
  bounds: undefined
};
/**
 * @private
 *
 * Returns the internal generic option object.
 *
 * @param {Partial<GenericOptions>} [config={}]
 * @returns {InternalGenericOptions}
 */

function getInternalGenericOptions(config) {
  if (config === void 0) {
    config = {};
  }

  var _config = config,
      _config$eventOptions = _config.eventOptions;
  _config$eventOptions = _config$eventOptions === void 0 ? {} : _config$eventOptions;

  var _config$eventOptions$ = _config$eventOptions.passive,
      passive = _config$eventOptions$ === void 0 ? true : _config$eventOptions$,
      _config$eventOptions$2 = _config$eventOptions.capture,
      capture = _config$eventOptions$2 === void 0 ? false : _config$eventOptions$2,
      _config$eventOptions$3 = _config$eventOptions.pointer,
      pointer = _config$eventOptions$3 === void 0 ? false : _config$eventOptions$3,
      _config$window = _config.window,
      window = _config$window === void 0 ? defaultWindow : _config$window,
      _config$domTarget = _config.domTarget,
      domTarget = _config$domTarget === void 0 ? undefined : _config$domTarget,
      _config$enabled = _config.enabled,
      enabled = _config$enabled === void 0 ? true : _config$enabled,
      restConfig = _objectWithoutPropertiesLoose(_config, ["eventOptions", "window", "domTarget", "enabled"]);

  return _extends(_extends({}, restConfig), {}, {
    enabled: enabled,
    domTarget: domTarget,
    window: window,
    // passive is always true if there's no domTarget
    eventOptions: {
      passive: !domTarget || !!passive,
      capture: !!capture
    },
    captureString: capture ? 'Capture' : '',
    pointer: !!pointer
  });
}
function getInternalGestureOptions(gestureConfig) {
  var _gestureConfig$thresh = gestureConfig.threshold,
      threshold = _gestureConfig$thresh === void 0 ? undefined : _gestureConfig$thresh,
      _gestureConfig$rubber = gestureConfig.rubberband,
      rubberband = _gestureConfig$rubber === void 0 ? 0 : _gestureConfig$rubber,
      _gestureConfig$enable = gestureConfig.enabled,
      enabled = _gestureConfig$enable === void 0 ? true : _gestureConfig$enable,
      _gestureConfig$initia = gestureConfig.initial,
      initial = _gestureConfig$initia === void 0 ? [0, 0] : _gestureConfig$initia;
  if (typeof rubberband === 'boolean') rubberband = rubberband ? DEFAULT_RUBBERBAND : 0;
  if (threshold === void 0) threshold = 0;
  return {
    enabled: enabled,
    initial: initial,
    threshold: def.array(threshold),
    rubberband: def.array(rubberband)
  };
}
function getInternalCoordinatesOptions(coordinatesConfig) {
  if (coordinatesConfig === void 0) {
    coordinatesConfig = {};
  }

  var _coordinatesConfig = coordinatesConfig,
      axis = _coordinatesConfig.axis,
      lockDirection = _coordinatesConfig.lockDirection,
      _coordinatesConfig$bo = _coordinatesConfig.bounds,
      bounds = _coordinatesConfig$bo === void 0 ? {} : _coordinatesConfig$bo,
      internalOptions = _objectWithoutPropertiesLoose(_coordinatesConfig, ["axis", "lockDirection", "bounds"]);

  var boundsArray = [[def.withDefault(bounds.left, -Infinity), def.withDefault(bounds.right, Infinity)], [def.withDefault(bounds.top, -Infinity), def.withDefault(bounds.bottom, Infinity)]];
  return _extends(_extends(_extends(_extends({}, getInternalGestureOptions(internalOptions)), defaultCoordinatesOptions), matchKeysFromObject({
    axis: axis,
    lockDirection: lockDirection
  }, coordinatesConfig)), {}, {
    bounds: boundsArray
  });
}
function getInternalDistanceAngleOptions(distanceAngleConfig) {
  if (distanceAngleConfig === void 0) {
    distanceAngleConfig = {};
  }

  var _distanceAngleConfig = distanceAngleConfig,
      _distanceAngleConfig$ = _distanceAngleConfig.distanceBounds,
      distanceBounds = _distanceAngleConfig$ === void 0 ? {} : _distanceAngleConfig$,
      _distanceAngleConfig$2 = _distanceAngleConfig.angleBounds,
      angleBounds = _distanceAngleConfig$2 === void 0 ? {} : _distanceAngleConfig$2,
      internalOptions = _objectWithoutPropertiesLoose(_distanceAngleConfig, ["distanceBounds", "angleBounds"]);

  var boundsArray = [[def.withDefault(distanceBounds.min, -Infinity), def.withDefault(distanceBounds.max, Infinity)], [def.withDefault(angleBounds.min, -Infinity), def.withDefault(angleBounds.max, Infinity)]];
  return _extends(_extends({}, getInternalGestureOptions(internalOptions)), {}, {
    bounds: boundsArray
  });
}
function getInternalDragOptions(dragConfig) {
  if (dragConfig === void 0) {
    dragConfig = {};
  }

  var _dragConfig = dragConfig,
      enabled = _dragConfig.enabled,
      threshold = _dragConfig.threshold,
      bounds = _dragConfig.bounds,
      rubberband = _dragConfig.rubberband,
      initial = _dragConfig.initial,
      dragOptions = _objectWithoutPropertiesLoose(_dragConfig, ["enabled", "threshold", "bounds", "rubberband", "initial"]);

  var _dragOptions$swipeVel = dragOptions.swipeVelocity,
      swipeVelocity = _dragOptions$swipeVel === void 0 ? DEFAULT_SWIPE_VELOCITY : _dragOptions$swipeVel,
      _dragOptions$swipeDis = dragOptions.swipeDistance,
      swipeDistance = _dragOptions$swipeDis === void 0 ? DEFAULT_SWIPE_DISTANCE : _dragOptions$swipeDis,
      _dragOptions$delay = dragOptions.delay,
      delay = _dragOptions$delay === void 0 ? false : _dragOptions$delay,
      _dragOptions$filterTa = dragOptions.filterTaps,
      filterTaps = _dragOptions$filterTa === void 0 ? false : _dragOptions$filterTa,
      axis = dragOptions.axis,
      lockDirection = dragOptions.lockDirection;

  if (threshold === void 0) {
    threshold = Math.max(0, filterTaps ? 3 : 0, lockDirection || axis ? 1 : 0);
  } else {
    filterTaps = true;
  }

  var internalCoordinatesOptions = getInternalCoordinatesOptions(matchKeysFromObject({
    enabled: enabled,
    threshold: threshold,
    bounds: bounds,
    rubberband: rubberband,
    axis: axis,
    lockDirection: lockDirection,
    initial: initial
  }, dragConfig));
  return _extends(_extends({}, internalCoordinatesOptions), {}, {
    filterTaps: filterTaps || internalCoordinatesOptions.threshold[0] + internalCoordinatesOptions.threshold[1] > 0,
    swipeVelocity: def.array(swipeVelocity),
    swipeDistance: def.array(swipeDistance),
    delay: typeof delay === 'number' ? delay : delay ? DEFAULT_DRAG_DELAY : 0
  });
}

/**
 * @public
 *
 * Drag hook.
 *
 * @param {Handler<'drag'>} handler - the function fired every time the drag gesture updates
 * @param {(Config | {})} [config={}] - the config object including generic options and drag options
 * @returns {(...args: any[]) => HookReturnType<Config>}
 */

function useDrag(handler, config) {
  if (config === void 0) {
    config = {};
  }

  var _config = config,
      domTarget = _config.domTarget,
      eventOptions = _config.eventOptions,
      window = _config.window,
      drag = _objectWithoutPropertiesLoose(_config, ["domTarget", "eventOptions", "window"]);
  /**
   * TODO: at the moment we recompute the config object at every render
   * this could probably be optimized
   */


  var mergedConfig = _extends(_extends({}, getInternalGenericOptions({
    domTarget: domTarget,
    eventOptions: eventOptions,
    window: window
  })), {}, {
    drag: getInternalDragOptions(drag)
  });

  return useRecognizers({
    drag: handler
  }, [DragRecognizer], mergedConfig);
}

/**
 * @private
 * Abstract class for distance/angle-based gesture recongizers
 * @abstract
 * @class DistanceAngleRecognizer
 * @extends {Recognizer<T>}
 * @template T
 */

var DistanceAngleRecognizer = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_Recognizer) {
  _inheritsLoose(DistanceAngleRecognizer, _Recognizer);

  function DistanceAngleRecognizer() {
    return _Recognizer.apply(this, arguments) || this;
  }

  var _proto = DistanceAngleRecognizer.prototype;

  /**
   * Returns the real movement (without taking intentionality into acount)
   */
  _proto.getInternalMovement = function getInternalMovement(_ref, state) {
    var d = _ref[0],
        a = _ref[1];
    var da = state.values,
        turns = state.turns,
        initial = state.initial; // angle might not be defined when ctrl wheel is used for zoom only
    // in that case we set it to the previous angle value

    a = a !== void 0 ? a : da[1];
    var delta_a = a - da[1];
    /**
     * The angle value might jump from 179deg to -179deg when we actually want to
     * read 181deg to ensure continuity. To make that happen, we detect when the jump
     * is supsiciously high (ie > 270deg) and increase the `turns` value
     */

    var newTurns = Math.abs(delta_a) > 270 ? turns + sign(delta_a) : turns; // we update the angle difference to its corrected value

    var movement_d = d - initial[0];
    var movement_a = a - 360 * newTurns - initial[1];
    return [movement_d, movement_a];
  };

  _proto.getKinematics = function getKinematics(values, event) {
    var _this$state = this.state,
        timeStamp = _this$state.timeStamp,
        initial = _this$state.initial;
    var movementDetection = this.getMovement(values, this.state);
    var delta = movementDetection.delta,
        movement = movementDetection.movement;
    var turns = (values[1] - movement[1] - initial[1]) / 360;
    var delta_t = event.timeStamp - timeStamp;
    var kinematics = calculateAllKinematics(movement, delta, delta_t);
    return _extends(_extends({
      values: values,
      delta: delta,
      turns: turns
    }, movementDetection), kinematics);
  };

  _proto.mapStateValues = function mapStateValues(state) {
    return {
      da: state.values,
      vdva: state.velocities
    };
  };

  return DistanceAngleRecognizer;
}(Recognizer)));

var PinchRecognizer = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_DistanceAngleRecogni) {
  _inheritsLoose(PinchRecognizer, _DistanceAngleRecogni);

  function PinchRecognizer(controller, args) {
    var _this;

    _this = _DistanceAngleRecogni.call(this, 'pinch', controller, args) || this;
    _this.ingKey = 'pinching';

    _this.pinchShouldStart = function (event) {
      var _getGenericEventData = getGenericEventData(event),
          touches = _getGenericEventData.touches;

      return _this.enabled && touches === 2;
    };

    _this.onPinchStart = function (event) {
      if (!_this.pinchShouldStart(event)) return;

      var _getTwoTouchesEventDa = getTwoTouchesEventData(event),
          values = _getTwoTouchesEventDa.values,
          origin = _getTwoTouchesEventDa.origin;

      _this.updateSharedState(getGenericEventData(event));

      var startState = _extends(_extends({}, _this.getStartGestureState(values, event)), _this.getGenericPayload(event, true));

      _this.updateGestureState(_extends(_extends(_extends({}, startState), _this.getMovement(values, startState)), {}, {
        origin: origin,
        cancel: function cancel() {
          return _this.onCancel();
        }
      }));

      _this.fireGestureHandler();
    };

    _this.onPinchChange = function (event) {
      var _this$state = _this.state,
          canceled = _this$state.canceled,
          timeStamp = _this$state.timeStamp,
          _active = _this$state._active;
      if (canceled || !_active) return;
      var genericEventData = getGenericEventData(event);
      if (genericEventData.touches !== 2 || event.timeStamp === timeStamp) return;

      _this.updateSharedState(genericEventData);

      var _getTwoTouchesEventDa2 = getTwoTouchesEventData(event),
          values = _getTwoTouchesEventDa2.values,
          origin = _getTwoTouchesEventDa2.origin;

      var kinematics = _this.getKinematics(values, event);

      _this.updateGestureState(_extends(_extends(_extends({}, _this.getGenericPayload(event)), kinematics), {}, {
        origin: origin,
        cancel: function cancel() {
          return _this.onCancel();
        }
      }));

      _this.fireGestureHandler();
    };

    _this.onPinchEnd = function (event) {
      if (!_this.state.active) return;
      _this.state._active = false;

      _this.updateSharedState({
        down: false,
        touches: 0
      });

      _this.updateGestureState(_extends(_extends({
        event: event
      }, _this.getGenericPayload(event)), _this.getMovement(_this.state.values)));

      _this.fireGestureHandler();
    };

    _this.onCancel = function () {
      _this.state._active = false;

      _this.updateGestureState({
        canceled: true,
        cancel: noop
      });

      _this.updateSharedState({
        down: false,
        touches: 0
      });

      requestAnimationFrame(function () {
        return _this.fireGestureHandler();
      });
    };
    /**
     * PINCH WITH WEBKIT GESTURES
     */


    _this.onGestureStart = function (event) {
      if (!_this.enabled) return;
      event.preventDefault();

      var _getWebkitGestureEven = getWebkitGestureEventValues(event),
          values = _getWebkitGestureEven.values;

      _this.updateSharedState(getGenericEventData(event));

      var startState = _extends(_extends({}, _this.getStartGestureState(values, event)), _this.getGenericPayload(event, true));

      _this.updateGestureState(_extends(_extends(_extends({}, startState), _this.getMovement(values, startState)), {}, {
        cancel: function cancel() {
          return _this.onCancel();
        }
      }));

      _this.fireGestureHandler();
    };

    _this.onGestureChange = function (event) {
      var _this$state2 = _this.state,
          canceled = _this$state2.canceled,
          _active = _this$state2._active;
      if (canceled || !_active) return;
      event.preventDefault();
      var genericEventData = getGenericEventData(event);

      _this.updateSharedState(genericEventData);

      var _getWebkitGestureEven2 = getWebkitGestureEventValues(event),
          values = _getWebkitGestureEven2.values;

      var kinematics = _this.getKinematics(values, event);

      _this.updateGestureState(_extends(_extends(_extends({}, _this.getGenericPayload(event)), kinematics), {}, {
        cancel: function cancel() {
          return _this.onCancel();
        }
      }));

      _this.fireGestureHandler();
    };

    _this.onGestureEnd = function (event) {
      event.preventDefault();
      if (!_this.state.active) return;
      _this.state._active = false;

      _this.updateSharedState({
        down: false,
        touches: 0
      });

      _this.updateGestureState(_extends(_extends({
        event: event
      }, _this.getGenericPayload(event)), _this.getMovement(_this.state.values)));

      _this.fireGestureHandler();
    };

    _this.updateTouchData = function (event) {
      if (!_this.enabled || event.touches.length !== 2 || !_this.state._active) return;

      var _getTwoTouchesEventDa3 = getTwoTouchesEventData(event),
          origin = _getTwoTouchesEventDa3.origin;

      _this.state.origin = origin;
    };
    /**
     * PINCH WITH WHEEL
     */


    _this.wheelShouldRun = function (event) {
      return _this.enabled && event.ctrlKey;
    };

    _this.getWheelValuesFromEvent = function (event) {
      var _getWheelEventValues = getWheelEventValues(event),
          _getWheelEventValues$ = _getWheelEventValues.values,
          delta_d = _getWheelEventValues$[1];

      var _this$state$values = _this.state.values,
          prev_d = _this$state$values[0],
          prev_a = _this$state$values[1];
      var d = prev_d - delta_d;
      var a = prev_a !== void 0 ? prev_a : 0;
      return {
        values: [d, a],
        origin: [event.clientX, event.clientY],
        delta: [0, delta_d]
      };
    };

    _this.onWheel = function (event) {
      if (!_this.wheelShouldRun(event)) return;

      _this.clearTimeout();

      _this.setTimeout(_this.onWheelEnd);

      if (!_this.state._active) _this.onWheelStart(event);else _this.onWheelChange(event);
    };

    _this.onWheelStart = function (event) {
      var _this$getWheelValuesF = _this.getWheelValuesFromEvent(event),
          values = _this$getWheelValuesF.values,
          delta = _this$getWheelValuesF.delta,
          origin = _this$getWheelValuesF.origin;

      if (!_this.controller.config.eventOptions.passive) {
        event.preventDefault();
      } else if (false) {}

      _this.updateSharedState(getGenericEventData(event));

      var startState = _extends(_extends(_extends({}, _this.getStartGestureState(values, event)), _this.getGenericPayload(event, true)), {}, {
        initial: _this.state.values
      });

      _this.updateGestureState(_extends(_extends(_extends({}, startState), _this.getMovement(values, startState)), {}, {
        offset: values,
        delta: delta,
        origin: origin
      }));

      _this.fireGestureHandler();
    };

    _this.onWheelChange = function (event) {
      var genericEventData = getGenericEventData(event);

      _this.updateSharedState(genericEventData);

      var _this$getWheelValuesF2 = _this.getWheelValuesFromEvent(event),
          values = _this$getWheelValuesF2.values,
          origin = _this$getWheelValuesF2.origin,
          delta = _this$getWheelValuesF2.delta;

      var kinematics = _this.getKinematics(values, event);

      _this.updateGestureState(_extends(_extends(_extends({}, _this.getGenericPayload(event)), kinematics), {}, {
        origin: origin,
        delta: delta
      }));

      _this.fireGestureHandler();
    };

    _this.onWheelEnd = function () {
      _this.state._active = false;

      _this.updateGestureState(_this.getMovement(_this.state.values));

      _this.fireGestureHandler();
    };

    return _this;
  }

  var _proto = PinchRecognizer.prototype;

  _proto.addBindings = function addBindings() {
    // Only try to use gesture events when they are supported and domTarget is set
    // as React doesn't support gesture handlers.
    if (this.controller.config.domTarget && supportsGestureEvents()) {
      this.controller.addBindings('onGestureStart', this.onGestureStart);
      this.controller.addBindings('onGestureChange', this.onGestureChange);
      this.controller.addBindings(['onGestureEnd', 'onTouchCancel'], this.onGestureEnd);
      this.controller.addBindings(['onTouchStart', 'onTouchMove'], this.updateTouchData);
    } else {
      this.controller.addBindings('onTouchStart', this.onPinchStart);
      this.controller.addBindings('onTouchMove', this.onPinchChange);
      this.controller.addBindings(['onTouchEnd', 'onTouchCancel'], this.onPinchEnd);
      this.controller.addBindings('onWheel', this.onWheel);
    }
  };

  return PinchRecognizer;
}(DistanceAngleRecognizer)));

/**
 * @public
 *
 * Pinch hook.
 *
 * @param {Handler<'pinch'>} handler - the function fired every time the pinch gesture updates
 * @param {(Config | {})} [config={}] - the config object including generic options and pinch options
 * @returns {(...args: any[]) => HookReturnType<Config>}
 */

function usePinch(handler, config) {
  if (config === void 0) {
    config = {};
  }

  var _config = config,
      domTarget = _config.domTarget,
      eventOptions = _config.eventOptions,
      window = _config.window,
      pinch = _objectWithoutPropertiesLoose(_config, ["domTarget", "eventOptions", "window"]);
  /**
   * TODO: at the moment we recompute the config object at every render
   * this could probably be optimized
   */


  var mergedConfig = _extends(_extends({}, getInternalGenericOptions({
    domTarget: domTarget,
    eventOptions: eventOptions,
    window: window
  })), {}, {
    pinch: getInternalDistanceAngleOptions(pinch)
  });

  return useRecognizers({
    pinch: handler
  }, [PinchRecognizer], mergedConfig);
}

var WheelRecognizer = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_CoordinatesRecognize) {
  _inheritsLoose(WheelRecognizer, _CoordinatesRecognize);

  function WheelRecognizer(controller, args) {
    var _this;

    _this = _CoordinatesRecognize.call(this, 'wheel', controller, args) || this;
    _this.ingKey = 'wheeling';
    _this.debounced = true;

    _this.wheelShouldRun = function (event) {
      if (event.ctrlKey && 'pinch' in _this.controller.handlers) return false;
      return _this.enabled;
    };

    _this.getValuesFromEvent = function (event) {
      var prevValues = _this.state.values;

      var _getWheelEventValues = getWheelEventValues(event),
          values = _getWheelEventValues.values;

      return {
        values: addV(values, prevValues)
      };
    };

    _this.onWheel = function (event) {
      if (!_this.wheelShouldRun(event)) return;

      _this.clearTimeout();

      _this.setTimeout(_this.onWheelEnd);

      if (!_this.state._active) _this.onWheelStart(event);else _this.onWheelChange(event);
    };

    _this.onWheelStart = function (event) {
      var _this$getValuesFromEv = _this.getValuesFromEvent(event),
          values = _this$getValuesFromEv.values;

      _this.updateSharedState(getGenericEventData(event));

      var startState = _extends(_extends(_extends({}, _this.getStartGestureState(values, event)), _this.getGenericPayload(event, true)), {}, {
        initial: _this.state.values
      });

      var movementDetection = _this.getMovement(values, startState);

      var delta = movementDetection.delta;

      _this.updateGestureState(_extends(_extends(_extends({}, startState), movementDetection), {}, {
        distance: calculateDistance(delta),
        direction: calculateDirection(delta)
      }));

      _this.fireGestureHandler();
    };

    _this.onWheelChange = function (event) {
      var genericEventData = getGenericEventData(event);

      _this.updateSharedState(genericEventData);

      var _this$getValuesFromEv2 = _this.getValuesFromEvent(event),
          values = _this$getValuesFromEv2.values;

      var kinematics = _this.getKinematics(values, event);

      _this.updateGestureState(_extends(_extends({}, _this.getGenericPayload(event)), kinematics));

      _this.fireGestureHandler();
    };

    _this.onWheelEnd = function () {
      _this.state._active = false;

      _this.updateGestureState(_extends(_extends({}, _this.getMovement(_this.state.values)), {}, {
        velocities: [0, 0],
        velocity: 0
      }));

      _this.fireGestureHandler();
    };

    return _this;
  }

  var _proto = WheelRecognizer.prototype;

  _proto.addBindings = function addBindings() {
    this.controller.addBindings('onWheel', this.onWheel);
  };

  return WheelRecognizer;
}(CoordinatesRecognizer)));

/**
 * @public
 *
 * Wheel hook.
 *
 * @param {Handler<'wheel'>} handler - the function fired every time the wheel gesture updates
 * @param {(Config | {})} [config={}] - the config object including generic options and wheel options
 * @returns {(...args: any[]) => HookReturnType<Config>}
 */

function useWheel(handler, config) {
  if (config === void 0) {
    config = {};
  }

  var _config = config,
      domTarget = _config.domTarget,
      eventOptions = _config.eventOptions,
      window = _config.window,
      wheel = _objectWithoutPropertiesLoose(_config, ["domTarget", "eventOptions", "window"]);
  /**
   * TODO: at the moment we recompute the config object at every render
   * this could probably be optimized
   */


  var mergedConfig = _extends(_extends({}, getInternalGenericOptions({
    domTarget: domTarget,
    eventOptions: eventOptions,
    window: window
  })), {}, {
    wheel: getInternalCoordinatesOptions(wheel)
  });

  return useRecognizers({
    wheel: handler
  }, [WheelRecognizer], mergedConfig);
}

var MoveRecognizer = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_CoordinatesRecognize) {
  _inheritsLoose(MoveRecognizer, _CoordinatesRecognize);

  function MoveRecognizer(controller, args) {
    var _this;

    _this = _CoordinatesRecognize.call(this, 'move', controller, args) || this;
    _this.ingKey = 'moving';
    _this.debounced = true;

    _this.moveShouldRun = function () {
      return _this.enabled;
    };

    _this.onMove = function (event) {
      if (!_this.moveShouldRun()) return;

      _this.clearTimeout();

      _this.setTimeout(_this.onMoveEnd);

      if (!_this.state._active) _this.onMoveStart(event);else _this.onMoveChange(event);
    };

    _this.onMoveStart = function (event) {
      var _getPointerEventValue = getPointerEventValues(event),
          values = _getPointerEventValue.values;

      _this.updateSharedState(getGenericEventData(event));

      var startState = _extends(_extends({}, _this.getStartGestureState(values, event)), _this.getGenericPayload(event, true));

      _this.updateGestureState(_extends(_extends({}, startState), _this.getMovement(values, startState)));

      _this.fireGestureHandler();
    };

    _this.onMoveChange = function (event) {
      var genericEventData = getGenericEventData(event);

      _this.updateSharedState(genericEventData);

      var _getPointerEventValue2 = getPointerEventValues(event),
          values = _getPointerEventValue2.values;

      var kinematics = _this.getKinematics(values, event);

      _this.updateGestureState(_extends(_extends({}, _this.getGenericPayload(event)), kinematics));

      _this.fireGestureHandler();
    };

    _this.onMoveEnd = function () {
      _this.state._active = false;

      _this.updateGestureState(_extends(_extends({}, _this.getMovement(_this.state.values)), {}, {
        velocities: [0, 0],
        velocity: 0
      }));

      _this.fireGestureHandler();
    };

    _this.onPointerEnter = function (event) {
      _this.controller.state.shared.hovering = true;
      if (!_this.controller.config.enabled) return;

      if (_this.controller.config.hover.enabled) {
        var _getPointerEventValue3 = getPointerEventValues(event),
            values = _getPointerEventValue3.values;

        var state = _extends(_extends(_extends(_extends({}, _this.controller.state.shared), _this.state), _this.getGenericPayload(event, true)), {}, {
          values: values,
          active: true,
          hovering: true
        });

        _this.controller.handlers.hover(_extends(_extends({}, state), _this.mapStateValues(state)));
      }

      if ('move' in _this.controller.handlers) _this.onMoveStart(event);
    };

    _this.onPointerLeave = function (event) {
      _this.controller.state.shared.hovering = false;
      if ('move' in _this.controller.handlers) _this.onMoveEnd();

      if (_this.controller.config.hover.enabled) {
        var _getPointerEventValue4 = getPointerEventValues(event),
            values = _getPointerEventValue4.values;

        var state = _extends(_extends(_extends(_extends({}, _this.controller.state.shared), _this.state), _this.getGenericPayload(event)), {}, {
          values: values,
          active: false
        });

        _this.controller.handlers.hover(_extends(_extends({}, state), _this.mapStateValues(state)));
      }
    };

    return _this;
  }

  var _proto = MoveRecognizer.prototype;

  _proto.addBindings = function addBindings() {
    if (this.controller.config.pointer) {
      if ('move' in this.controller.handlers) {
        this.controller.addBindings('onPointerMove', this.onMove);
      }

      if ('hover' in this.controller.handlers) {
        this.controller.addBindings('onPointerEnter', this.onPointerEnter);
        this.controller.addBindings('onPointerLeave', this.onPointerLeave);
      }
    } else {
      if ('move' in this.controller.handlers) {
        this.controller.addBindings('onMouseMove', this.onMove);
      }

      if ('hover' in this.controller.handlers) {
        this.controller.addBindings('onMouseEnter', this.onPointerEnter);
        this.controller.addBindings('onMouseLeave', this.onPointerLeave);
      }
    }
  };

  return MoveRecognizer;
}(CoordinatesRecognizer)));

/**
 * @public
 *
 * Move hook.
 *
 * @param {Handler<'move'>} handler - the function fired every time the move gesture updates
 * @param {(Config | {})} [config={}] - the config object including generic options and move options
 * @returns {(...args: any[]) => HookReturnType<Config>}
 */

function useMove(handler, config) {
  if (config === void 0) {
    config = {};
  }

  var _config = config,
      domTarget = _config.domTarget,
      eventOptions = _config.eventOptions,
      window = _config.window,
      move = _objectWithoutPropertiesLoose(_config, ["domTarget", "eventOptions", "window"]);
  /**
   * TODO: at the moment we recompute the config object at every render
   * this could probably be optimized
   */


  var mergedConfig = _extends(_extends({}, getInternalGenericOptions({
    domTarget: domTarget,
    eventOptions: eventOptions,
    window: window
  })), {}, {
    move: getInternalCoordinatesOptions(move)
  });

  return useRecognizers({
    move: handler
  }, [MoveRecognizer], mergedConfig);
}

/**
 * @public
 *
 * Hover hook.
 *
 * @param {Handler<'hover'>} handler - the function fired every time the hover gesture updates
 * @param {(Config | {})} [config={}] - the config object including generic options and hover options
 * @returns {(...args: any[]) => HookReturnType<Config>}
 */

function useHover(handler, config) {
  if (config === void 0) {
    config = {};
  }

  var _config = config,
      domTarget = _config.domTarget,
      eventOptions = _config.eventOptions,
      window = _config.window,
      hover = _objectWithoutPropertiesLoose(_config, ["domTarget", "eventOptions", "window"]);
  /**
   * TODO: at the moment we recompute the config object at every render
   * this could probably be optimized
   */


  var mergedConfig = _extends(_extends({}, getInternalGenericOptions({
    domTarget: domTarget,
    eventOptions: eventOptions,
    window: window
  })), {}, {
    hover: _extends({
      enabled: true
    }, hover)
  });

  return useRecognizers({
    hover: handler
  }, [MoveRecognizer], mergedConfig);
}

var ScrollRecognizer = /*#__PURE__*/(/* unused pure expression or super */ null && (function (_CoordinatesRecognize) {
  _inheritsLoose(ScrollRecognizer, _CoordinatesRecognize);

  function ScrollRecognizer(controller, args) {
    var _this;

    _this = _CoordinatesRecognize.call(this, 'scroll', controller, args) || this;
    _this.ingKey = 'scrolling';
    _this.debounced = true;

    _this.scrollShouldRun = function () {
      return _this.enabled;
    };

    _this.onScroll = function (event) {
      if (!_this.scrollShouldRun()) return;

      _this.clearTimeout();

      _this.setTimeout(_this.onScrollEnd);

      if (!_this.state._active) _this.onScrollStart(event);else _this.onScrollChange(event);
    };

    _this.onScrollStart = function (event) {
      var _getScrollEventValues = getScrollEventValues(event),
          values = _getScrollEventValues.values;

      _this.updateSharedState(getGenericEventData(event));

      var startState = _extends(_extends(_extends({}, _this.getStartGestureState(values, event)), _this.getGenericPayload(event, true)), {}, {
        initial: _this.state.values
      });

      var movementDetection = _this.getMovement(values, startState);

      var delta = movementDetection.delta;

      _this.updateGestureState(_extends(_extends(_extends({}, startState), movementDetection), {}, {
        distance: calculateDistance(delta),
        direction: calculateDirection(delta)
      }));

      _this.fireGestureHandler();
    };

    _this.onScrollChange = function (event) {
      var genericEventData = getGenericEventData(event);

      _this.updateSharedState(genericEventData);

      var _getScrollEventValues2 = getScrollEventValues(event),
          values = _getScrollEventValues2.values;

      var kinematics = _this.getKinematics(values, event);

      _this.updateGestureState(_extends(_extends({}, _this.getGenericPayload(event)), kinematics));

      _this.fireGestureHandler();
    };

    _this.onScrollEnd = function () {
      _this.state._active = false;

      _this.updateGestureState(_extends(_extends({}, _this.getMovement(_this.state.values)), {}, {
        velocities: [0, 0],
        velocity: 0
      }));

      _this.fireGestureHandler();
    };

    return _this;
  }

  var _proto = ScrollRecognizer.prototype;

  _proto.addBindings = function addBindings() {
    this.controller.addBindings('onScroll', this.onScroll);
  };

  return ScrollRecognizer;
}(CoordinatesRecognizer)));

/**
 * @public
 *
 * Scroll hook.
 *
 * @param {Handler<'scroll'>} handler - the function fired every time the scroll gesture updates
 * @param {(Config | {})} [config={}] - the config object including generic options and scroll options
 * @returns {(...args: any[]) => HookReturnType<Config>}
 */

function useScroll(handler, config) {
  if (config === void 0) {
    config = {};
  }

  var _config = config,
      domTarget = _config.domTarget,
      eventOptions = _config.eventOptions,
      window = _config.window,
      scroll = _objectWithoutPropertiesLoose(_config, ["domTarget", "eventOptions", "window"]);
  /**
   * TODO: at the moment we recompute the config object at every render
   * this could probably be optimized
   */


  var mergedConfig = _extends(_extends({}, getInternalGenericOptions({
    domTarget: domTarget,
    eventOptions: eventOptions,
    window: window
  })), {}, {
    scroll: getInternalCoordinatesOptions(scroll)
  });

  return useRecognizers({
    scroll: handler
  }, [ScrollRecognizer], mergedConfig);
}

/**
 * @public
 *
 * The most complete gesture hook, allowing support for multiple gestures.
 *
 * @param {UserHandlersPartial} handlers - an object with on[Gesture] keys containg gesture handlers
 * @param {UseGestureConfig} [config={}] - the full config object
 * @returns {(...args: any[]) => HookReturnType<Config>}
 */

function useGesture(handlers, config) {
  if (config === void 0) {
    config = {};
  }

  /**
   * If handlers contains {onDragStart, onDrag, onDragEnd, onMoveStart, onMove}
   * actions will include 'onDrag' and 'onMove.
   */
  var _React$useState = React.useState(function () {
    return new Set(Object.keys(handlers).map(function (k) {
      return k.replace(/End|Start/, '');
    }));
  }),
      actions = _React$useState[0];
  /**
   * Here we compute the derived internal config based on the provided config object.
   * We decompose the config into its generic and gesture options and compute each.
   * TODO: this is currently done on every render!
   */


  var _config = config,
      drag = _config.drag,
      wheel = _config.wheel,
      move = _config.move,
      scroll = _config.scroll,
      pinch = _config.pinch,
      hover = _config.hover,
      restConfig = _objectWithoutPropertiesLoose(_config, ["drag", "wheel", "move", "scroll", "pinch", "hover"]);

  var mergedConfig = getInternalGenericOptions(restConfig);
  var classes = [];
  var internalHandlers = {}; // will hold reference to native handlers such as onClick, onMouseDown, etc.

  var _nativeHandlers = _extends({}, handlers);

  if (actions.has('onDrag')) {
    classes.push(DragRecognizer);
    internalHandlers.drag = includeStartEndHandlers(handlers, 'onDrag', _nativeHandlers);
    mergedConfig.drag = getInternalDragOptions(drag);
  }

  if (actions.has('onWheel')) {
    classes.push(WheelRecognizer);
    internalHandlers.wheel = includeStartEndHandlers(handlers, 'onWheel', _nativeHandlers);
    mergedConfig.wheel = getInternalCoordinatesOptions(wheel);
  }

  if (actions.has('onScroll')) {
    classes.push(ScrollRecognizer);
    internalHandlers.scroll = includeStartEndHandlers(handlers, 'onScroll', _nativeHandlers);
    mergedConfig.scroll = getInternalCoordinatesOptions(scroll);
  }

  if (actions.has('onMove')) {
    classes.push(MoveRecognizer);
    internalHandlers.move = includeStartEndHandlers(handlers, 'onMove', _nativeHandlers);
    mergedConfig.move = getInternalCoordinatesOptions(move);
  }

  if (actions.has('onPinch')) {
    classes.push(PinchRecognizer);
    internalHandlers.pinch = includeStartEndHandlers(handlers, 'onPinch', _nativeHandlers);
    mergedConfig.pinch = getInternalDistanceAngleOptions(pinch);
  }

  if (actions.has('onHover')) {
    if (!actions.has('onMove')) classes.push(MoveRecognizer);
    internalHandlers.hover = handlers.onHover;
    mergedConfig.hover = _extends({
      enabled: true
    }, hover);
    delete _nativeHandlers.onHover;
  }

  return useRecognizers(internalHandlers, classes, mergedConfig, _nativeHandlers);
}
/**
 * @private
 *
 * This utility function will integrate start and end handlers into the regular
 * handler function by using first and last conditions.
 *
 * @param {UserHandlersPartial} handlers - the handlers function object
 * @param {HandlerKey} handlerKey - the key for which to integrate start and end handlers
 * @returns
 */

function includeStartEndHandlers(handlers, handlerKey, _nativeHandlers) {
  var startKey = handlerKey + 'Start';
  var endKey = handlerKey + 'End';
  delete _nativeHandlers[handlerKey];
  delete _nativeHandlers[startKey];
  delete _nativeHandlers[endKey];

  var fn = function fn(state) {
    var memo = undefined;
    if (state.first && startKey in handlers) handlers[startKey](state);
    if (handlerKey in handlers) memo = handlers[handlerKey](state);
    if (state.last && endKey in handlers) handlers[endKey](state);
    return memo;
  };

  return fn;
}


//# sourceMappingURL=react-use-gesture.esm.js.map


/***/ }),

/***/ 12524:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 43090:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),

/***/ 7328:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

/***/ }),

/***/ 95922:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _toArray; }
/* harmony export */ });
/* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64034);
/* harmony import */ var _iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17602);
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57211);
/* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42330);




function _toArray(arr) {
  return (0,_arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr) || (0,_nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}

/***/ }),

/***/ 48847:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"id":"google-analytics","description":"Install a Google Analytics tag on your website","website":"https://analytics.google.com/analytics/web/","scripts":[{"url":"https://www.googletagmanager.com/gtag/js","params":["id"],"strategy":"worker","location":"head","action":"append"},{"code":"window.dataLayer=window.dataLayer||[];window.gtag=function gtag(){window.dataLayer.push(arguments);};gtag(\'js\',new Date());gtag(\'config\',\'${args.id}\')","strategy":"worker","location":"head","action":"append"}]}');

/***/ }),

/***/ 13240:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"id":"google-maps-embed","description":"Embed a Google Maps embed on your webpage","website":"https://developers.google.com/maps/documentation/embed/get-started","html":{"element":"iframe","attributes":{"loading":"lazy","src":{"url":"https://www.google.com/maps/embed/v1/place","slugParam":"mode","params":["key","q","center","zoom","maptype","language","region"]},"referrerpolicy":"no-referrer-when-downgrade","frameborder":"0","style":"border:0","allowfullscreen":true,"width":null,"height":null}}}');

/***/ }),

/***/ 51991:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"id":"youtube-embed","description":"Embed a YouTube embed on your webpage.","website":"https://github.com/paulirish/lite-youtube-embed","html":{"element":"lite-youtube","attributes":{"videoid":null,"playlabel":null}},"stylesheets":["https://cdn.jsdelivr.net/gh/paulirish/lite-youtube-embed@master/src/lite-yt-embed.css"],"scripts":[{"url":"https://cdn.jsdelivr.net/gh/paulirish/lite-youtube-embed@master/src/lite-yt-embed.js","strategy":"idle","location":"head","action":"append"}]}');

/***/ })

}]);